// @ts-strict-ignore
import Form, { FormInstance } from 'antd/lib/form';
import Modal from 'antd/lib/modal';
import * as React from 'react';
import {
    AllRollbackResigningStrategies,
    AllAppStoreArtifactUploadRules,
    AllAutoSubmitStrategies,
    AllDaysOfTheWeek,
    ReleaseNotesDataSource,
    AndroidAutoRolloutStartStrategy,
    AppIdentifierForIntegration,
    AppMonitoringHealthMetric,
    AppPlatform,
    SettingField,
    SettingFieldType,
    SettingOption,
    AppStoreArtifactUploadDestinationType,
    AppStoreArtifactUploadRule,
    AppStoreArtifactUploadWorkflowSettings,
    AppStoreType,
    ASCRole,
    PRCommentStrategy,
    Automation,
    AutomationAssignBetaBuildGroups,
    AutomationBAAssignBetaBuildGroups,
    AutomationAutoCreateReleaseChannels,
    AutomationAutoRelease,
    AutomationAutoStagedRollout,
    AutomationAutoSubmitRelease,
    AutomationAutoAddMissingFAs,
    AutomationAutoUploadBinaryArtifactToAppStore,
    AutomationAutoUploadDsymsToStabilityMonitoring,
    AutomationBAAutoTriggerBuildSystemWorkflow,
    AutomationCherryPickFromWorkingBranch,
    AutomationCreateIncidents,
    AutomationCreateIncidentsData,
    AutomationAutoTriggerCIWorkflow,
    AutoTriggerCIWorkflowData,
    TriggerCIWorkflowConditionGroup,
    UnhealthyMetricsTriggerConfig,
    AutomationHaltPromotePhasedReleaseData,
    AutomationHaltPromotePhasedReleaseConditionGroup,
    AutomationHaltUnstableRelease,
    AutomationPrepareRollbackRelease,
    AutomationPrepareRollbackReleaseData,
    AutomationPromoteStablePhasedRelease,
    AutomationReleaseTypeOverride,
    AutomationReleaseTypes,
    AutomationSyncAppStoreUsers,
    AutomationType,
    AutomationTypesWithSettings,
    AutoStagedRolloutBlackoutDay,
    AutoStagedRolloutBlackoutSegmentsByDay,
    AutoSubmitStrategy,
    AutoTriggerBuildDistroBuildData,
    AzureActiveDirectoryTeam,
    BAAutomationAutoUploadBinaryArtifactToAppStore,
    BaseCIIntegrationData,
    BaseStabilityMonitoringIntegrationData,
    BetaGroup,
    BuildNotesAutomationStrategy,
    betaBuildNotesStrategyUsesCIMatchedBuild,
    isAIBetaBuildNotesStrategy,
    BumpVersionAutomationStrategy,
    ChecklistItemTemplate,
    DsymUploadDestinationOption,
    DayOfTheWeek,
    disallowedTokensForForAndroidTrackReleaseName,
    DsymsUploadWorkflowSettings,
    FileStats,
    FirebaseBetaGroup,
    GoogleAppStoreSettings,
    GooglePlayConsolePermission,
    Integration,
    IntegrationCapability,
    IntegrationFirebaseBeta,
    IntegrationGoogleBeta,
    IntegrationInstallationId,
    IntegrationProvider,
    IntegrationProviderApple,
    IntegrationProviderAzureActiveDirectory,
    IntegrationProviderGoogle,
    IntegrationProviderIncidentIo,
    IntegrationProviderPagerDuty,
    IntegrationProviderType,
    IntegrationTestFlight,
    IntegrationType,
    MonitoringAutomationConditionType,
    NotificationTriggerConditionType,
    OrgUser,
    PatternToken,
    ReleaseStepType,
    ReleaseTypesForNonBlockingSteps,
    RequireAtLeastOneOfTokensForAndroidTrackReleaseName,
    RoleSyncData,
    RollbackResigningStrategy,
    SettingType,
    UserGroup,
    UserGroupId,
    WorkflowType,
    AutomationBAAutoUpdatePRWithArtifactLink,
    IncidentIoCreateIncidentsSettings,
    MicrosoftTeamsChannelLayoutType,
    MicrosoftTeamsChannelLayoutTypeDisplayNames,
    MicrosoftTeamsChannelMembershipType,
    MicrosoftTeamsChannelMembershipTypeDisplayNames,
    PagerDutyCreateIncidentsSettings,
} from '../../types';
import Icon, {
    ClockCircleOutlined,
    CopyOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import Divider from 'antd/lib/divider';
import TimePicker from 'antd/lib/time-picker';
import { Link, useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { useGetIssueTrackingLabelsQuery } from '@/middlewares/defaultApi';
import { useAutomationSettingFields } from '@/utils/hooks/useAutomationSettingFields';
import { UpdateAutomationSettingsRequest } from '../../actions/appSettings';
import {
    automationConditionsForAutomationType,
    capitalizeFirstLetter,
    decodeAutoStagedRolloutBlackoutSegmentsByDay,
    displayNameForCapability,
    displayTextForCapability,
    docsLinkForAutomationType,
    encodeAutoStagedRolloutBlackoutSegmentsByDay,
    getIsAppleAppStore,
    getIsApplePlatform,
    hasSupportForAutoRelease,
    hasSupportForPhasedRelease,
    isBucketAutomation,
    isGoogleBetaIntegration,
    isGooglePlatform,
    sanitizeTrackName,
    unitForMonitoringMetric,
    validatePattern,
    metricBelongsToStepInstallations,
} from '../../helpers';
import {
    availableAndroidAutoRolloutStartStrategiesForStoreType,
    displayConsoleNameForAppStoreType,
    displayTextForAndroidAutoRolloutStartStrategy,
    displayTextForAppStoreUploadRule,
    displayTextForAutomationConditionType,
    displayTextForAutoSubmitStrategy,
    displayTextForDayOfTheWeek,
    displayTextForResigningStrategy,
    displayTextForMonitoringMetric,
    fullDisplayTextForMonitoringMetric,
    displayTextForUserChecklistGroup,
    displayTextForUserGroup,
    helperTextForAutoSubmitStrategy,
    iconForCapability,
    identifierForAppPlatform,
    placeholderForFileTypePlatform,
    ROLE_TITLE_BY_ASCROLE,
    ROLE_TITLE_BY_GPLAY_PERMISSION,
    warningTextForAutoSubmitStrategy,
    displayTextForReleaseTypeGroup,
    LIFECYCLE_AUTOMATION_TIMING_MESSAGE,
    phasedReleaseDisplayTextForAppStoreType,
    automationDisplayNameForAutomationId,
} from '../../helpers/displayHelpers';
import {
    FieldType,
    filterOptionLabel,
    FormFieldData,
    renderFormField,
    renderFormFields,
    validateFileNameForAppStoreType,
} from '../../helpers/formHelpers';
import { RootState } from '../../reducers/reducers';
import {
    selectAllAppIdentifiers,
    selectAppIntegrations,
    selectFirstAutomationOfType,
    selectAppHasRequiredCapabilitiesAndIntegrationsForAutomation,
    selectAppPlatform,
    selectAppStoreArtifactWorkflowUploadDestinationOptions,
    selectAppStoreType,
    selectConnectedCapabilitiesForApp,
    selectDefaultReviewAttachmentFromAutomation,
    selectIntegrationWithCapabilityFromInstallations,
    selectIsAutoDownloadArtifactsEnabledForStep,
    selectIsPlayReleaseLifecycleEnabled,
    selectOrgGroups,
    selectProviderForIntegration,
    selectRegressionTestingIntegration,
    selectStabilityIntegrations,
    selectVCSSupportsDirectPushCheck,
    selectShouldDisableAutomation,
    selectStepConfigDataFromStepGraphs,
    selectWorkflowEnabledSteps,
} from '../../selectors/selectors';
import {
    AppComponentProps,
    AppRouteComponentMatchParams,
    AppStoreArtifactUploadDestinationTypeOption,
    AppStoreArtifactUploadWorkflowOption,
    DsymsUploadWorkflowOption,
    InputFieldDataWithValidation,
    MonitoringConditionOption,
    Nullable,
} from '../../typescriptHelpers';
import { globalMessage } from '../../utils/globalMessage';
import Alert from 'antd/lib/alert';
import Spin from 'antd/lib/spin';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import InputNumber from 'antd/lib/input-number';
import Popover from 'antd/lib/popover';
import Select from 'antd/lib/select';
import Typography from 'antd/lib/typography';
import { antGrey, colorWithAlpha, runwayColors, rwColors, titleStyle } from '../styles/globalStyles';
import { createAppSettingsRouteWithSettingType } from '../../helpers/routeHelpers';
import { getIntegrationTypeForInstallationId, iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { get, isNil, sortBy } from 'lodash';
import { formFieldsFromSettingFields } from '../../helpers/settingFieldHelpers';
import { PlanRestrictedFeatureWrapper } from '../planRestrictions/PlanRestrictedFeatureWrapper';
import { AutomationPlanExecutionBlockedAlert } from '../planRestrictions/planRestrictionHelperComponents';
import { PatternTokenHelperTextComponent } from '../appSettings/PatternTokenHelperTextComponent';
import Tooltip from 'antd/lib/tooltip';
import { DEFAULT_ROLLOUT_SEQUENCE } from '../../constants';
import {
    DEFAULT_MAX_DATA_AGE_MINUTES,
    isCustomObaaMetric,
    MAX_DATA_AGE_MINUTES_LIMIT,
    metricMaxDataAgeMinutesFromFormValue,
    validatePositiveMaxDataAgeMinutes,
} from './healthMetricStaleness';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import ConfigProvider from 'antd/lib/config-provider';
import Tabs from 'antd/lib/tabs';
import Tag from 'antd/lib/tag';
import { BetaBadge, UpdatedBadge } from './AppAutomationSettings';
import VCSDirectPushCheck from '../vcs/VCSDirectPushCheck';
import {
    ReleaseMilestone,
    VCSDirectPushBranchTarget,
    allReleaseMilestones,
    releaseMilestoneLabels,
} from '../../types/automation';
import PermissionedActionButton from '../HOCs/PermissionedActionButton';
import { RunwayUserAction } from '../../helpers/aclHelpers';
import AutomationConfigurationHelpBanner from './AutomationConfigurationHelpBanner';
import { DestinationOptionsSelector } from './DestinationOptionsSelector';
import { dayjs } from '@/extendedDayjs';
import PropTypes from 'prop-types';
import { AndroidStagedRolloutPercentageInput } from '../sharedComponents/shared';
import { ExtendedThresholdDescription, NUMERIC_BADGE_INDENT } from '../appSettings/MonitoringMetricFormFields';
import { mapThresholdToFormValue } from '@/components/appSettings/AddEditMonitoringMetricModal';
import DefaultReviewAttachmentUpload from '@/components/automations/DefaultReviewAttachmentUpload';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Switch from 'antd/lib/switch';
import { selectAppOrgUsers } from '@/selectors/memoizedSelectors';
import { useAppSettings } from '@/utils/hooks/helpers';
import { StepConfigSelector } from '@/components/common/StepConfigSelector';
import { StepGraphStep } from '@/types/workflow';
import { RelativeTimeTriggerSettings } from '../RelativeTimeTriggerSettings';
import { CompletedStepsTriggerSettings } from '../CompletedStepsTriggerSettings';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';
import { renamedMetricTooltip } from '../monitoring/monitoringHelpers';
import { DescriptionPopoverIcon } from '../common/DescriptionPopoverIcon';
import {
    AutomationSettingsContext,
    renderReleaseTypesForAutomation,
    isAppLevelAutomationConfig,
} from '@/helpers/automationHelpers';
import { AutoCreateTestRuns } from './AutoCreateTestRuns/AutoCreateTestRunsSettings';
import { BlockingStepsSelector } from '../BlockingStepsSelector';
import { Flex } from 'antd/lib';
import FormItem from 'antd/lib/form/FormItem';
import {
    conditionGroupsForTriggerCIWorkflow,
    TriggerCIWorkflowConditionGroups,
} from './TriggerCIWorkflowConditionGroups';

// Backend error message for missing default release settings
// Defined in: lib/runway/api_automation.go - appHasDefaultReleaseSettingsConfigured() and stepConfigHasDefaultReleaseSettingsConfigured()
const DEFAULT_RELEASE_SETTINGS_ERROR_MESSAGE = 'This automation requires default release settings be configured.';

const TRIGGER_CONDITION_GROUPS_FIELD_KEY = 'triggerConditionGroupsField';

// Evaluate visibility against the current release-type tab's namespaced values.
const applyVisibleWhen = (
    form: FormInstance,
    fields: FormFieldData[],
    unnamespacedFields: FormFieldData[],
    namespace?: string,
): FormFieldData[] =>
    fields.map((field) => {
        if (!field.visibleWhen) return field;
        const { field: controllingFieldName, equals } = field.visibleWhen;
        const controllingField = unnamespacedFields.find((f) => f.name === controllingFieldName);
        const value =
            form.getFieldValue(namespace ? [namespace, controllingFieldName] : controllingFieldName) ??
            controllingField?.initialValue;
        return { ...field, extraFormItemProps: { ...field.extraFormItemProps, hidden: value !== equals } };
    });

const namespaceFormFields = (fields: FormFieldData[], namespace: string): FormFieldData[] => {
    return fields.map((field) => {
        const namespacedField = { ...field };
        if (field.name) {
            const nameParts = Array.isArray(field.name) ? field.name : [field.name];
            namespacedField.name = [namespace, ...nameParts] as any;
        }
        if (field.fieldType === FieldType.WrappedGroup && field.groupedFields) {
            namespacedField.groupedFields = namespaceFormFields(field.groupedFields, namespace);
        }
        if (field.data?.formListName) {
            const formListName =
                Array.isArray(field.data.formListName) ? field.data.formListName : [field.data.formListName];
            namespacedField.data = {
                ...field.data,
                formListName: [namespace, ...formListName],
            };
        }
        if (field.dependencies) {
            namespacedField.dependencies = (field.dependencies as string[]).map((dep) => [namespace, dep] as any);
        }

        // Passing the namespace to custom fields so they can access the right values
        if (field.fieldType === FieldType.Custom && field.renderField) {
            const renderField = field.renderField;
            namespacedField.renderField = (data: unknown, ...extraData: unknown[]) =>
                renderField(data, ...extraData, namespace);
        }

        return namespacedField;
    });
};

const ALL_RELEASE_TYPE_GROUPS: ReleaseTypesForNonBlockingSteps[] = [
    ReleaseTypesForNonBlockingSteps.Standard,
    ReleaseTypesForNonBlockingSteps.Hotfix,
    ReleaseTypesForNonBlockingSteps.Rollback,
];

interface ReleaseTypeTab {
    id: string;
    releaseTypes: ReleaseTypesForNonBlockingSteps[];
    initialEnabled?: boolean;
    // True for the tab that holds the automation's default settings (the ones used by any
    // release type without its own override). Saved as top-level enabled/data, not under
    // configPerReleaseType. Exists only when at least one release type has no override.
    isPrimary?: boolean;
}

const isDisabledReleaseTypeOverride = (override: AutomationReleaseTypeOverride | undefined): boolean =>
    override?.enabled === false;

const withoutEnabledSwitch = (fields: FormFieldData[], namespace?: string): FormFieldData[] =>
    fields.filter((f) =>
        namespace ?
            !(Array.isArray(f.name) && f.name.length === 2 && f.name[0] === namespace && f.name[1] === 'enabled')
        :   f.name !== 'enabled',
    );

function trimCustomRequiredStepsForReleaseTypes(
    automationType: AutomationType,
    data: AutomationTypesWithSettings['data'] | undefined,
    releaseTypes: ReleaseTypesForNonBlockingSteps[],
): AutomationTypesWithSettings['data'] | undefined {
    if (!data) {
        return data;
    }

    if (automationType === AutomationType.AutoSubmitRelease) {
        const autoSubmitData = data as AutomationAutoSubmitRelease['data'];
        if (!autoSubmitData.shouldUseCustomRequiredSteps || !autoSubmitData.customRequiredSteps) {
            return data;
        }

        const customRequiredSteps = releaseTypes.reduce(
            (acc, releaseType) => {
                if (releaseType in autoSubmitData.customRequiredSteps) {
                    acc[releaseType] = autoSubmitData.customRequiredSteps[releaseType];
                }
                return acc;
            },
            {} as Partial<Record<ReleaseTypesForNonBlockingSteps, ReleaseStepType[]>>,
        );

        return {
            ...autoSubmitData,
            customRequiredSteps: customRequiredSteps as AutomationAutoSubmitRelease['data']['customRequiredSteps'],
        };
    }

    if (automationType === AutomationType.AutoRelease) {
        const autoReleaseData = data as AutomationAutoRelease['data'];
        if (!autoReleaseData.shouldUseCustomRequiredSteps || !autoReleaseData.customRequiredSteps) {
            return data;
        }

        const customRequiredSteps = releaseTypes.reduce(
            (acc, releaseType) => {
                if (releaseType in autoReleaseData.customRequiredSteps) {
                    acc[releaseType] = autoReleaseData.customRequiredSteps[releaseType];
                }
                return acc;
            },
            {} as Partial<Record<ReleaseTypesForNonBlockingSteps, ReleaseStepType[]>>,
        );

        return {
            ...autoReleaseData,
            customRequiredSteps: customRequiredSteps as AutomationAutoRelease['data']['customRequiredSteps'],
        };
    }

    return data;
}

// Override tabs add their own required steps fields, bound to the tab's release types
const PRIMARY_REQUIRED_STEPS_FIELD_KEYS = new Set([
    'primaryRequiredStepsToggleField',
    'primaryRequiredStepsConfigField',
    'shouldUseCustomRequiredSteps',
    'customRequiredSteps',
]);

interface AutomationSettingsProps extends AppComponentProps {
    open: boolean;
    automation: Automation;
    onClose: () => void;
    onAfterClose: () => void;
    isLoading: boolean;
    sameTypeAutomations: Automation[];
    onSubmit: (request: UpdateAutomationSettingsRequest) => void;
    onAutomationSelected: Nullable<(automationId: string) => void>;
    context?: AutomationSettingsContext;
}

type ArtifactUploadOptions = {
    appIdentifiers: Map<IntegrationInstallationId, AppIdentifierForIntegration>;
    destinationOptions: AppStoreArtifactUploadDestinationTypeOption[];
    buildSystem?: Integration;
};

type DsymsUploadOptions = {
    buildSystem?: Integration;
    /** Deprecated legacy field — kept for the empty-state path. The destination options on the
     *  automation entity (`automation.dsymUploadDestinationOptions`) are what drive the per-row
     *  selector. */
    stabilityMonitoring?: Integration;
};

export const AutomationSettings: React.FC<AutomationSettingsProps> = (props: AutomationSettingsProps) => {
    const { orgIdParam, appIdParam } = useParams<AppRouteComponentMatchParams>();
    const [form] = Form.useForm();
    const releaseNotesSourceFormValue = Form.useWatch('releaseNotesSource', form);

    const sameTypeAutomations = props.sameTypeAutomations;
    const appPlatform = useSelector((state: RootState) => selectAppPlatform(state, props.appId));
    const stepGraphStepsMap = useSelector((state: RootState) => selectStepConfigDataFromStepGraphs(state, props.appId));

    // Selectors
    const appSettings = useAppSettings({ appId: props.appId, orgId: props.orgId });
    const appStoreType = useSelector((state: RootState) => selectAppStoreType(state, props.appId));
    const automation = props.automation;
    const appLevelAutomationConfig = isAppLevelAutomationConfig(automation.type);
    const automationForFormFields = React.useMemo<Automation>(() => {
        const standardOverride = automation.configPerReleaseType?.[ReleaseTypesForNonBlockingSteps.Standard];
        if (!appLevelAutomationConfig || !standardOverride) {
            return automation;
        }

        return {
            ...automation,
            enabled: standardOverride.enabled ?? automation.enabled,
            data: standardOverride.data ?? automation.data,
            relativeTimeTrigger: standardOverride.relativeTimeTrigger ?? automation.relativeTimeTrigger,
            completedStepsTrigger: standardOverride.completedStepsTrigger ?? automation.completedStepsTrigger,
        };
    }, [automation, appLevelAutomationConfig]);

    const shouldDisableAutomation = useSelector((state: RootState) => {
        return selectShouldDisableAutomation(state, props.orgId, automation.type);
    });
    const autoDownloadArtifactsEnabled = useSelector((state: RootState) =>
        selectIsAutoDownloadArtifactsEnabledForStep(state, props.appId, automation.stepConfigId),
    );

    const isPlayReleaseLifecycleEnabled = useSelector((state: RootState) =>
        selectIsPlayReleaseLifecycleEnabled(state, props.orgId),
    );

    const appStoreIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.AppStore,
            automation.integrationInstallationIds,
        ),
    );
    const connectedCapabilities = useSelector((state: RootState) =>
        selectConnectedCapabilitiesForApp(state, props.appId),
    );
    const stabilityIntegrations = useSelector((state: RootState) => selectStabilityIntegrations(state, props.appId));
    const destinationOptions = useSelector((state: RootState) =>
        selectAppStoreArtifactWorkflowUploadDestinationOptions(state, props.appId, automation.id),
    );
    const buildSystem = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.BuildSystem,
            automation.integrationInstallationIds,
        ),
    );
    const connectedBuildSystemIntegrations = useSelector((state: RootState) =>
        selectAppIntegrations(state, props.appId).filter((integration) =>
            integration.capabilities.includes(IntegrationCapability.BuildSystem),
        ),
    );
    const triggerBuildAutomation = useSelector(
        (state: RootState) =>
            selectFirstAutomationOfType(state, props.appId, AutomationType.AutoTriggerCIWorkflow) ??
            selectFirstAutomationOfType(state, props.appId, AutomationType.AutoKickoffTriggerWorkflow),
    );
    const unsupportedBuildTriggerIntegration = connectedBuildSystemIntegrations.find((integration) =>
        (triggerBuildAutomation?.unsupportedIntegrations ?? []).includes(integration.id),
    );
    const rebuildByCIUnavailableReason =
        unsupportedBuildTriggerIntegration ?
            `${unsupportedBuildTriggerIntegration.name} does not support triggering builds from Runway.`
        :   null;
    const appIdentifiers = useSelector((state: RootState) => selectAllAppIdentifiers(state, props.appId));
    const stabilityMonitoring = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.StabilityMonitoring,
            automation.integrationInstallationIds,
        ),
    );

    const appUsers = useSelector((state: RootState) => selectAppOrgUsers(state, props.appId));
    const orgUserGroups = useSelector((state: RootState) => selectOrgGroups(state, props.orgId));

    const isBucketAutomationType = isBucketAutomation(automation.type);

    let [appHasRequiredServices, servicesErrorMessage] = useSelector(
        (state: RootState) =>
            selectAppHasRequiredCapabilitiesAndIntegrationsForAutomation(
                state,
                props.appId,
                automation.unsupportedIntegrations,
                automation.requiredCapabilities,
                automation.integrationInstallationIds,
                isBucketAutomationType,
            ),
        shallowEqual,
    );

    const betaTesting = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.BetaTesting,
            automation.integrationInstallationIds,
        ),
    );
    const betaTestingProvider = useSelector((state: RootState) =>
        selectProviderForIntegration(state, props.orgId, betaTesting),
    );
    const notificationsIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.Notifications,
            automation.integrationInstallationIds,
        ),
    );
    const notificationsProvider = useSelector((state: RootState) =>
        selectProviderForIntegration(state, props.orgId, notificationsIntegration),
    );

    const schedulingIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.Scheduling,
            automation.integrationInstallationIds,
        ),
    );
    const schedulingProvider = useSelector((state: RootState) =>
        selectProviderForIntegration(state, props.orgId, schedulingIntegration),
    );

    // State
    const triggerWorkflowOptionInitialState =
        automation.type === AutomationType.BAAutoTriggerBuildSystemWorkflow ?
            (automation.data as AutoTriggerBuildDistroBuildData)?.timedTriggerEveryNHours !== null ?
                TriggerWorkflowOption.TriggerEveryNHours
            :   TriggerWorkflowOption.SmartMode
        :   null;

    // for BAAutoTriggerWorkflow
    const [triggerWorkflowOption, setTriggerWorkflowOption] = React.useState(triggerWorkflowOptionInitialState);

    const vcsSupportsDirectPushCheck = useSelector(selectVCSSupportsDirectPushCheck(props.appId, props.orgId));

    const autoSubmitStragyInitialState =
        automation.type === AutomationType.AutoSubmitRelease ?
            ((automation as AutomationAutoSubmitRelease).data?.submitStrategy ?? AutoSubmitStrategy.OnceStepsComplete)
        :   AutoSubmitStrategy.OnceStepsComplete;
    const [autoSubmitStrategy, setAutoSubmitStrategy] = React.useState(autoSubmitStragyInitialState);

    const resigningStrategyInitialState =
        automation.type === AutomationType.AutoPrepareRollbackRelease ?
            ((automation as AutomationPrepareRollbackRelease).data?.strategy ?? RollbackResigningStrategy.LocalResign)
        :   RollbackResigningStrategy.LocalResign;
    const [resigningStrategy, setResigningStrategy] = React.useState(resigningStrategyInitialState);

    const workflowEnabledSteps = useSelector((state: RootState) => selectWorkflowEnabledSteps(state, props.appId));
    const isWorkflowsCIStepEnabled = !!workflowEnabledSteps[ReleaseStepType.ReleaseCandidate];
    const isWorkflowsSubmissionStepEnabled = !!workflowEnabledSteps[ReleaseStepType.Submission];
    const isWorkflowsTakeoffStepEnabled = !!workflowEnabledSteps[ReleaseStepType.Takeoff];
    const isWorkflowsRolloutStepEnabled = !!workflowEnabledSteps[ReleaseStepType.Rollout];

    const selectedAutomation = sameTypeAutomations.find((auto) => auto.id === automation.id);
    const [selectedStepConfigId, setSelectedStepConfigId] = React.useState(selectedAutomation?.stepConfigId);

    const initializeTabs = React.useCallback(
        (configPerReleaseType: Automation['configPerReleaseType']): ReleaseTypeTab[] => {
            if (appLevelAutomationConfig) {
                const standardOverride = configPerReleaseType?.[ReleaseTypesForNonBlockingSteps.Standard];
                return [
                    {
                        id: 'tab-0',
                        releaseTypes: [ReleaseTypesForNonBlockingSteps.Standard],
                        initialEnabled: standardOverride?.enabled ?? automationForFormFields.enabled,
                    },
                ];
            }

            const allOverrideKeys = Object.keys(configPerReleaseType ?? {}) as ReleaseTypesForNonBlockingSteps[];
            const overrideKeys = allOverrideKeys.filter(
                (t) => !isDisabledReleaseTypeOverride(configPerReleaseType![t]),
            );
            const primaryTypes =
                automation.enabled ? ALL_RELEASE_TYPE_GROUPS.filter((t) => !allOverrideKeys.includes(t)) : [];
            if (overrideKeys.length === 0) {
                return [{ id: 'tab-0', releaseTypes: primaryTypes, isPrimary: true }];
            }
            // Group overrides with identical configs onto one tab, in canonical order.
            const canonicalIndex = (t: ReleaseTypesForNonBlockingSteps) => ALL_RELEASE_TYPE_GROUPS.indexOf(t);
            const orderedOverrideKeys = [...overrideKeys].sort((a, b) => canonicalIndex(a) - canonicalIndex(b));
            // Drop disabled trigger fields before fingerprinting so configs that differ only in
            // leftover disabled triggers still group together.
            const fingerprintConfig = (c: AutomationReleaseTypeOverride) => {
                return JSON.stringify({
                    enabled: c.enabled,
                    data: c.data,
                    relativeTimeTrigger: c.relativeTimeTrigger?.enabled ? c.relativeTimeTrigger : undefined,
                    completedStepsTrigger: c.completedStepsTrigger?.enabled ? c.completedStepsTrigger : undefined,
                });
            };
            const groups = new Map<string, ReleaseTypesForNonBlockingSteps[]>();
            for (const key of orderedOverrideKeys) {
                const fingerprint = fingerprintConfig(configPerReleaseType![key]);
                if (!groups.has(fingerprint)) {
                    groups.set(fingerprint, []);
                }
                groups.get(fingerprint)!.push(key);
            }
            const overrideGroups = Array.from(groups.values()).sort(
                (a, b) => canonicalIndex(a[0]) - canonicalIndex(b[0]),
            );
            const allTabs: ReleaseTypeTab[] = [];
            if (primaryTypes.length > 0) {
                allTabs.push({ id: 'tab-0', releaseTypes: primaryTypes, isPrimary: true });
            }
            for (const types of overrideGroups) {
                allTabs.push({ id: `tab-${allTabs.length}`, releaseTypes: types });
            }
            return allTabs;
        },
        [appLevelAutomationConfig, automationForFormFields.enabled, automation.enabled],
    );

    const [tabs, setTabs] = React.useState<ReleaseTypeTab[]>(() => initializeTabs(automation.configPerReleaseType));
    const [activeTab, setActiveTab] = React.useState<string>('tab-0');
    const [nextTabId, setNextTabId] = React.useState(() => initializeTabs(automation.configPerReleaseType).length);
    // Save the config as text so the same values stay the same after an app settings refresh.
    const configPerReleaseTypeSnapshot = JSON.stringify(automation.configPerReleaseType ?? {});

    // Reset the tabs when the modal opens or the saved config changes.
    React.useEffect(() => {
        if (!props.open) return;

        const configPerReleaseType = JSON.parse(configPerReleaseTypeSnapshot) as Automation['configPerReleaseType'];
        const newTabs = initializeTabs(configPerReleaseType);
        setTabs(newTabs);
        setNextTabId(newTabs.length);
        setActiveTab((currentActiveTab) => {
            if (newTabs.some((tab) => tab.id === currentActiveTab)) {
                return currentActiveTab;
            }
            return newTabs[0]?.id ?? 'tab-0';
        });
    }, [automation.id, props.open, configPerReleaseTypeSnapshot, initializeTabs]);

    const getOverrideConfigForTab = (tab: ReleaseTypeTab) => {
        if (appLevelAutomationConfig) {
            return automation.configPerReleaseType?.[ReleaseTypesForNonBlockingSteps.Standard];
        }
        if (tab.releaseTypes.length === 0) return undefined;
        return automation.configPerReleaseType?.[tab.releaseTypes[0]];
    };

    const [tabTriggerState, setTabTriggerState] = React.useState<
        Record<string, { relativeTimeTrigger: boolean; completedStepsTrigger: boolean }>
    >(() => {
        const state: Record<string, { relativeTimeTrigger: boolean; completedStepsTrigger: boolean }> = {};
        const initialTabs = initializeTabs(automation.configPerReleaseType);
        for (const tab of initialTabs) {
            const cfg = getOverrideConfigForTab(tab);
            if (!cfg) continue;
            state[tab.id] = {
                relativeTimeTrigger: cfg?.relativeTimeTrigger?.enabled ?? false,
                completedStepsTrigger: cfg?.completedStepsTrigger?.enabled ?? false,
            };
        }
        return state;
    });

    const onSubmit = (form) => {
        if (shouldDisableAutomation) {
            return;
        }

        const tabIdsWithoutReleaseTypes = new Set(
            tabs.filter((tab) => tab.releaseTypes.length === 0).map((tab) => tab.id),
        );
        const firstTabHasNoReleaseTypes = !!tabs[0] && tabIdsWithoutReleaseTypes.has(tabs[0].id);
        // Like the backend, a disabled automation skips its BE-defined fields' rules, so it can always be turned off
        const isEnabled = form.getFieldValue('enabled');
        const settingFieldKeys = new Set(automationSettingFields?.map((settingField) => settingField.key));
        const namesToValidate = form
            .getFieldsError()
            .map(({ name }) => name)
            .filter((name) => isEnabled || !settingFieldKeys.has(name[name.length - 1]))
            .filter((name) => {
                const rootName = name[0];
                if (tabs.some((tab) => tab.id === rootName)) {
                    return !tabIdsWithoutReleaseTypes.has(rootName);
                }
                return !firstTabHasNoReleaseTypes;
            });

        form.validateFields(namesToValidate)
            .then(() => form.getFieldsValue())
            .then((values) => {
                const data = automationUpdateRequestDataFromValues(
                    automationForFormFields as AutomationTypesWithSettings,
                    values,
                    appSettings.monitoringSettings.metrics,
                    (!appLevelAutomationConfig && !tabs[0]?.isPrimary ?
                        getOverrideConfigForTab(tabs[0])?.data
                    :   undefined) as AutomationTypesWithSettings['data'] | undefined,
                );

                if (!data) {
                    throw Error('Something went wrong, please try again');
                }

                if (appLevelAutomationConfig) {
                    const request: UpdateAutomationSettingsRequest = {
                        orgId: props.orgId,
                        appId: props.appId,
                        automationId: automation.id,
                        enabled: values.enabled,
                        data: data,
                        configPerReleaseType: undefined,
                        relativeTimeTrigger: values.relativeTimeTrigger,
                        completedStepsTrigger: values.completedStepsTrigger,
                        automationReleaseTypes: AutomationReleaseTypes.All,
                    };

                    props.onSubmit(request);
                    return;
                }

                let configPerReleaseType: UpdateAutomationSettingsRequest['configPerReleaseType'];
                // Skip the primary tab here — it's saved as the automation's main settings,
                // not as a per-release-type override.
                const tabsForSave = tabs
                    .map((tab, index) => ({ tab, index }))
                    .filter(({ tab }) => tab.releaseTypes.length > 0 && !tab.isPrimary);

                if (tabsForSave.length > 0) {
                    configPerReleaseType = {};
                    const groupedOverrides = new Map<
                        string,
                        {
                            releaseTypes: ReleaseTypesForNonBlockingSteps[];
                            config: {
                                enabled: boolean;
                                data?: AutomationTypesWithSettings['data'];
                                relativeTimeTrigger: any;
                                completedStepsTrigger: any;
                            };
                        }
                    >();

                    for (const { tab, index } of tabsForSave) {
                        // Tab values are namespaced for non-primary tabs; first tab can be top-level.
                        const tabValues = values[tab.id] ?? (index === 0 ? values : undefined);

                        let normalizedOverride:
                            | {
                                  enabled: boolean;
                                  data?: AutomationTypesWithSettings['data'];
                                  relativeTimeTrigger: any;
                                  completedStepsTrigger: any;
                              }
                            | undefined;

                        if (!tabValues) {
                            // Tab was never visited (antd lazy rendering) — preserve existing overrides unchanged
                            const existingOverride = tab.releaseTypes
                                .map((rt) => automation.configPerReleaseType?.[rt])
                                .find((override) => !!override);
                            if (!existingOverride) {
                                continue;
                            }
                            normalizedOverride = {
                                enabled: true,
                                data: trimCustomRequiredStepsForReleaseTypes(
                                    automation.type,
                                    existingOverride.data as AutomationTypesWithSettings['data'],
                                    tab.releaseTypes,
                                ),
                                relativeTimeTrigger: existingOverride.relativeTimeTrigger,
                                completedStepsTrigger: existingOverride.completedStepsTrigger,
                            };
                        } else {
                            const tabData = automationUpdateRequestDataFromValues(
                                automationForFormFields as AutomationTypesWithSettings,
                                tabValues,
                                appSettings.monitoringSettings.metrics,
                                getOverrideConfigForTab(tab)?.data as AutomationTypesWithSettings['data'],
                            );
                            if (!tabData) {
                                throw Error('Something went wrong, please try again');
                            }
                            normalizedOverride = {
                                enabled: true,
                                data: trimCustomRequiredStepsForReleaseTypes(
                                    automation.type,
                                    tabData,
                                    tab.releaseTypes,
                                ),
                                relativeTimeTrigger: tabValues.relativeTimeTrigger,
                                completedStepsTrigger: tabValues.completedStepsTrigger,
                            };
                        }

                        const fingerprint = JSON.stringify(normalizedOverride);
                        const existingGroup = groupedOverrides.get(fingerprint);
                        if (existingGroup) {
                            existingGroup.releaseTypes = Array.from(
                                new Set([...existingGroup.releaseTypes, ...tab.releaseTypes]),
                            );
                            continue;
                        }

                        groupedOverrides.set(fingerprint, {
                            releaseTypes: [...tab.releaseTypes],
                            config: normalizedOverride,
                        });
                    }

                    for (const groupedOverride of groupedOverrides.values()) {
                        for (const rt of groupedOverride.releaseTypes) {
                            configPerReleaseType[rt] = groupedOverride.config;
                        }
                    }
                }

                const assignedReleaseTypes = new Set(
                    tabs.reduce<ReleaseTypesForNonBlockingSteps[]>((acc, tab) => acc.concat(tab.releaseTypes), []),
                );
                for (const rt of ALL_RELEASE_TYPE_GROUPS) {
                    if (!assignedReleaseTypes.has(rt)) {
                        configPerReleaseType = {
                            ...configPerReleaseType,
                            [rt]: { ...automation.configPerReleaseType?.[rt], enabled: false },
                        };
                    }
                }
                if (configPerReleaseType && Object.keys(configPerReleaseType).length === 0) {
                    configPerReleaseType = undefined;
                }

                // `values` reflects the first tab, which is the top-level config only when a
                // primary tab exists. With no primary tab, derive top-level state from the
                // overrides so it doesn't flip when tabs get re-sorted on the next render.
                const hasPrimaryTab = tabs[0]?.isPrimary === true;
                const anyOverrideEnabled = Object.values(configPerReleaseType ?? {}).some(
                    (override) => override.enabled,
                );

                const request: UpdateAutomationSettingsRequest = {
                    orgId: props.orgId,
                    appId: props.appId,
                    automationId: automation.id,
                    enabled: hasPrimaryTab ? tabs[0].releaseTypes.length > 0 : anyOverrideEnabled,
                    data: data,
                    configPerReleaseType,
                    relativeTimeTrigger: hasPrimaryTab ? values.relativeTimeTrigger : automation.relativeTimeTrigger,
                    completedStepsTrigger:
                        hasPrimaryTab ? values.completedStepsTrigger : automation.completedStepsTrigger,
                    automationReleaseTypes: AutomationReleaseTypes.All,
                };

                if (!appHasRequiredServices && (request.enabled || anyOverrideEnabled)) {
                    throw Error(`${servicesErrorMessage}.`);
                }

                props.onSubmit(request);
            })
            .catch((error) => {
                if (error?.errorFields) {
                    return;
                }
                globalMessage.error(error.message);
            });
    };

    let artifactUploadOptions: ArtifactUploadOptions;
    if (
        automation.type == AutomationType.AutoUploadBinaryArtifactToAppStore ||
        automation.type == AutomationType.BAAutoUploadBinaryArtifactToAppStore
    ) {
        artifactUploadOptions = {
            appIdentifiers: appIdentifiers,
            destinationOptions: destinationOptions,
            buildSystem: buildSystem,
        };
    }

    let dsymsUploadOptions: DsymsUploadOptions;
    if (automation.type == AutomationType.AutoUploadDsymsToStabilityMonitoring) {
        dsymsUploadOptions = {
            buildSystem: buildSystem,
            stabilityMonitoring: stabilityMonitoring,
        };
    }

    const regressionTesting = useSelector((state: RootState) => selectRegressionTestingIntegration(state, props.appId));

    servicesErrorMessage = servicesErrorMessage || automation.automationRequirementsErrorMessage;

    const appSettingsRoute = createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.General);
    const appStoreDefaultsRoute = createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.AppStore);

    const renderErrorMessage = (errorMessage: string) => {
        if (errorMessage === DEFAULT_RELEASE_SETTINGS_ERROR_MESSAGE) {
            return (
                <Text style={{ color: runwayColors.statusRed, marginTop: -16 }}>
                    This automation requires{' '}
                    <Link
                        to={appStoreDefaultsRoute}
                        style={{ color: runwayColors.primary, textDecoration: 'underline' }}
                    >
                        default release settings
                    </Link>{' '}
                    be configured.
                </Text>
            );
        }
        return <Text style={{ color: runwayColors.statusRed, marginTop: -16 }}>{errorMessage}</Text>;
    };

    const baseFieldHelpMessage = defaultHelpMessage(automation.type);

    // display required capabilities in a bulleted list if we are displaying both required and also A OR B capability requirements
    const capabilitiesShouldBeBulleted =
        automation.requiredCapabilities &&
        automation.requiredCapabilities.length > 1 &&
        automation.requiredCapabilities.some((capabilityArray) => capabilityArray.length > 1);

    const isApplyLabelsToFixTicketsAutomation = automation.type === AutomationType.AutoApplyLabelsToFixTickets;
    const { data: issueTrackingLabelsResponse } = useGetIssueTrackingLabelsQuery(
        { orgId: props.orgId, appId: props.appId },
        { skip: !props.open || !isApplyLabelsToFixTicketsAutomation, refetchOnMountOrArgChange: false },
    );
    const availableIssueTrackingLabels = issueTrackingLabelsResponse?.data?.labels ?? [];

    const { settingFieldsByAutomationId, isSettingFieldsError } = useAutomationSettingFields(props.orgId, props.appId);

    // All CLI templates available to be selected
    const checklistItems = appSettings.stepChecklistItems;
    const monitoringChecklistItemTemplates = checklistItems.filter(
        (cli) =>
            cli.releaseStepType === ReleaseStepType.Rollout ||
            (cli.stepConfigId && cli.stepConfigId === selectedStepConfigId),
    );

    const automationPlatform = automation.platform || appPlatform;
    const automationAppStoreType = automation.appStoreType || appStoreType;

    // For scheduled automations
    const [isRelativeTimeTriggerEnabled, setIsRelativeTimeTriggerEnabled] = React.useState(
        automation.relativeTimeTrigger.enabled,
    );
    const [isCompletedStepsTriggerEnabled, setIsCompletedStepsTriggerEnabled] = React.useState(
        automation.completedStepsTrigger.enabled,
    );

    const triggerConditionFormFields = (): FormFieldData[] => {
        const hasAnySupportedTrigger =
            automation.hasSupportForRelativeTimeTrigger || automation.hasSupportForCompletedStepsTrigger;

        const conditionGroupsUIEnabled =
            !!appSettings?.useTriggerCIWorkflowConditionGroups &&
            automation.type === AutomationType.AutoTriggerCIWorkflow;
        if (!hasAnySupportedTrigger || !automation.stepConfigId || conditionGroupsUIEnabled) {
            return [];
        }

        const fields: FormFieldData[] = [
            {
                label: (
                    <div>
                        <Divider style={{ marginTop: '10px', marginBottom: '10px', width: '664px' }} />
                    </div>
                ),
                fieldType: FieldType.Custom,
                name: 'automationTriggerConditions',
                renderField: () => (
                    <div
                        style={{
                            fontWeight: 600,
                            fontSize: 14,
                            marginBottom: 0,
                            marginTop: 0,
                            display: 'block',
                            color: runwayColors.black,
                        }}
                    >
                        Trigger conditions
                    </div>
                ),
                extraFormItemProps: { style: { marginBottom: 10 } },
            },
            ...(automation.hasSupportForRelativeTimeTrigger ?
                [
                    {
                        data: (
                            <div>
                                Eligible to run no earlier than...
                                <Tooltip title="Runway will trigger the automation at the specified target time.">
                                    <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                                </Tooltip>
                            </div>
                        ),
                        name: ['relativeTimeTrigger', 'enabled'],
                        initialValue: isRelativeTimeTriggerEnabled,
                        fieldType: FieldType.Checkbox,
                        onChange: (e) => {
                            setIsRelativeTimeTriggerEnabled(e.target.checked);
                        },
                        extraFormItemProps: {
                            style: { marginBottom: 10 },
                        },
                    },
                ]
            :   []),
        ];

        if (automation.hasSupportForRelativeTimeTrigger && isRelativeTimeTriggerEnabled) {
            fields.push({
                label: '',
                name: 'relativeTimeTrigger',
                fieldType: FieldType.Custom,
                rules: [],
                renderField: () => (
                    <RelativeTimeTriggerSettings
                        orgId={props.orgId}
                        appId={props.appId}
                        stepConfigId={automation.stepConfigId}
                        initialValues={automation.relativeTimeTrigger}
                        isOrgLevelItem={false}
                        showAllowTriggeringBasedOnTargetDate
                    />
                ),
                extraFormItemProps: {
                    style: { marginBottom: 10 },
                },
            });
        }

        if (automation.hasSupportForCompletedStepsTrigger) {
            fields.push({
                label: '',
                data: (
                    <div>
                        Require previous release steps to be complete (green)
                        <Tooltip
                            title={
                                <span>
                                    Only blocking steps can be included as trigger conditions. Go to{' '}
                                    <Link to={appSettingsRoute} style={{ color: 'white', textDecoration: 'underline' }}>
                                        App settings
                                    </Link>{' '}
                                    to configure blocking and non-blocking steps.
                                </span>
                            }
                        >
                            <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                        </Tooltip>
                    </div>
                ),
                name: ['completedStepsTrigger', 'enabled'],
                initialValue: isCompletedStepsTriggerEnabled,
                fieldType: FieldType.Checkbox,
                onChange: (e) => {
                    setIsCompletedStepsTriggerEnabled(e.target.checked);
                },
                extraFormItemProps: {
                    style: { marginBottom: 10 },
                },
            });
        }

        if (automation.hasSupportForCompletedStepsTrigger && isCompletedStepsTriggerEnabled) {
            fields.push({
                label: '',
                name: 'completedStepsTrigger',
                fieldType: FieldType.Custom,
                initialValue: automation.completedStepsTrigger,
                rules: [],
                renderField: () => (
                    <CompletedStepsTriggerSettings
                        orgId={props.orgId}
                        appId={props.appId}
                        platform={automationPlatform}
                        appStoreType={automationAppStoreType}
                        stepGraphStepsMap={stepGraphStepsMap}
                    />
                ),
                extraFormItemProps: {
                    style: { marginBottom: 0 },
                },
            });
        }

        return fields;
    };

    const monitoringMetricsForAutomationStep = appSettings.monitoringSettings.metrics.filter((metric) =>
        metricBelongsToStepInstallations(
            metric,
            stepGraphStepsMap[automation.stepConfigId]?.integrationInstallationIds,
        ),
    );

    const automationSettingFields = settingFieldsByAutomationId?.[automationForFormFields.id];
    var formFields = automationSettingFormFieldsForAutomation(
        props.appId,
        props.orgId,
        orgIdParam,
        appIdParam,
        automationForFormFields,
        automationPlatform,
        automationAppStoreType,
        appHasRequiredServices,
        shouldDisableAutomation,
        connectedCapabilities,
        vcsSupportsDirectPushCheck,
        baseFieldHelpMessage,
        monitoringMetricsForAutomationStep,
        artifactUploadOptions,
        dsymsUploadOptions,
        notificationsProvider,
        regressionTesting,
        triggerWorkflowOption,
        setTriggerWorkflowOption,
        betaTesting,
        betaTestingProvider,
        monitoringChecklistItemTemplates,
        orgUserGroups,
        appUsers,
        autoSubmitStrategy,
        setAutoSubmitStrategy,
        schedulingIntegration,
        schedulingProvider,
        form,
        isPlayReleaseLifecycleEnabled,
        stabilityIntegrations,
        !!appStoreIntegration,
        availableIssueTrackingLabels,
        appSettings?.useTriggerCIWorkflowConditionGroups,
        stepGraphStepsMap,
        automationSettingFields,
        resigningStrategy,
        setResigningStrategy,
        rebuildByCIUnavailableReason,
        !!isWorkflowsRolloutStepEnabled,
    );

    formFields = [...formFields, ...triggerConditionFormFields()];
    const primaryFormFields = formFields.filter((f) => f.name !== 'automationReleaseTypes');

    const formInitialValues: Record<string, any> = {};
    primaryFormFields.forEach((field) => {
        if (field.fieldType === FieldType.WrappedGroup) {
            field.groupedFields?.forEach((gf) => {
                formInitialValues[gf.name as string] = gf.initialValue ?? null;
            });
        } else if (field.name) {
            formInitialValues[field.name as string] = field.initialValue ?? null;
        }
    });

    const triggerFieldNames = new Set(['automationTriggerConditions', 'relativeTimeTrigger', 'completedStepsTrigger']);
    const isTriggerField = (name: FormFieldData['name']): boolean => {
        if (!name) return false;
        const rootName = Array.isArray(name) ? name[0] : name;
        return triggerFieldNames.has(rootName as string);
    };

    const automationSpecificFields = primaryFormFields.filter(
        (f) =>
            f.name !== 'enabled' && !isTriggerField(f.name) && !PRIMARY_REQUIRED_STEPS_FIELD_KEYS.has(f.name as string),
    );
    const primaryHasTriggerFields = primaryFormFields.some((f) => isTriggerField(f.name));

    const buildOverrideFieldsForTab = (tab: ReleaseTypeTab, namespace?: string): FormFieldData[] => {
        const overrideCfg = getOverrideConfigForTab(tab);
        const dataObj = (overrideCfg?.data ?? automationForFormFields.data ?? {}) as Record<string, any>;

        const withOverrideInitialValue = (field: FormFieldData): FormFieldData => {
            if (field.fieldType === FieldType.WrappedGroup && field.groupedFields) {
                return { ...field, groupedFields: field.groupedFields.map(withOverrideInitialValue) };
            }

            if (field.name === TRIGGER_CONDITION_GROUPS_FIELD_KEY) {
                return {
                    ...field,
                    data: {
                        ...(field.data as object),
                        initialValue: conditionGroupsForTriggerCIWorkflow(
                            dataObj.conditionGroups,
                            overrideCfg?.relativeTimeTrigger ?? automation.relativeTimeTrigger,
                            overrideCfg?.completedStepsTrigger ?? automation.completedStepsTrigger,
                        ),
                    },
                };
            }

            if (!field.name || Array.isArray(field.name)) return field;
            const val = dataObj[field.name as string];
            if (val === null || val === undefined || val === '') return field;

            // autoStagedRolloutCustomHour is persisted as a number (the hour) but
            // the form's TimePicker requires a Dayjs object.
            if (field.name === 'autoStagedRolloutCustomHour' && typeof val === 'number') {
                const tz = (dataObj.autoStagedRolloutBlackoutTimezone as string)?.trim() || dayjs.tz.guess();
                return {
                    ...field,
                    initialValue: dayjs()
                        .tz(tz)
                        .set('hour', val)
                        .set('minute', 0)
                        .set('second', 0)
                        .set('millisecond', 0),
                };
            }

            if (field.name === 'autoStagedRolloutBlackoutSegmentsByDay') {
                return {
                    ...field,
                    initialValue: decodeAutoStagedRolloutBlackoutSegmentsByDay(
                        val as AutoStagedRolloutBlackoutSegmentsByDay,
                    ),
                };
            }

            return { ...field, initialValue: val };
        };

        const rawSpecificFields: FormFieldData[] = automationSpecificFields.map(withOverrideInitialValue);
        const specificFields = applyVisibleWhen(
            form,
            namespace ? namespaceFormFields(rawSpecificFields, namespace) : rawSpecificFields,
            rawSpecificFields,
            namespace,
        );
        const enabledFieldName = namespace ? [namespace, 'enabled'] : 'enabled';
        const relativeTimeTriggerEnabledFieldName =
            namespace ? [namespace, 'relativeTimeTrigger', 'enabled'] : ['relativeTimeTrigger', 'enabled'];
        const relativeTimeTriggerFieldName = namespace ? [namespace, 'relativeTimeTrigger'] : 'relativeTimeTrigger';
        const completedStepsTriggerEnabledFieldName =
            namespace ? [namespace, 'completedStepsTrigger', 'enabled'] : ['completedStepsTrigger', 'enabled'];
        const completedStepsTriggerFieldName =
            namespace ? [namespace, 'completedStepsTrigger'] : 'completedStepsTrigger';
        const selectedReleaseTypesFieldName = namespace ? [namespace, 'selectedReleaseTypes'] : 'selectedReleaseTypes';
        const initialEnabled = tab.initialEnabled !== undefined ? tab.initialEnabled : (overrideCfg?.enabled ?? true);

        const fields: FormFieldData[] = [
            {
                name: namespace ? `${namespace}SelectedReleaseTypesField` : 'selectedReleaseTypesField',
                fieldType: FieldType.Custom,
                skipFormItemWrapper: true,
                renderField: () => (
                    <FormItem hidden name={selectedReleaseTypesFieldName} initialValue={tab.releaseTypes}>
                        <Input />
                    </FormItem>
                ),
            },
            {
                label: 'Enabled',
                name: enabledFieldName,
                initialValue: initialEnabled,
                fieldType: FieldType.Switch,
                disabled: !appHasRequiredServices && !initialEnabled,
            },
            ...specificFields,
        ];

        if (primaryHasTriggerFields) {
            const trigState = tabTriggerState[tab.id] ?? { relativeTimeTrigger: false, completedStepsTrigger: false };

            fields.push(
                {
                    label: '',
                    fieldType: FieldType.Custom,
                    name: 'overrideTriggerConditionsHeader',
                    renderField: () => (
                        <div
                            style={{
                                fontWeight: 600,
                                fontSize: 14,
                                marginBottom: 0,
                                marginTop: 0,
                                display: 'block',
                                color: runwayColors.black,
                            }}
                        >
                            Trigger conditions
                        </div>
                    ),
                    extraFormItemProps: { style: { marginBottom: 10 } },
                },
                {
                    data: (
                        <div>
                            Eligible to run no earlier than...
                            <Tooltip title="Runway will trigger the automation at the specified target time.">
                                <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                            </Tooltip>
                        </div>
                    ),
                    name: relativeTimeTriggerEnabledFieldName,
                    initialValue: trigState.relativeTimeTrigger,
                    fieldType: FieldType.Checkbox,
                    onChange: (e) =>
                        setTabTriggerState((prev) => ({
                            ...prev,
                            [tab.id]: {
                                ...(prev[tab.id] ?? { relativeTimeTrigger: false, completedStepsTrigger: false }),
                                relativeTimeTrigger: e.target.checked,
                            },
                        })),
                    extraFormItemProps: { style: { marginBottom: 10 } },
                },
            );

            if (trigState.relativeTimeTrigger) {
                fields.push({
                    label: '',
                    name: relativeTimeTriggerFieldName,
                    fieldType: FieldType.Custom,
                    rules: [],
                    renderField: () => (
                        <RelativeTimeTriggerSettings
                            orgId={props.orgId}
                            appId={props.appId}
                            stepConfigId={automation.stepConfigId}
                            initialValues={overrideCfg?.relativeTimeTrigger ?? automation.relativeTimeTrigger}
                            isOrgLevelItem={false}
                            showAllowTriggeringBasedOnTargetDate
                        />
                    ),
                    extraFormItemProps: { style: { marginBottom: 10 } },
                });
            }

            fields.push({
                label: '',
                data: (
                    <div>
                        Require previous release steps to be complete (green)
                        <Tooltip
                            title={
                                <span>
                                    Only blocking steps can be included as trigger conditions. Go to{' '}
                                    <Link to={appSettingsRoute} style={{ color: 'white', textDecoration: 'underline' }}>
                                        App settings
                                    </Link>{' '}
                                    to configure blocking and non-blocking steps.
                                </span>
                            }
                        >
                            <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                        </Tooltip>
                    </div>
                ),
                name: completedStepsTriggerEnabledFieldName,
                initialValue: trigState.completedStepsTrigger,
                fieldType: FieldType.Checkbox,
                onChange: (e) =>
                    setTabTriggerState((prev) => ({
                        ...prev,
                        [tab.id]: {
                            ...(prev[tab.id] ?? { relativeTimeTrigger: false, completedStepsTrigger: false }),
                            completedStepsTrigger: e.target.checked,
                        },
                    })),
                extraFormItemProps: { style: { marginBottom: 10 } },
            });

            if (trigState.completedStepsTrigger) {
                fields.push({
                    label: '',
                    name: completedStepsTriggerFieldName,
                    fieldType: FieldType.Custom,
                    initialValue: overrideCfg?.completedStepsTrigger ?? automation.completedStepsTrigger,
                    rules: [],
                    renderField: () => (
                        <CompletedStepsTriggerSettings
                            orgId={props.orgId}
                            appId={props.appId}
                            platform={automationPlatform}
                            appStoreType={automationAppStoreType}
                            stepGraphStepsMap={stepGraphStepsMap}
                        />
                    ),
                    extraFormItemProps: { style: { marginBottom: 0 } },
                });
            }
        }

        const overrideData = overrideCfg?.data as
            | (AutomationAutoSubmitRelease['data'] & AutomationAutoRelease['data'])
            | undefined;

        if (automation.type === AutomationType.AutoSubmitRelease) {
            fields.push(
                ...buildAutoReleaseAndAutoSubmitRequiredStepsFields(
                    automation as AutomationAutoSubmitRelease,
                    props.appId,
                    automationPlatform,
                    automationAppStoreType,
                    {
                        fieldKeyPrefix: namespace ? `${namespace}OverrideRequiredSteps` : 'overrideRequiredSteps',
                        submitStrategyFieldName: namespace ? [namespace, 'submitStrategy'] : 'submitStrategy',
                        shouldUseCustomRequiredStepsFieldName:
                            namespace ? [namespace, 'shouldUseCustomRequiredSteps'] : 'shouldUseCustomRequiredSteps',
                        customRequiredStepsFieldNamePrefix:
                            namespace ? [namespace, 'customRequiredSteps'] : ['customRequiredSteps'],
                        releaseTypesFieldName: selectedReleaseTypesFieldName,
                        shouldUseCustomRequiredStepsInitialValue: overrideData?.shouldUseCustomRequiredSteps,
                        customRequiredStepsInitialValue: overrideData?.customRequiredSteps,
                    },
                ),
            );
        }

        if (automation.type === AutomationType.AutoRelease) {
            fields.push(
                ...buildAutoReleaseAndAutoSubmitRequiredStepsFields(
                    automation as AutomationAutoRelease,
                    props.appId,
                    automationPlatform,
                    automationAppStoreType,
                    {
                        fieldKeyPrefix: namespace ? `${namespace}OverrideRequiredSteps` : 'overrideRequiredSteps',
                        submitStrategyFieldName: namespace ? [namespace, 'strategy'] : 'strategy',
                        shouldUseCustomRequiredStepsFieldName:
                            namespace ? [namespace, 'shouldUseCustomRequiredSteps'] : 'shouldUseCustomRequiredSteps',
                        customRequiredStepsFieldNamePrefix:
                            namespace ? [namespace, 'customRequiredSteps'] : ['customRequiredSteps'],
                        releaseTypesFieldName: selectedReleaseTypesFieldName,
                        shouldUseCustomRequiredStepsInitialValue: overrideData?.shouldUseCustomRequiredSteps,
                        customRequiredStepsInitialValue: overrideData?.customRequiredSteps,
                    },
                ),
            );
        }

        return fields;
    };

    // When all types have overrides, the first tab is an override tab rendered without namespacing
    // (its values map to the top-level request fields on submit)
    const hasPrimaryTab = tabs[0]?.isPrimary === true;
    const firstTabOverrideFields = !hasPrimaryTab && tabs.length > 0 ? buildOverrideFieldsForTab(tabs[0]) : [];

    const overrideTabData = tabs.slice(1).map((tab) => {
        return { tab, namespacedFields: buildOverrideFieldsForTab(tab, tab.id) };
    });

    const allInitialValues = { ...formInitialValues };

    // When every release type has an override (no primary tab), the first tab reuses the form's
    // top-level fields. Seed those fields with the first tab's override values, otherwise the
    // tab would show the automation's old default settings instead of its own.
    if (!hasPrimaryTab && firstTabOverrideFields.length > 0) {
        for (const field of firstTabOverrideFields) {
            if (field.fieldType === FieldType.WrappedGroup) {
                field.groupedFields?.forEach((gf) => {
                    if (gf.name && !Array.isArray(gf.name)) {
                        allInitialValues[gf.name as string] = gf.initialValue ?? null;
                    }
                });
            } else if (field.name && !Array.isArray(field.name)) {
                allInitialValues[field.name as string] = field.initialValue ?? null;
            }
        }
    }

    const filterAccelerateFieldByReleaseTypes = (
        fields: FormFieldData[],
        releaseTypes: ReleaseTypesForNonBlockingSteps[],
    ): FormFieldData[] => {
        if (releaseTypes.includes(ReleaseTypesForNonBlockingSteps.Standard)) return fields;
        const isPreviousReleaseRolloutField = (field: FormFieldData) =>
            [acceleratePreviousReleaseFieldName, waitForPreviousRolloutFieldName].includes(
                lastFieldNamePart(field.name),
            );
        return fields.map((f) => {
            if (f.fieldType === FieldType.WrappedGroup && f.groupedFields?.some(isPreviousReleaseRolloutField)) {
                return {
                    ...f,
                    groupedFields: f.groupedFields.map((gf) =>
                        isPreviousReleaseRolloutField(gf) ? { ...gf, disabled: true } : gf,
                    ),
                };
            }
            if (isPreviousReleaseRolloutField(f)) return { ...f, disabled: true };
            return f;
        });
    };

    const getTabTitle = (tab: ReleaseTypeTab): string => {
        if (appLevelAutomationConfig) return 'Configuration';
        if (tab.releaseTypes.length === 0) return 'New configuration';
        const sorted = [...tab.releaseTypes].sort(
            (a, b) => ALL_RELEASE_TYPE_GROUPS.indexOf(a) - ALL_RELEASE_TYPE_GROUPS.indexOf(b),
        );
        return sorted.map(displayTextForReleaseTypeGroup).join(', ');
    };

    const handleReleaseTypeChange = (tabIndex: number, selected: ReleaseTypesForNonBlockingSteps[]) => {
        if (appLevelAutomationConfig) return;

        const currentTab = tabs[tabIndex];
        const previousTypes = currentTab.releaseTypes;
        const added = selected.filter((t) => !previousTypes.includes(t));

        // Prepare updated tabs copy and apply the selection change to the current tab
        const updated = tabs.map((t) => ({ ...t, releaseTypes: [...t.releaseTypes] }));
        updated[tabIndex].releaseTypes = selected;

        // Remove added types from other tabs to ensure uniqueness
        for (const addedType of added) {
            for (let i = 0; i < updated.length; i++) {
                if (i === tabIndex) continue;
                updated[i].releaseTypes = updated[i].releaseTypes.filter((t) => t !== addedType);
            }
        }

        if (tabIndex === 0) {
            form.setFieldValue('selectedReleaseTypes', selected);
            form.setFieldValue('primaryReleaseTypes', selected);
        } else {
            form.setFieldValue([currentTab.id, 'selectedReleaseTypes'], selected);
        }

        // Filter out duplicate releaseTypes across tabs (keep first occurrence)
        const seen = new Set<ReleaseTypesForNonBlockingSteps>();
        let final = updated.map((t) => ({
            ...t,
            releaseTypes: t.releaseTypes.filter((rt) => {
                if (seen.has(rt)) return false;
                seen.add(rt);
                return true;
            }),
        }));

        // Remove tabs that became empty as a side-effect of moving types, except keep the tab
        // the user is actively editing (so it becomes a 'New configuration' if emptied)
        const currentTabId = currentTab.id;
        final = final.filter((t) => !(t.releaseTypes.length === 0 && t.id !== currentTabId));

        setTabs(final);

        // Keep focus on the tab the user was editing
        setActiveTab(currentTabId);
    };

    const handleAddTab = () => {
        if (appLevelAutomationConfig) return;

        const newId = `tab-${nextTabId}`;
        setNextTabId((n) => n + 1);
        setTabs((prev) => [...prev, { id: newId, releaseTypes: [] }]);
        setActiveTab(newId);
    };

    const handleCloseTab = (tabId: string) => {
        if (appLevelAutomationConfig) return;

        const tabToClose = tabs.find((t) => t.id === tabId);
        if (!tabToClose) return;
        setTabs((prev) => prev.filter((t) => t.id !== tabId));
        // Switch to the last remaining tab if any
        const remainingTabs = tabs.filter((t) => t.id !== tabId);
        if (remainingTabs.length > 0) setActiveTab(remainingTabs[remainingTabs.length - 1].id);
    };

    const tabContentStyle: React.CSSProperties = {
        background: runwayColors.white,
        borderRadius: '0 0 8px 8px',
        padding: 16,
        border: `1px solid ${antGrey.grey4}`,
        borderTop: 'none',
    };
    const appLevelConfigContentStyle: React.CSSProperties = {
        ...tabContentStyle,
        borderRadius: 8,
        borderTop: `1px solid ${antGrey.grey4}`,
    };

    const didMountRef = React.useRef(false);
    React.useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        form.resetFields();
    }, [automation.id]);

    const watchedFormValues = Form.useWatch([], form) as any;
    const activeWorkflowHaltConditionGroups: HaltPhasedRolloutConditionGroupFormValue[] =
        activeTab === 'tab-0' ?
            (watchedFormValues?.conditionGroups ?? form.getFieldValue('conditionGroups') ?? [])
        :   (watchedFormValues?.[activeTab]?.conditionGroups ??
            form.getFieldValue([activeTab, 'conditionGroups']) ??
            []);
    const workflowHaltConditionGroupsSaveDisabled =
        automation.type === AutomationType.AutoHaltUnstablePhasedReleases &&
        !!isWorkflowsRolloutStepEnabled &&
        (tabs.find((tab) => tab.id === activeTab)?.releaseTypes.length ?? 0) > 0 &&
        (activeWorkflowHaltConditionGroups.length === 0 ||
            !activeWorkflowHaltConditionGroups.some(haltConditionGroupHasSelectedCondition));

    const automationDocsLink = docsLinkForAutomationType(automation.type, automationPlatform);

    const automationSettingsFooter = footerComponentForAutomationType(automation.type, automationPlatform);

    const cannotSaveAutomationSettingsDueToPlan = shouldDisableAutomation;

    const hasEmptyReleaseTypeTab =
        !appLevelAutomationConfig && tabs.length > 1 && tabs.some((tab) => tab.releaseTypes.length === 0);

    const shouldShowDelayWarningForLifecycleAutomations =
        (!isWorkflowsSubmissionStepEnabled && automation.type === AutomationType.AutoSubmitRelease) ||
        (!isWorkflowsTakeoffStepEnabled && automation.type === AutomationType.AutoRelease);

    return (
        <Modal
            open={props.open}
            width={720}
            destroyOnClose
            title={
                <div style={{ paddingRight: 24 }}>
                    <Space size={12}>
                        <PlanRestrictedFeatureWrapper
                            automationType={automation.type}
                            requiresTooltip
                            shouldFakeDisabledState
                        >
                            <Text>{automation.name}</Text>
                        </PlanRestrictedFeatureWrapper>
                        {automation.isBeta && <BetaBadge />}
                        {automation.isUpdated && <UpdatedBadge />}
                    </Space>
                </div>
            }
            onCancel={props.onClose}
            footer={[
                <Button key="cancel" onClick={props.onClose}>
                    Cancel
                </Button>,
                <PermissionedActionButton
                    key="save"
                    actionType={RunwayUserAction.UAEditAutomations}
                    type="primary"
                    loading={props.isLoading}
                    disabled={
                        cannotSaveAutomationSettingsDueToPlan ||
                        workflowHaltConditionGroupsSaveDisabled ||
                        hasEmptyReleaseTypeTab
                    }
                    onClick={() => {
                        if (
                            !cannotSaveAutomationSettingsDueToPlan &&
                            !workflowHaltConditionGroupsSaveDisabled &&
                            !hasEmptyReleaseTypeTab
                        ) {
                            onSubmit(form);
                        }
                    }}
                >
                    Save
                </PermissionedActionButton>,
            ]}
            afterClose={() => {
                form.resetFields();
                props.onAfterClose();
            }}
            focusTriggerAfterClose={false}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                <AutomationPlanExecutionBlockedAlert
                    visible={shouldDisableAutomation && automation.enabled}
                    style={{ marginBottom: 0 }}
                />
                <PlanRestrictedFeatureWrapper automationType={automation.type} shouldFakeDisabledState>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            width: '100%',
                        }}
                    >
                        <AutomationConfigurationHelpBanner
                            automationType={automation.type}
                            appStoreDefaultsSet={!!appSettings.appStoreDefaults}
                            stagedRolloutEnabled={
                                appSettings.appStoreDefaults ?
                                    (appSettings.appStoreDefaults as GoogleAppStoreSettings).stagedRelease === true
                                :   false
                            }
                            platform={automationPlatform}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                            {props.context !== AutomationSettingsContext.App &&
                                !(shouldDisableAutomation && automation.enabled) && (
                                    <Alert
                                        showIcon
                                        closable={false}
                                        message={
                                            <Text>
                                                These settings will apply to all releases of the specified type (not
                                                only to the current release).
                                            </Text>
                                        }
                                        type="warning"
                                    />
                                )}
                            {automation.description && <Text>{automation.description}</Text>}
                            {automationDocsLink && (
                                <Text>
                                    Read more about this automation in our{' '}
                                    <Typography.Link href={automationDocsLink} target="_blank">
                                        docs.
                                    </Typography.Link>
                                </Text>
                            )}
                            <Space size={10} wrap direction="vertical">
                                {automation.requiredCapabilities?.length > 0 && capabilitiesShouldBeBulleted ?
                                    <>
                                        <Text style={{ color: antGrey.grey8 }}>Required integrations:</Text>
                                        {automation.requiredCapabilities.map((requiredArray) => {
                                            return (
                                                <>
                                                    <ul style={{ margin: 0 }}>
                                                        <li style={{ color: antGrey.grey8 }}>
                                                            {requiredCapabilitiesComponent(requiredArray)}
                                                        </li>
                                                    </ul>
                                                </>
                                            );
                                        })}
                                    </>
                                : automation.requiredCapabilities?.length > 0 ?
                                    <Space size={10} wrap>
                                        <Text style={{ color: antGrey.grey7 }}>Required:</Text>
                                        {automation.requiredCapabilities.map((requiredArray) => {
                                            return requiredCapabilitiesComponent(requiredArray);
                                        })}
                                    </Space>
                                :   null}
                            </Space>
                            {automation.type === AutomationType.AutoUploadBinaryArtifactToAppStore &&
                                !autoDownloadArtifactsEnabled && (
                                    <Alert
                                        showIcon
                                        closable={false}
                                        type="warning"
                                        message={
                                            <Text>
                                                The &apos;
                                                {automationDisplayNameForAutomationId(
                                                    AutomationType.AutoDownloadArtifacts,
                                                    automationAppStoreType,
                                                )}
                                                &apos; automation is disabled, so Runway won&apos;t have any artifacts
                                                to upload. Enable it, or make sure you upload artifacts to Runway via
                                                the public API, for this automation to work.
                                            </Text>
                                        }
                                    />
                                )}
                            {servicesErrorMessage &&
                                !(
                                    servicesErrorMessage === DEFAULT_RELEASE_SETTINGS_ERROR_MESSAGE &&
                                    releaseNotesSourceFormValue === ReleaseNotesDataSource.PreviousRelease
                                ) &&
                                renderErrorMessage(servicesErrorMessage)}
                        </div>
                        {sameTypeAutomations.length > 1 && (
                            <StepConfigSelector
                                value={automation.id}
                                sameTypeAutomations={sameTypeAutomations}
                                stepGraphStepsMap={stepGraphStepsMap}
                                platform={automationPlatform}
                                appStoreType={automationAppStoreType}
                                isWorkflowsCIStepEnabled={isWorkflowsCIStepEnabled}
                                onChange={(automationId) => {
                                    props.onAutomationSelected?.(automationId);
                                    const selectedAutomation = sameTypeAutomations.find(
                                        (auto) => auto.id === automationId,
                                    );
                                    setSelectedStepConfigId(selectedAutomation?.stepConfigId);
                                }}
                            />
                        )}
                        {/* The form can't start without every field, or the missing settings would be saved as cleared */}
                        {!settingFieldsByAutomationId ?
                            isSettingFieldsError ?
                                <Alert
                                    type="error"
                                    showIcon
                                    message="Couldn't load the automation settings. Please try again."
                                />
                            :   <Spin style={{ display: 'block', margin: '24px auto' }} />
                        : !isBucketAutomationType ?
                            <Form
                                form={form}
                                autoComplete="off"
                                layout="vertical"
                                initialValues={allInitialValues}
                                onFinish={() => onSubmit(form)}
                                disabled={shouldDisableAutomation}
                            >
                                {appLevelAutomationConfig ?
                                    tabs[0] && (
                                        <div style={appLevelConfigContentStyle}>
                                            {renderFormFields(
                                                filterAccelerateFieldByReleaseTypes(
                                                    firstTabOverrideFields,
                                                    tabs[0].releaseTypes,
                                                ),
                                            )}
                                        </div>
                                    )
                                :   <Tabs
                                        activeKey={activeTab}
                                        onChange={setActiveTab}
                                        type="editable-card"
                                        hideAdd={false}
                                        tabBarStyle={{ marginBottom: 0 }}
                                        onEdit={(targetKey, action) => {
                                            if (action === 'add') {
                                                handleAddTab();
                                            } else if (action === 'remove' && typeof targetKey === 'string') {
                                                handleCloseTab(targetKey);
                                            }
                                        }}
                                        items={tabs.map((tab, index) => {
                                            const hasNoReleaseTypes = tab.releaseTypes.length === 0;
                                            const overrideData = overrideTabData.find((d) => d.tab.id === tab.id);
                                            return {
                                                key: tab.id,
                                                label: getTabTitle(tab),
                                                closable: tabs.length > 1,
                                                children: (
                                                    <div style={tabContentStyle}>
                                                        {index === 0 && (
                                                            <FormItem
                                                                hidden
                                                                name="primaryReleaseTypes"
                                                                initialValue={tab.releaseTypes}
                                                            >
                                                                <Input />
                                                            </FormItem>
                                                        )}
                                                        <Form.Item
                                                            label="Enabled for release types"
                                                            style={{ marginBottom: 16 }}
                                                        >
                                                            <Select
                                                                mode="multiple"
                                                                value={tab.releaseTypes}
                                                                tagRender={({ label, closable, onClose }) => (
                                                                    <Tag
                                                                        color={rwColors.primary}
                                                                        closable={closable}
                                                                        onClose={onClose}
                                                                        onMouseDown={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                        }}
                                                                        style={{ marginInlineEnd: 4 }}
                                                                    >
                                                                        {label}
                                                                    </Tag>
                                                                )}
                                                                onChange={(selected) =>
                                                                    handleReleaseTypeChange(index, selected)
                                                                }
                                                                options={ALL_RELEASE_TYPE_GROUPS.map((t) => ({
                                                                    value: t,
                                                                    label: displayTextForReleaseTypeGroup(t),
                                                                }))}
                                                            />
                                                        </Form.Item>
                                                        <div
                                                            style={
                                                                hasNoReleaseTypes ?
                                                                    {
                                                                        opacity: 0.5,
                                                                        filter: 'grayscale(100%)',
                                                                        pointerEvents: 'none',
                                                                    }
                                                                :   undefined
                                                            }
                                                        >
                                                            {index === 0 ?
                                                                renderFormFields(
                                                                    filterAccelerateFieldByReleaseTypes(
                                                                        withoutEnabledSwitch(
                                                                            hasPrimaryTab ? primaryFormFields : (
                                                                                firstTabOverrideFields
                                                                            ),
                                                                        ),
                                                                        tab.releaseTypes,
                                                                    ),
                                                                )
                                                            :   renderFormFields(
                                                                    filterAccelerateFieldByReleaseTypes(
                                                                        withoutEnabledSwitch(
                                                                            overrideData?.namespacedFields ?? [],
                                                                            tab.id,
                                                                        ),
                                                                        tab.releaseTypes,
                                                                    ),
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                ),
                                            };
                                        })}
                                    />
                                }
                            </Form>
                        :   <Form
                                form={form}
                                autoComplete="off"
                                layout="vertical"
                                initialValues={allInitialValues}
                                onFinish={() => onSubmit(form)}
                                disabled={shouldDisableAutomation}
                            >
                                {renderFormFields(primaryFormFields)}
                            </Form>
                        }
                        {automation.additionalInfo && (
                            <div>
                                <Text type="secondary">{automation.additionalInfo}</Text>
                            </div>
                        )}
                        {/* Only show a warning about potential delay for non-migrated steps */}
                        {/* For workflow apps, we have scheduled actions enabled */}
                        {shouldShowDelayWarningForLifecycleAutomations && (
                            <Alert
                                showIcon
                                closable={false}
                                message={<Text>{LIFECYCLE_AUTOMATION_TIMING_MESSAGE}</Text>}
                                type="info"
                            />
                        )}
                        {automationSettingsFooter}
                    </div>
                </PlanRestrictedFeatureWrapper>
            </div>
        </Modal>
    );
};

const footerComponentForAutomationType = (automationType: AutomationType, platform: AppPlatform) => {
    switch (automationType) {
        case AutomationType.AutoCreateAppStoreVersions:
            return getIsApplePlatform(platform) ?
                    <Text type="warning">
                        For this automation to work correctly, please ensure that App Store versions are not updated by
                        any existing CI/CD workflows (for example, if you&apos;re using{' '}
                        <Text code>fastlane deliver</Text>).
                    </Text>
                :   null;
        default:
            return null;
    }
};

enum TriggerWorkflowOption {
    SmartMode,
    TriggerEveryNHours,
}

type AutoSubmitOrReleaseAutomationName = 'auto-submit' | 'auto-release';

const acceleratePreviousReleaseTooltip = (
    <>
        <p>
            By default, your prior release will NOT automatically accelerate to 100% when releasing the next version.
            With multiple subsequent incomplete rollouts, this may mean that some of your users will continue on older
            (n-2, n-3) versions even if they have enabled automatic updates. Choose this option to ensure all your users
            will be on at least your prior release when they update.
        </p>
        <p style={{ marginBottom: 0 }}>
            Releases that were previously halted, or releases before a rollback or hotfix, will not be accelerated to
            100% automatically.
        </p>
    </>
);

const waitForPreviousRolloutTooltip = (
    <>
        <p>
            While your previous release is still rolling out, Runway holds the automation and adds a timeline event
            explaining the wait. It picks back up on its own once that rollout reaches 100%.
        </p>
        <p style={{ marginBottom: 0 }}>
            A rollout that was halted or paused never reaches 100%, so Runway treats it as finished and moves forward.
            Hotfix and rollback releases are never delayed.
        </p>
    </>
);

const continueIncrementingAfterManualUpdateTooltip = (
    <>
        <p>
            Applies whether the percentage was changed from Runway or straight from your store console — Runway treats
            both the same way.
        </p>
        <p>
            <strong>Checked:</strong> Runway matches the new percentage to the day it corresponds to in the sequence
            above, and carries on from the next day. With a 1 / 2 / 5 / 10 / 20 / 50 / 100 sequence, a manual jump to
            20% counts as day 5, so the next increment Runway makes is to 50%. The wait before that next increment
            starts from the manual change, not from Runway's last one.
        </p>
        <p style={{ marginBottom: 0 }}>
            <strong>Unchecked:</strong> Runway keeps walking the sequence one day at a time and only writes a new
            percentage once the day it has reached is scheduled for more than what is already live. After that same jump
            to 20%, the rollout sits at 20% while Runway works through days 4 and 5, and only moves when it reaches day
            6 (50%).
        </p>
    </>
);

const infoTooltipIcon = (tooltip: React.ReactNode) => (
    <Tooltip title={tooltip}>
        <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
    </Tooltip>
);

const acceleratePreviousReleaseLabel = (
    <div>
        (Standard releases only) Accelerate previous release to 100% of users if needed before releasing new version
        {infoTooltipIcon(acceleratePreviousReleaseTooltip)}
    </div>
);

const waitForPreviousRolloutLabel = (automationName: AutoSubmitOrReleaseAutomationName) => (
    <div>
        {`Do not ${automationName === 'auto-submit' ? 'submit' : 'release'} until the previous release is 100% rolled out, or has been halted/paused`}
        {infoTooltipIcon(waitForPreviousRolloutTooltip)}
    </div>
);

const acceleratePreviousReleaseFieldName = 'shouldReleasePreviousSubmissionToAllUsersFirst';
const waitForPreviousRolloutFieldName = 'shouldWaitForPreviousReleaseToBeFullyRolledOut';

const lastFieldNamePart = (name: FormFieldData['name']): string =>
    Array.isArray(name) && name.length ? String(name[name.length - 1]) : String(name);

const buildPreviousReleaseRolloutFields = (
    automationName: AutoSubmitOrReleaseAutomationName,
    automationData:
        | {
              shouldReleasePreviousSubmissionToAllUsersFirst?: boolean;
              shouldWaitForPreviousReleaseToBeFullyRolledOut?: boolean;
          }
        | undefined,
    formInstance?: FormInstance,
): FormFieldData => ({
    name: `previousReleaseRolloutOptions-${automationName}`,
    fieldType: FieldType.WrappedGroup,
    groupedFields: [
        {
            label: '',
            data: acceleratePreviousReleaseLabel,
            name: acceleratePreviousReleaseFieldName,
            fieldType: FieldType.Checkbox,
            initialValue: automationData?.shouldReleasePreviousSubmissionToAllUsersFirst ?? false,
            rules: [],
        },
        {
            label: '',
            data: waitForPreviousRolloutLabel(automationName),
            name: waitForPreviousRolloutFieldName,
            fieldType: FieldType.Checkbox,
            initialValue: automationData?.shouldWaitForPreviousReleaseToBeFullyRolledOut ?? false,
            rules: [],
        },
    ],
    groupChildrenWrapper:
        formInstance ?
            (_, wrappedFields, renderFields) => (
                <Form.Item shouldUpdate noStyle>
                    {() => {
                        const isChecked = (fieldName: string) =>
                            !!formInstance.getFieldValue(
                                wrappedFields.find((f) => lastFieldNamePart(f.name) === fieldName)?.name,
                            );

                        return renderFields(
                            wrappedFields.map((field) => {
                                const otherFieldName =
                                    lastFieldNamePart(field.name) === acceleratePreviousReleaseFieldName ?
                                        waitForPreviousRolloutFieldName
                                    :   acceleratePreviousReleaseFieldName;

                                return { ...field, disabled: field.disabled || isChecked(otherFieldName) };
                            }),
                        );
                    }}
                </Form.Item>
            )
        :   undefined,
});

const automationSettingFormFieldsForAutomation: (
    appId: string,
    orgId: string,
    appIdParam: string,
    orgIdParam: string,
    automation: Automation,
    appPlatform: AppPlatform,
    appStoreType: AppStoreType,
    hasRequiredCapabilities: boolean,
    shouldDisableAutomationForPlan: boolean,
    connectedCapabilities: IntegrationCapability[],
    vcsSupportsDirectPushCheck: boolean,
    baseFieldHelpMessage: React.ReactNode,
    monitoringMetrics?: AppMonitoringHealthMetric[],
    artifactUploadOptions?: ArtifactUploadOptions,
    dsymsUploadOptions?: DsymsUploadOptions,
    notificationsProvider?: IntegrationProvider,
    regressionTesting?: Integration,
    triggerWorkflowOption?: TriggerWorkflowOption,
    onSelectTriggerWorkflowOption?: (option: TriggerWorkflowOption) => void,
    betaTesting?: Integration,
    betaTestingProvider?: IntegrationProvider,
    monitoringChecklistItemTemplates?: ChecklistItemTemplate[],
    orgUserGroups?: Record<UserGroupId, UserGroup>,
    appUsers?: OrgUser[],
    autoSubmitStrategy?: AutoSubmitStrategy,
    onSelectAutoSubmitStrategy?: (strategy: AutoSubmitStrategy) => void,
    schedulingIntegration?: Integration,
    schedulingProvider?: IntegrationProvider | null,
    form?: FormInstance,
    isPlayReleaseLifecycleEnabled?: boolean,
    stabilityIntegrations?: Integration[],
    hasAppStoreIntegration?: boolean,
    availableIssueTrackingLabels?: string[],
    useTriggerCIWorkflowConditionGroups?: boolean,
    stepGraphStepsMap?: Record<string, StepGraphStep>,
    settingFields?: SettingField[],
    resigningStrategy?: RollbackResigningStrategy,
    onSelectResigningStrategy?: (strategy: RollbackResigningStrategy) => void,
    rebuildByCIUnavailableReason?: string | null,
    isWorkflowsRolloutStepEnabled?: boolean,
) => FormFieldData[] = (
    appId,
    orgId,
    orgIdParam,
    appIdParam,
    automation,
    platform,
    appStoreType,
    hasRequiredCapabilities,
    shouldDisableAutomationForPlan,
    connectedCapabilities,
    vcsSupportsDirectPushCheck,
    baseFieldHelpMessage,
    monitoringMetrics,
    artifactUploadOptions,
    dsymsUploadOptions,
    notificationsProvider,
    regressionTesting,
    triggerWorkflowOption,
    onSelectTriggerWorkflowOption,
    betaTesting,
    betaTestingProvider,
    monitoringChecklistItemTemplates,
    orgUserGroups,
    appUsers,
    autoSubmitStrategy,
    onSelectAutoSubmitStrategy,
    schedulingIntegration,
    schedulingProvider,
    form,
    isPlayReleaseLifecycleEnabled,
    stabilityIntegrations = [],
    hasAppStoreIntegration = false,
    availableIssueTrackingLabels = [],
    useTriggerCIWorkflowConditionGroups = false,
    stepGraphStepsMap = {},
    settingFields,
    resigningStrategy,
    onSelectResigningStrategy,
    rebuildByCIUnavailableReason,
    isWorkflowsRolloutStepEnabled,
) => {
    if (!automation) {
        return [];
    }

    const baseField: FormFieldData = {
        label: 'Enabled',
        name: 'enabled',
        helpMessage: baseFieldHelpMessage,
        initialValue: automation.enabled,
        fieldType: FieldType.Switch,
        rules: [
            {
                validator: (_, enabled) => {
                    if (enabled && !hasRequiredCapabilities) {
                        return Promise.reject(
                            'Required integrations not configured. Please disable automation to save settings.',
                        );
                    }

                    return Promise.resolve();
                },
            },
        ],
        // disabled: !hasRequiredCapabilities && !automation.enabled,
        disabled: !hasRequiredCapabilities && !automation.enabled,
        extraFormItemProps: {
            validateTrigger: false,
        },
    };

    const automationPlatform = automation.platform ?? platform;

    const releaseTypesField: FormFieldData | null = renderReleaseTypesForAutomation(
        automation.type,
        automationPlatform,
        !hasRequiredCapabilities && !automation.enabled,
        automation.automationReleaseTypes,
    );

    const baseFields: FormFieldData[] = [baseField, ...(releaseTypesField ? [releaseTypesField] : [])];

    if (settingFields) {
        return [
            ...baseFields,
            ...formFieldsFromSettingFields(
                settingFields.map((settingField) =>
                    withAutomationCurrentValue(
                        withIssueTrackingLabelOptions(settingField, availableIssueTrackingLabels),
                        automation,
                    ),
                ),
                undefined,
                (settingField, formField) =>
                    resolveAutomationFormField(settingField, formField, {
                        orgId,
                        appId,
                        automationType: automation.type,
                        vcsSupportsDirectPushCheck,
                        platform: automationPlatform,
                        appStoreType,
                        regressionTestingType: regressionTesting?.id,
                    }),
            ),
        ];
    }

    switch (automation.type) {
        case AutomationType.AutoSyncAppStoreUsers: {
            const syncAutomation = automation as AutomationSyncAppStoreUsers;
            const appStoreName = displayConsoleNameForAppStoreType(appStoreType);

            return generateAutoSyncAppStoreUsersFields(
                baseField,
                syncAutomation,
                appStoreName,
                appStoreType,
                Object.values(orgUserGroups),
            );
        }
        case AutomationType.AutoTriggerCIWorkflow: {
            const triggerCIData = (automation as AutomationAutoTriggerCIWorkflow).data;
            const fields: FormFieldData[] = [
                ...baseFields,
                {
                    label: '',
                    name: 'skipIfBuildAlreadyExists',
                    fieldType: FieldType.Checkbox,
                    initialValue: !!triggerCIData?.skipIfBuildAlreadyExists,
                    data: 'Skip execution if a CI build has already been triggered for version',
                },
            ];

            if (useTriggerCIWorkflowConditionGroups) {
                fields.push({
                    name: TRIGGER_CONDITION_GROUPS_FIELD_KEY,
                    fieldType: FieldType.Custom,
                    skipFormItemWrapper: true,
                    data: {
                        formListName: 'conditionGroups',
                        initialValue: conditionGroupsForTriggerCIWorkflow(
                            triggerCIData?.conditionGroups,
                            automation.relativeTimeTrigger,
                            automation.completedStepsTrigger,
                        ),
                    },
                    renderField: ({ formListName, initialValue }) => (
                        <TriggerCIWorkflowConditionGroups
                            orgId={orgId}
                            appId={appId}
                            stepConfigId={automation.stepConfigId}
                            initialGroups={initialValue}
                            formListName={formListName}
                            platform={platform}
                            appStoreType={appStoreType}
                            stepGraphStepsMap={stepGraphStepsMap}
                        />
                    ),
                });
            }

            return fields;
        }
        case AutomationType.AutoCreateIncidents: {
            const createIncidentAutomation = automation as AutomationCreateIncidents;
            const unhealthyTrigger = createIncidentAutomation.data?.unhealthyMetricsTrigger;

            const visibleIncidentMetrics =
                monitoringMetrics?.filter(
                    (item) => !item.hideOnRolloutView || unhealthyTrigger?.monitoringConditions?.includes(item.id),
                ) ?? [];

            const incidentConditionOptions: MonitoringConditionOption[] = automationConditionsForAutomationType(
                automation.type,
                appStoreType,
            ).map((type) => ({ id: type, title: displayTextForAutomationConditionType(type) }));

            const incidentConditionFields: { id: MonitoringAutomationConditionType; threshold: number }[] = [];
            if (unhealthyTrigger?.adoptionThreshold != null) {
                incidentConditionFields.push({
                    id: MonitoringAutomationConditionType.Adoption,
                    threshold: unhealthyTrigger.adoptionThreshold,
                });
            }
            if (unhealthyTrigger?.phasedReleaseDayThreshold != null) {
                incidentConditionFields.push({
                    id: MonitoringAutomationConditionType.PhasedReleaseDay,
                    threshold: unhealthyTrigger.phasedReleaseDayThreshold,
                });
            }
            if (unhealthyTrigger?.stagedRolloutPercentageThreshold != null) {
                incidentConditionFields.push({
                    id: MonitoringAutomationConditionType.StagedRolloutPercentage,
                    threshold: unhealthyTrigger.stagedRolloutPercentageThreshold,
                });
            }

            const appStoreTriggersDisabled = !hasAppStoreIntegration;
            const healthMetricsTriggerDisabled = visibleIncidentMetrics.length === 0;
            const healthMetricsLink = createAppSettingsRouteWithSettingType(
                orgIdParam,
                appIdParam,
                SettingType.HealthMetrics,
            );
            const appStoreTriggerLabel = (label: string): React.ReactNode =>
                appStoreTriggersDisabled ?
                    <Tooltip title="Requires an app store integration">
                        <span>{label}</span>
                    </Tooltip>
                :   label;
            const healthMetricsTriggerLabel = (label: string): React.ReactNode =>
                healthMetricsTriggerDisabled ?
                    <Tooltip
                        title={
                            <span>
                                Requires at least one health metric.{' '}
                                <Link
                                    to={healthMetricsLink}
                                    style={{
                                        color: 'white',
                                        textDecorationLine: 'underline',
                                        textDecorationStyle: 'dotted',
                                        textUnderlineOffset: 3,
                                    }}
                                >
                                    Manage health metrics
                                </Link>
                            </span>
                        }
                    >
                        <span>{label}</span>
                    </Tooltip>
                :   label;
            const atLeastOneTriggerSelectedRule = (form) => ({
                validator: () => {
                    const anyTriggerSelected =
                        (!appStoreTriggersDisabled &&
                            (form.getFieldValue('shouldTriggerOnReviewRejection') ||
                                form.getFieldValue('shouldTriggerOnRolloutHalted'))) ||
                        (!healthMetricsTriggerDisabled && form.getFieldValue('shouldTriggerOnUnhealthyMetrics'));
                    if (!anyTriggerSelected) {
                        return Promise.reject('Select at least one trigger.');
                    }
                    return Promise.resolve();
                },
            });
            const clearAtLeastOneTriggerError = () => {
                form?.setFields([{ name: 'shouldTriggerOnUnhealthyMetrics', errors: [] }]);
            };
            const clearUnhealthyMetricsError = () => {
                form?.setFields([{ name: 'shouldTriggerOnUnhealthyMetrics', errors: [] }]);
            };
            const unhealthyMetricsValidationRule = (form) => ({
                validator: (_, shouldTrigger) => {
                    if (!shouldTrigger || healthMetricsTriggerDisabled) {
                        return Promise.resolve();
                    }
                    const monitoringConditions: { id?: string }[] = form.getFieldValue('monitoringConditions') ?? [];
                    const hasSelectedMetric = monitoringConditions.some((c) => !!c?.id);
                    if (!hasSelectedMetric) {
                        return Promise.reject(
                            'At least one health metric is required to trigger on unhealthy metrics.',
                        );
                    }
                    return Promise.resolve();
                },
            });
            const incidentMetricsInitialValue = (unhealthyTrigger?.monitoringConditions ?? [])
                .filter((id) => visibleIncidentMetrics.find((m) => m.id === id)?.thresholds?.length > 0)
                .map((id) => ({ id }));

            const isIncidentIoScheduling = schedulingIntegration?.id === IntegrationType.IncidentIoScheduling;
            const incidentIoSeverities = (
                (schedulingProvider as IntegrationProviderIncidentIo | null)?.data?.severities ?? []
            ).map((severity) => ({ value: severity.id, displayValue: severity.name }));
            const incidentIoSettings = createIncidentAutomation.data
                ?.integrationSpecificSettings as IncidentIoCreateIncidentsSettings;
            const incidentIoFields: FormFieldData[] =
                isIncidentIoScheduling ?
                    [
                        {
                            label: 'Severity',
                            name: 'incidentIoSeverityId',
                            fieldType: FieldType.Select,
                            initialValue: incidentIoSettings?.severityId ?? null,
                            data: incidentIoSeverities,
                            helpMessage: 'The severity assigned to incidents created on incident.io.',
                            rules: [{ required: true, message: 'Severity is required.' }],
                            style: { marginTop: 16 },
                        },
                    ]
                :   [];

            const isPagerDutyScheduling = schedulingIntegration?.id === IntegrationType.PagerDutyScheduling;
            const pagerDutyServices = (
                (schedulingProvider as IntegrationProviderPagerDuty | null)?.data?.services ?? []
            ).map((service) => ({ value: service.id, displayValue: `${service.name} (${service.id})` }));
            const pagerDutySettings = createIncidentAutomation.data
                ?.integrationSpecificSettings as PagerDutyCreateIncidentsSettings;
            const pagerDutyFields: FormFieldData[] =
                isPagerDutyScheduling ?
                    [
                        {
                            label: 'PagerDuty Service',
                            name: 'pagerDutyServiceId',
                            fieldType: FieldType.Select,
                            initialValue: pagerDutySettings?.serviceId ?? null,
                            data: pagerDutyServices,
                            helpMessage: 'The PagerDuty service that incidents will be created on.',
                            rules: [{ required: true, message: 'PagerDuty Service is required.' }],
                            style: { marginTop: 16 },
                        },
                        {
                            label: 'PagerDuty From Email',
                            name: 'pagerDutyFromEmail',
                            fieldType: FieldType.Input,
                            placeholder: 'Email',
                            initialValue: pagerDutySettings?.fromEmail ?? '',
                            helpMessage:
                                'Email of the PagerDuty user that incidents will be created from. Must be a valid PagerDuty user.',
                            rules: [
                                { required: true, message: 'PagerDuty From Email is required.' },
                                { type: 'email', message: 'Please enter a valid email.' },
                            ],
                        },
                    ]
                :   [];

            return [
                ...baseFields,
                {
                    label: 'Create an incident/alert when...',
                    data: appStoreTriggerLabel('Submission is rejected during app store review'),
                    name: 'shouldTriggerOnReviewRejection',
                    fieldType: FieldType.Checkbox,
                    initialValue:
                        !appStoreTriggersDisabled &&
                        (createIncidentAutomation.data?.reviewRejectionTrigger?.enabled ?? false),
                    rules: [],
                    style: { marginBottom: 0 },
                    disabled: appStoreTriggersDisabled,
                    onChange: clearAtLeastOneTriggerError,
                },
                {
                    label: '',
                    data: appStoreTriggerLabel(
                        `An active ${phasedReleaseDisplayTextForAppStoreType(appStoreType) || 'rollout'} is halted`,
                    ),
                    name: 'shouldTriggerOnRolloutHalted',
                    fieldType: FieldType.Checkbox,
                    initialValue:
                        !appStoreTriggersDisabled &&
                        (createIncidentAutomation.data?.rolloutHaltedTrigger?.enabled ?? false),
                    rules: [],
                    style: { marginTop: 0, marginBottom: 0 },
                    disabled: appStoreTriggersDisabled,
                    onChange: clearAtLeastOneTriggerError,
                },
                {
                    label: '',
                    data: healthMetricsTriggerLabel('One or more health metrics become unhealthy'),
                    name: 'shouldTriggerOnUnhealthyMetrics',
                    fieldType: FieldType.Checkbox,
                    initialValue: unhealthyTrigger?.enabled ?? false,
                    rules: [unhealthyMetricsValidationRule, atLeastOneTriggerSelectedRule],
                    style: { marginTop: 0, marginBottom: 12 },
                    disabled: healthMetricsTriggerDisabled,
                    extraFormItemProps: { validateTrigger: [] },
                    onChange: () => {
                        clearUnhealthyMetricsError();
                        clearAtLeastOneTriggerError();
                    },
                },
                {
                    label: '',
                    name: 'incidentMetricSelector',
                    fieldType: FieldType.Custom,
                    rules: [],
                    style: { marginTop: 0, marginBottom: 0, paddingLeft: 32 },
                    renderField: () => (
                        <Form.Item shouldUpdate noStyle>
                            {(form) => {
                                if (
                                    healthMetricsTriggerDisabled ||
                                    !form.getFieldValue('shouldTriggerOnUnhealthyMetrics')
                                ) {
                                    return null;
                                }
                                const conditionsField = {
                                    ...generateThresholdConditionsField(
                                        'conditions',
                                        'Apply under the following conditions:',
                                        incidentConditionFields,
                                        connectedCapabilities,
                                        incidentConditionOptions,
                                    ),
                                    showDivider: false,
                                };
                                const metricField = {
                                    ...generateMonitoringConditionsField(
                                        'Trigger if any of these health metric conditions are not met:',
                                        unhealthyTrigger?.monitoringConditions ?? [],
                                        false,
                                        'OR',
                                        visibleIncidentMetrics,
                                    ),
                                    showDivider: true,
                                    initialValue: incidentMetricsInitialValue,
                                };
                                return (
                                    <>
                                        {renderFormField(conditionsField)}
                                        {renderFormField(metricField)}
                                        {renderFormField(
                                            generateLinkToHealthMetricsField(
                                                'Constraints for health metrics can be managed from',
                                                healthMetricsLink,
                                            ),
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    ),
                },
                ...incidentIoFields,
                ...pagerDutyFields,
            ];
        }
        case AutomationType.AutoHaltUnstablePhasedReleases:
        case AutomationType.AutoPromoteStablePhasedReleases: {
            return generateAutoHaltOrPromoteFields(
                baseField,
                automation,
                appStoreType,
                connectedCapabilities,
                stabilityIntegrations,
                monitoringMetrics,
                createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.HealthMetrics),
                monitoringChecklistItemTemplates,
                isWorkflowsRolloutStepEnabled,
            );
        }
        case AutomationType.AutoStagedRollout: {
            const autoStagedRolloutAutomation = automation as AutomationAutoStagedRollout;
            const initialValue = autoStagedRolloutAutomation?.data?.daysToPercent ?? [];
            const initialTimezone =
                autoStagedRolloutAutomation?.data?.autoStagedRolloutBlackoutTimezone?.trim() ?
                    autoStagedRolloutAutomation.data.autoStagedRolloutBlackoutTimezone?.trim()
                :   dayjs.tz.guess();
            const rawHour = autoStagedRolloutAutomation?.data?.autoStagedRolloutCustomHour;
            const customRolloutHourDefault =
                typeof rawHour === 'number' ?
                    dayjs()
                        .tz(initialTimezone)
                        .set('hour', rawHour)
                        .set('minute', 0)
                        .set('second', 0)
                        .set('millisecond', 0)
                :   undefined;

            const androidRolloutStartStrategiesData = availableAndroidAutoRolloutStartStrategiesForStoreType(
                appStoreType,
            ).map((strategy) => {
                const displayText = displayTextForAndroidAutoRolloutStartStrategy(strategy, appStoreType);

                return {
                    value: strategy,
                    displayValue: displayText,
                };
            });

            const shouldAllowCustomizedRollouts =
                appStoreType === AppStoreType.Google || appStoreType === AppStoreType.Huawei;

            const shouldShowRolloutStartStrategy = !(
                appStoreType === AppStoreType.Google && isPlayReleaseLifecycleEnabled
            );

            return [
                ...baseFields,
                ...(shouldAllowCustomizedRollouts ?
                    [
                        {
                            name: 'daysToPercent',
                            fieldType: FieldType.List,
                            initialValue,
                            rules: [
                                {
                                    validator: async (_, values) => {
                                        if (!values || values?.length === 0) {
                                            return Promise.reject(new Error('Percentages need at least 1 day'));
                                        }
                                        if (values.length === 1) {
                                            return Promise.resolve();
                                        }
                                        const numericValues = values.map((value) => Number(value));
                                        for (let i = 0; i < values.length; i++) {
                                            if (numericValues[i - 1] > numericValues[i]) {
                                                return Promise.reject(
                                                    new Error('Percentages must increase over rollout'),
                                                );
                                            }
                                        }
                                        if (numericValues.includes(0)) {
                                            return Promise.reject(new Error('Percentages must be greater than 0'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ],
                            listChildrenWrapper: (children, _, { errors }) => {
                                return (
                                    <Space
                                        direction="vertical"
                                        style={{
                                            width: '100%',
                                        }}
                                        size={16}
                                    >
                                        <Form.Item
                                            label="Number of days"
                                            rules={[{ required: true }]}
                                            required
                                            shouldUpdate
                                        >
                                            {(form) => {
                                                return (
                                                    <Select
                                                        defaultValue={initialValue.length}
                                                        style={{ width: 120 }}
                                                        onChange={(value) => {
                                                            const selectedDays = Math.trunc(value);
                                                            const sequence = [...DEFAULT_ROLLOUT_SEQUENCE].reverse();
                                                            const updatedSequence = [];

                                                            [...Array(selectedDays)].forEach((_, i) => {
                                                                updatedSequence.push(sequence[selectedDays - i - 1]);
                                                            });

                                                            form.setFieldsValue({
                                                                daysToPercent: updatedSequence,
                                                            });
                                                        }}
                                                    >
                                                        {[...DEFAULT_ROLLOUT_SEQUENCE].slice(1).map((_, i) => {
                                                            const day = i + 2;
                                                            return (
                                                                <Select.Option value={day} key={i}>
                                                                    {day}
                                                                </Select.Option>
                                                            );
                                                        })}
                                                    </Select>
                                                );
                                            }}
                                        </Form.Item>
                                        <Form.Item shouldUpdate noStyle>
                                            {(form) => {
                                                const daysToPercent = form.getFieldValue('daysToPercent');
                                                if (!daysToPercent || daysToPercent.length === 0) {
                                                    return null;
                                                }
                                                return (
                                                    <Form.Item
                                                        label="Rollout percentage per day"
                                                        required
                                                        style={{
                                                            marginBottom: 0,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'grid',
                                                                gridTemplateColumns: `repeat(3, 1fr)`,
                                                            }}
                                                        >
                                                            {children}
                                                        </div>
                                                    </Form.Item>
                                                );
                                            }}
                                        </Form.Item>
                                        <div
                                            style={{
                                                color: runwayColors.statusRed,
                                            }}
                                        >
                                            <Form.ErrorList errors={errors?.errors} />
                                        </div>
                                    </Space>
                                );
                            },
                            nestedListFields: [
                                {
                                    fieldType: FieldType.Custom,
                                    renderField: ({ index, listFieldData }) => {
                                        const day = index + 1;
                                        return (
                                            <Space size={6}>
                                                <Text>Day {day}</Text>
                                                <Form.Item
                                                    noStyle
                                                    validateTrigger="onSubmit"
                                                    {...listFieldData}
                                                    style={{
                                                        marginBottom: 8,
                                                    }}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: `Day ${day} is required `,
                                                        },
                                                        {
                                                            validator(_rule, value) {
                                                                if (value === 0 || value > 100) {
                                                                    return Promise.reject();
                                                                }

                                                                return Promise.resolve();
                                                            },
                                                            message:
                                                                'Staged rollout percentage must be greater than zero and less than or equal to 100. Up to 6 decimal points are allowed.',
                                                        },
                                                    ]}
                                                    hasFeedback={false}
                                                >
                                                    <AndroidStagedRolloutPercentageInput
                                                        style={{
                                                            width: 140,
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Space>
                                        );
                                    },
                                },
                            ],
                        },
                        ...(shouldShowRolloutStartStrategy ?
                            [
                                {
                                    label: 'Rollout start strategy',
                                    name: 'autoStagedRolloutStartStrategy',
                                    showsDivider: true,
                                    helpMessage:
                                        appStoreType == AppStoreType.Google ?
                                            <Text type="secondary">
                                                Teams who have managed publishing enabled in Play Console or
                                                consistently get pulled for long reviews by Google should not choose the
                                                &apos;Start automatically on submission&apos; option. For more info on
                                                this setting and store email forwarding, see our{' '}
                                                <Typography.Link
                                                    href={
                                                        'https://docs.runway.team/automations/types-of-automations#customized-android-staged-rollouts'
                                                    }
                                                    target="_blank"
                                                >
                                                    docs.
                                                </Typography.Link>
                                            </Text>
                                        :   null,
                                    fieldType: FieldType.Select,
                                    initialValue:
                                        autoStagedRolloutAutomation.data?.autoStagedRolloutStartStrategy ??
                                        AndroidAutoRolloutStartStrategy.Manual,
                                    data: androidRolloutStartStrategiesData,
                                    rules: [],
                                },
                            ]
                        :   []),
                    ]
                :   []),
                {
                    fieldType: FieldType.Select,
                    initialValue:
                        autoStagedRolloutAutomation.data?.autoStagedRolloutBlackoutTimezone || dayjs.tz.guess(),
                    inputProps: {
                        showSearch: true,
                        allowClear: true,
                    },
                    name: 'autoStagedRolloutBlackoutTimezone',
                    data: Intl.supportedValuesOf('timeZone').map((timezone) => {
                        return {
                            value: timezone,
                            displayValue: `${timezone} (${dayjs().tz(timezone).format('z')})`,
                        };
                    }),
                    rules: [
                        (form) => ({
                            validator: async (_, value) => {
                                const autoStagedRolloutBlackoutSegmentsByDay = form.getFieldValue(
                                    'autoStagedRolloutBlackoutSegmentsByDay',
                                ) as AutoStagedRolloutBlackoutSegmentsByDay;

                                const hasAtLeastOneBlackout = Object.values(
                                    autoStagedRolloutBlackoutSegmentsByDay,
                                ).some((day) => day.isBlackedOut);

                                if (!hasAtLeastOneBlackout) {
                                    return Promise.resolve(); // no blackouts, then this field is not required
                                }

                                if (!value) {
                                    return Promise.reject(new Error('Please select a timezone'));
                                }

                                if (Intl.supportedValuesOf('timeZone').includes(value)) {
                                    return Promise.resolve();
                                } else {
                                    return Promise.reject(new Error('Invalid timezone'));
                                }
                            },
                        }),
                    ],
                    showDivider: true,
                    label: 'Timezone',
                    helpMessage: `Choose the timezone for your blackout periods${shouldAllowCustomizedRollouts ? ' and the hour at which your rollout should be incremented' : ''}. Your browser's current timezone is ${dayjs.tz.guess()}.`,
                },
                shouldAllowCustomizedRollouts && {
                    fieldType: FieldType.Custom,
                    name: 'autoStagedRolloutCustomHour',
                    initialValue: customRolloutHourDefault,
                    label: 'Update staged rollout percentage at',
                    helpMessage:
                        'Runway will update the staged rollout percentage each day at the specified hour. If not set, the staged rollout will be updated every 24 hours starting from the time at which the rollout was started.',
                    inputProps: {
                        showSearch: true,
                        allowClear: true,
                    },
                    renderField: () => {
                        return (
                            <TimePicker
                                defaultValue={customRolloutHourDefault}
                                use12Hours
                                format="h A"
                                style={{ width: '100%' }}
                            />
                        );
                    },
                },
                ...(shouldAllowCustomizedRollouts ?
                    [
                        {
                            fieldType: FieldType.Checkbox,
                            name: 'shouldAccountBlackoutsForHoursSinceLastIncrement',
                            initialValue:
                                autoStagedRolloutAutomation.data?.shouldAccountBlackoutsForHoursSinceLastIncrement ??
                                false,
                            data: 'Include time passed during blackout period towards overall time in between rollout increments',
                        },
                        {
                            fieldType: FieldType.Checkbox,
                            name: 'shouldAccountHaltedPeriodsForHoursSinceLastIncrement',
                            initialValue:
                                autoStagedRolloutAutomation.data
                                    ?.shouldAccountHaltedPeriodsForHoursSinceLastIncrement ?? true,
                            data: 'Include time passed during halted period towards overall time in between rollout increments',
                        },
                        {
                            fieldType: FieldType.Checkbox,
                            name: 'shouldContinueIncrementingAfterManualUpdate',
                            initialValue:
                                autoStagedRolloutAutomation.data?.shouldContinueIncrementingAfterManualUpdate ?? true,
                            data: checkboxLabelWithTooltip(
                                'Continue incrementing rollout even when rollout percentage is manually updated (in Runway or externally)',
                                continueIncrementingAfterManualUpdateTooltip,
                            ),
                        },
                    ]
                :   []),
                {
                    fieldType: FieldType.Custom,
                    showDivider: false,
                    renderField: () => {
                        return shouldAllowCustomizedRollouts ?
                                <Text>
                                    Specify <strong>blackout days</strong> (and optionally, windows of time) for your
                                    staged rollout. Your staged rollout <strong>will not be incremented</strong>{' '}
                                    automatically by Runway during blackout days or hours.
                                </Text>
                            :   <Text>
                                    Specify <strong>blackout days</strong> (and optionally, windows of time) for your
                                    phased rollout. Your phased rollout <strong>will be paused</strong> automatically by
                                    Runway during blackout days or hours.
                                </Text>;
                    },
                },
                {
                    fieldType: FieldType.Custom,
                    initialValue: decodeAutoStagedRolloutBlackoutSegmentsByDay(
                        autoStagedRolloutAutomation.data?.autoStagedRolloutBlackoutSegmentsByDay,
                    ),
                    name: 'autoStagedRolloutBlackoutSegmentsByDay',
                    extraFormItemProps: {
                        name: undefined, // this will override the name in the field which fixes a bug with checkbox overriding the whole object value
                    },
                    showDivider: false,
                    renderField: () => {
                        return (
                            <Space
                                direction="vertical"
                                style={{
                                    width: '100%',
                                    marginTop: 16,
                                }}
                                split={
                                    <Divider
                                        style={{
                                            margin: '8px 0',
                                        }}
                                    />
                                }
                            >
                                {AllDaysOfTheWeek.map((day) => (
                                    <React.Fragment key={day}>
                                        {generateDayRow('autoStagedRolloutBlackoutSegmentsByDay', day)}
                                    </React.Fragment>
                                ))}
                            </Space>
                        );
                    },
                },
            ];
        }
        case AutomationType.AutoUploadBinaryArtifactToAppStore: {
            if (!artifactUploadOptions) {
                return [];
            }
            const isCustomCI = artifactUploadOptions?.buildSystem?.id === IntegrationType.CustomCI;
            const buildSystemData = artifactUploadOptions.buildSystem?.data as BaseCIIntegrationData;
            let workflowName: string;
            let prodWorkflowName: string;
            if (buildSystemData) {
                workflowName = buildSystemData.workflowName;
                prodWorkflowName = buildSystemData.prodWorkflowName;
            }

            if (
                connectedCapabilities.includes(IntegrationCapability.BuildSystem) &&
                buildSystemData &&
                (workflowName || prodWorkflowName || isCustomCI) &&
                artifactUploadOptions.appIdentifiers.size > 0
            ) {
                return generateAutoUploadBinaryArtifactToAppStoreFields(
                    baseField,
                    automation,
                    platform,
                    appStoreType,
                    artifactUploadOptions.destinationOptions,
                    buildSystemData,
                    isCustomCI,
                );
            } else {
                return [
                    {
                        ...baseField,
                        disabled: true,
                    },
                    {
                        name: 'ciCdMessage',
                        showDivider: true,
                        fieldType: FieldType.Custom,
                        renderField: () => {
                            const platformIdentifier = identifierForAppPlatform(platform);
                            // default message for null buildSystemData or no workflows configured
                            let message =
                                'A Release Candidate or production workflow must be configured in order to enable this automation. Configure workflows by visiting CI/CD integration settings.';
                            if (artifactUploadOptions.appIdentifiers.size == 0 && !workflowName && !prodWorkflowName) {
                                message = `At least one workflow and either a Beta Testing or App Store ${platformIdentifier} must be configured in order to enable this automation. Configure by visiting CI/CD and Beta and/or App Store integration settings.`;
                            } else if (artifactUploadOptions.appIdentifiers.size == 0) {
                                message = `A Beta Testing or App Store ${platformIdentifier} must be configured in order to enable this automation. Configure by visiting Beta and/or App Store integration settings.`;
                            }
                            return <Text style={{ color: antGrey.grey7 }}>{message}</Text>;
                        },
                    },
                ];
            }
        }
        case AutomationType.AutoUploadDsymsToStabilityMonitoring: {
            if (!dsymsUploadOptions) {
                return [];
            }
            const isCustomCI = dsymsUploadOptions.buildSystem?.id === IntegrationType.CustomCI;
            const buildSystemData = dsymsUploadOptions.buildSystem?.data as BaseCIIntegrationData;
            let workflowName: string;
            let prodWorkflowName: string;
            if (buildSystemData) {
                workflowName = buildSystemData.workflowName;
                prodWorkflowName = buildSystemData.prodWorkflowName;
            }

            const stabilityMonitoring = dsymsUploadOptions.stabilityMonitoring
                ?.data as BaseStabilityMonitoringIntegrationData;

            if (
                connectedCapabilities.includes(IntegrationCapability.BuildSystem) &&
                buildSystemData &&
                (workflowName || prodWorkflowName || isCustomCI) &&
                stabilityMonitoring != null
            ) {
                return generateAutoUploadDsymsToStabilityMonitoringFields(
                    baseField,
                    automation,
                    buildSystemData,
                    automation.dsymUploadDestinationOptions ?? [],
                );
            } else {
                return [
                    {
                        ...baseField,
                        disabled: true,
                    },
                    {
                        name: 'ciCdMessage',
                        showDivider: true,
                        fieldType: FieldType.Custom,
                        renderField: () => {
                            // default message for null buildSystemData or no workflows configured
                            let message =
                                'A Release Candidate or production workflow must be configured in order to enable this automation. Configure workflows by visiting CI/CD integration settings.';
                            if (!stabilityMonitoring && !workflowName && !prodWorkflowName) {
                                message = `At least one workflow and a stability monitoring integration must be configured in order to enable this automation. Configure by visiting CI/CD and stability monitoring integration settings.`;
                            } else if (!stabilityMonitoring) {
                                message = `A stability monitoring integration must be configured in order to enable this automation. Configure by visiting stability monitoring integration settings.`;
                            }
                            return <Text style={{ color: antGrey.grey7 }}>{message}</Text>;
                        },
                    },
                ];
            }
        }
        case AutomationType.AutoSubmitRelease: {
            const submitReleaseAutomation = automation as AutomationAutoSubmitRelease;
            const shouldShowReleaseToFullPercentageCheckboxOption =
                isGooglePlatform(platform) && isGoogleBetaIntegration(betaTesting?.id);

            const helpMessage = helperTextForAutoSubmitStrategy(autoSubmitStrategy, appStoreType);
            const warningMessage = warningTextForAutoSubmitStrategy(autoSubmitStrategy, appStoreType);

            const baseFieldAndSubmitField: FormFieldData[] = [
                ...baseFields,
                {
                    label: 'Submit for review:',
                    fieldType: FieldType.Custom,
                    style: { wordWrap: 'break-word' },
                    name: 'submitStrategy',
                    initialValue: autoSubmitStrategy,
                    helpMessage:
                        warningMessage ?
                            <>
                                {' '}
                                <div
                                    style={{
                                        color: antGrey.grey7,
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        maxWidth: '100%',
                                    }}
                                >
                                    {helpMessage}
                                </div>
                                <Text
                                    style={{
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        maxWidth: '100%',
                                    }}
                                    type="warning"
                                >
                                    {warningMessage}
                                </Text>
                            </>
                        :   helpMessage,
                    renderField: (data) => {
                        return (
                            <Select style={{ width: '100%' }} onChange={(value) => onSelectAutoSubmitStrategy(value)}>
                                {data.map((option) => {
                                    return (
                                        <Select.Option value={option.value} key={option.value}>
                                            {option.displayValue}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        );
                    },
                    data: AllAutoSubmitStrategies.map((strategy) => {
                        return {
                            value: strategy,
                            displayValue: displayTextForAutoSubmitStrategy(strategy),
                        };
                    }),
                    rules: [],
                },
                ...buildAutoReleaseAndAutoSubmitRequiredStepsFields(
                    submitReleaseAutomation,
                    appId,
                    platform,
                    appStoreType,
                    {
                        fieldKeyPrefix: 'primaryRequiredSteps',
                        submitStrategyFieldName: 'submitStrategy',
                        shouldUseCustomRequiredStepsFieldName: 'shouldUseCustomRequiredSteps',
                        customRequiredStepsFieldNamePrefix: ['customRequiredSteps'],
                        releaseTypesFieldName: 'primaryReleaseTypes',
                        shouldUseCustomRequiredStepsInitialValue:
                            submitReleaseAutomation.data?.shouldUseCustomRequiredSteps,
                        customRequiredStepsInitialValue: submitReleaseAutomation.data?.customRequiredSteps,
                    },
                ),
                // For app stores that support phased release (e.g., Google, Huawei) but do not support auto-release,
                // we show the checkbox in the auto-submit automation (not auto-release).
                ...(hasSupportForPhasedRelease(appStoreType) && !hasSupportForAutoRelease(appStoreType) ?
                    [buildPreviousReleaseRolloutFields('auto-submit', submitReleaseAutomation.data, form)]
                :   []),
            ];

            if (shouldShowReleaseToFullPercentageCheckboxOption) {
                const testingTrack = (betaTesting as IntegrationGoogleBeta)?.data?.testingTrack;

                const BoldText = ({ text }) => <strong>{text}</strong>;
                BoldText.propTypes = {
                    text: PropTypes.string.isRequired,
                };
                const betaTrackName = testingTrack ? <BoldText text={testingTrack} /> : 'default beta';

                const data = (
                    <>
                        {'Release to 100% on the '}
                        {betaTrackName}
                        {' track prior to submission'}
                    </>
                );
                return [
                    ...baseFieldAndSubmitField,
                    {
                        label: '',
                        data: data,
                        name: 'shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission',
                        fieldType: FieldType.Checkbox,
                        initialValue:
                            submitReleaseAutomation.data?.shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission ??
                            false,
                        rules: [],
                    },
                ];
            }

            return baseFieldAndSubmitField;
        }
        case AutomationType.AutoCreateReleaseChannels: {
            const autoCreateReleaseChannels = automation as AutomationAutoCreateReleaseChannels;
            const autoArchiveChannelConfig = {
                label: '',
                data: (
                    <div>
                        Archive release channels when the release rollout is complete
                        <Tooltip title="Release-specific channels will be automatically archived once the release is rolled out to 100% of users.">
                            <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                        </Tooltip>
                    </div>
                ),
                initialValue: autoCreateReleaseChannels.data?.archiveChannelsWhenReleaseCompleted ?? false,
                name: 'archiveChannelsWhenReleaseCompleted',
                fieldType: FieldType.Checkbox,
                rules: [],
            };

            const autoAddUsersConfig = {
                label: 'Auto-add users',
                initialValue: autoCreateReleaseChannels.data?.inviteUsers ?? [],
                data: appUsers.map((user) => {
                    return user.email;
                }),
                name: 'inviteUsers',
                fieldType: FieldType.Custom,

                renderField: (data: string[]) => {
                    return (
                        <Select style={{ width: '100%' }} allowClear mode="multiple" placeholder="Select">
                            {data.map((email, index) => {
                                return (
                                    <Select.Option value={email} key={index}>
                                        {email}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    );
                },
                rules: [],
            };

            const autoAddGroupsConfig = {
                label: 'Auto-add user groups',
                initialValue: autoCreateReleaseChannels.data?.inviteGroups ?? [],
                data: Object.keys(orgUserGroups),
                name: 'inviteGroups',
                fieldType: FieldType.Custom,

                renderField: (data: UserGroupId[]) => {
                    return (
                        <Select style={{ width: '100%' }} allowClear mode="multiple" placeholder="Select">
                            {data.map((groupId, index) => {
                                const group = orgUserGroups[groupId];
                                return (
                                    <Select.Option value={groupId} key={index}>
                                        {displayTextForUserChecklistGroup(group)}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    );
                },
                rules: [],
            };

            if (!notificationsProvider || notificationsProvider.type !== IntegrationProviderType.AzureActiveDirectory) {
                return [...baseFields, autoArchiveChannelConfig, autoAddUsersConfig, autoAddGroupsConfig];
            }

            const teamsProvider = notificationsProvider as IntegrationProviderAzureActiveDirectory;
            const teamId = autoCreateReleaseChannels.data?.teamId;
            const channelLayoutType =
                autoCreateReleaseChannels.data?.channelLayoutType || MicrosoftTeamsChannelLayoutType.Post;
            const channelMembershipType =
                autoCreateReleaseChannels.data?.channelMembershipType || MicrosoftTeamsChannelMembershipType.Standard;
            return [
                ...baseFields,
                {
                    label: (
                        <span>
                            Team
                            <span style={{ marginLeft: 4 }}>
                                <TooltipInfoIcon tooltipContent="The Team that new release channels will be created in" />
                            </span>
                        </span>
                    ),
                    initialValue: teamId,
                    data: teamsProvider.data?.availableTeams ?? [],
                    name: 'teamId',
                    fieldType: FieldType.Custom,
                    renderField: (data: AzureActiveDirectoryTeam[]) => {
                        return (
                            <Select style={{ width: '100%' }}>
                                {data.map((team) => {
                                    return (
                                        <Select.Option value={team.id} key={team.id}>
                                            {team.name}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        );
                    },
                    rules: [{ required: true }],
                },
                {
                    label: (
                        <span>
                            Channel layout
                            <span style={{ marginLeft: 4 }}>
                                <TooltipInfoIcon
                                    tooltipContent={
                                        <>
                                            <b>Posts:</b> Reorder by most recent reply. Best for forums and
                                            announcements.
                                            <br /> <br />
                                            <b>Threads:</b> Chat with replies on the side. Best for discussions.
                                        </>
                                    }
                                />
                            </span>
                        </span>
                    ),
                    initialValue: channelLayoutType,
                    name: 'channelLayoutType',
                    fieldType: FieldType.Custom,
                    renderField: () => {
                        return (
                            <Select style={{ width: '100%' }} placeholder="Select">
                                {Object.values(MicrosoftTeamsChannelLayoutType).map((type) => (
                                    <Select.Option value={type} key={type}>
                                        {MicrosoftTeamsChannelLayoutTypeDisplayNames[type]}
                                    </Select.Option>
                                ))}
                            </Select>
                        );
                    },
                    rules: [{ required: true }],
                },
                {
                    label: (
                        <span>
                            Channel privacy
                            <span style={{ marginLeft: 4 }}>
                                <TooltipInfoIcon
                                    tooltipContent={
                                        <>
                                            <b>Standard:</b> Visible to everyone in the Team. Microsoft Teams does not
                                            allow adding users to standard channels, so the auto-add settings below have
                                            no effect.
                                            <br /> <br />
                                            <b>Private:</b> Only visible to channel members. Runway will add the users
                                            and mapped user groups selected below.
                                        </>
                                    }
                                />
                            </span>
                        </span>
                    ),
                    initialValue: channelMembershipType,
                    name: 'channelMembershipType',
                    fieldType: FieldType.Custom,
                    renderField: () => {
                        return (
                            <Select style={{ width: '100%' }} placeholder="Select">
                                {Object.values(MicrosoftTeamsChannelMembershipType).map((type) => (
                                    <Select.Option value={type} key={type}>
                                        {MicrosoftTeamsChannelMembershipTypeDisplayNames[type]}
                                    </Select.Option>
                                ))}
                            </Select>
                        );
                    },
                    rules: [{ required: true }],
                },
                autoArchiveChannelConfig,
                autoAddUsersConfig,
                autoAddGroupsConfig,
            ];
        }

        case AutomationType.AutoResignRollbackBuild:
            return [
                {
                    helpMessage: baseFieldHelpMessage,
                    fieldType: FieldType.Custom,
                    renderField: () => {
                        return null;
                    },
                },
            ];
        case AutomationType.AutoPrepareRollbackRelease:
            return generatePrepareRollbackFields(
                baseField,
                automation,
                appStoreType,
                connectedCapabilities,
                stabilityIntegrations,
                platform,
                monitoringMetrics,
                createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.HealthMetrics),
                resigningStrategy,
                onSelectResigningStrategy,
                rebuildByCIUnavailableReason,
            );
        case AutomationType.BAAutoUploadBinaryArtifactToAppStore: {
            if (!artifactUploadOptions) {
                return [];
            }

            if (artifactUploadOptions.appIdentifiers.size > 0) {
                const isCustomCI = artifactUploadOptions.buildSystem?.id === IntegrationType.CustomCI;

                return generateAutoUploadBinaryArtifactToAppStoreFields(
                    baseField,
                    automation,
                    platform,
                    appStoreType,
                    artifactUploadOptions.destinationOptions,
                    null,
                    isCustomCI,
                );
            } else {
                return [
                    {
                        ...baseField,
                        disabled: true,
                    },
                    {
                        name: 'ciCdMessage',
                        showDivider: true,
                        fieldType: FieldType.Custom,
                        renderField: () => {
                            const platformIdentifier = identifierForAppPlatform(platform);
                            const message = `A Beta Testing or App Store ${platformIdentifier} must be configured in order to enable this automation. Configure by visiting Beta and/or App Store integration settings.`;
                            return <Text style={{ color: antGrey.grey7 }}>{message}</Text>;
                        },
                    },
                ];
            }
        }
        case AutomationType.BAAutoTriggerBuildSystemWorkflow: {
            const autoTriggerWorfklow = automation as AutomationBAAutoTriggerBuildSystemWorkflow;
            const timedTriggerEveryNHours = autoTriggerWorfklow.data?.timedTriggerEveryNHours ?? 12;
            const fields = [
                ...baseFields,
                {
                    fieldType: FieldType.Custom,
                    data: [
                        {
                            label: 'Smart mode – trigger based on bucket configuration',
                            value: TriggerWorkflowOption.SmartMode,
                        },
                        {
                            label: 'Trigger workflow every N hours',
                            value: TriggerWorkflowOption.TriggerEveryNHours,
                        },
                    ],
                    renderField: (data) => {
                        return (
                            <Select
                                options={data}
                                placeholder="Select"
                                style={{ width: '100%' }}
                                onChange={(value) => onSelectTriggerWorkflowOption(value as TriggerWorkflowOption)}
                            />
                        );
                    },
                    initialValue: triggerWorkflowOption ?? TriggerWorkflowOption.SmartMode,
                    label: 'Trigger workflow strategy',
                    name: 'triggerStrategy',
                    required: true,
                    rules: [{ required: true }],
                },
            ];

            if (triggerWorkflowOption === TriggerWorkflowOption.TriggerEveryNHours) {
                fields.push({
                    label: 'Trigger workflow every N hours',
                    fieldType: FieldType.Custom,
                    name: 'timedTriggerEveryNHours',
                    renderField: () => {
                        return (
                            <InputNumber
                                min={1}
                                max={168}
                                precision={0}
                                type="number"
                                addonAfter="hours"
                                defaultValue={timedTriggerEveryNHours}
                            />
                        );
                    },
                    initialValue: timedTriggerEveryNHours,
                    required: true,
                    rules: [{ required: true }],
                });
            }

            return fields;
        }
        case AutomationType.BAAutoAssignBetaBuilds: {
            const autoAssignBetaBuildsAutomation = automation as
                | AutomationAssignBetaBuildGroups
                | AutomationBAAssignBetaBuildGroups;

            const selectBetaGroupField = (() => {
                if (!betaTesting || !betaTestingProvider) {
                    return buildDisabledBetaGroupField();
                }

                switch (betaTesting.id) {
                    case IntegrationType.TestFlight:
                        return buildTestFlightBetaGroupField(
                            betaTesting,
                            betaTestingProvider as IntegrationProviderApple,
                            autoAssignBetaBuildsAutomation.data?.selectedBetaGroupIds ?? [],
                        );
                    case IntegrationType.FirebaseBeta:
                        return buildFirebaseBetaGroupField(
                            betaTesting,
                            betaTestingProvider as IntegrationProviderGoogle,
                            autoAssignBetaBuildsAutomation.data?.selectedBetaGroupIds ?? [],
                        );
                    default:
                        return null;
                }
            })();
            return selectBetaGroupField ? [...baseFields, selectBetaGroupField] : [...baseFields];
        }
        case AutomationType.AutoApplyReviewAttachments: {
            const currentlyUploadedReviewAttachment = useSelector((state: RootState) =>
                selectDefaultReviewAttachmentFromAutomation(state, appId, automation.id),
            );

            return generateAutoApplyReviewAttachmentsFields(
                baseField,
                appId,
                orgId,
                currentlyUploadedReviewAttachment,
                automation.stepConfigId,
            );
        }
        case AutomationType.BAAutoUpdatePRWithArtifactLink: {
            const baAutoUpdatePRWithArtifactLinkAutomation = automation as AutomationBAAutoUpdatePRWithArtifactLink;
            return [
                ...baseFields,
                {
                    label: 'Commenting method',
                    name: 'prCommentStrategy',
                    fieldType: FieldType.Select,
                    initialValue:
                        baAutoUpdatePRWithArtifactLinkAutomation.data?.prCommentStrategy ??
                        PRCommentStrategy.UpdateExisting,
                    data: [
                        {
                            value: PRCommentStrategy.CreateNew,
                            displayValue: 'Post a new comment with every update',
                        },
                        {
                            value: PRCommentStrategy.UpdateExisting,
                            displayValue: 'Post a single comment and make edits with updates',
                        },
                    ],
                },
            ];
        }
        default:
            return [...baseFields];
    }
};

interface AutomationFormFieldContext {
    orgId: string;
    appId: string;
    automationType: AutomationType;
    vcsSupportsDirectPushCheck: boolean;
    platform: AppPlatform;
    appStoreType: AppStoreType;
    regressionTestingType?: IntegrationType;
}

const TEST_RUNS_FILTER_SETTINGS_KEY = 'testRunsFilterSettings';
const TEST_PLANS_FILTER_SETTINGS_KEY = 'testPlansFilterSettings';
const TRANSITION_NEW_TICKETS_AFTER_KICKOFF_KEY = 'transitionNewTicketsAfterKickoff';

// These editors read the app's destinations, steps or integrations from the store, which the shared renderer can't reach
const resolveAutomationFormField = (
    settingField: SettingField,
    formField: FormFieldData,
    context: AutomationFormFieldContext,
): FormFieldData | undefined => {
    if (settingField.type === SettingFieldType.DestinationOptions) {
        return { ...formField, renderField: () => <DestinationOptionsSelector appId={context.appId} /> };
    }
    if (settingField.type === SettingFieldType.RequiredSteps) {
        return {
            ...formField,
            renderField: () => (
                <RequiredStepsInput
                    appId={context.appId}
                    platform={context.platform}
                    appStoreType={context.appStoreType}
                />
            ),
        };
    }
    if (settingField.type === SettingFieldType.MilestoneStatuses) {
        return {
            ...formField,
            renderField: () => <MilestoneStatusesInput statusOptions={settingField.options ?? []} />,
        };
    }
    // The kickoff row shows this switch itself
    if (settingField.key === TRANSITION_NEW_TICKETS_AFTER_KICKOFF_KEY) {
        return { ...formField, extraFormItemProps: { ...formField.extraFormItemProps, hidden: true } };
    }
    if (settingField.key === TEST_RUNS_FILTER_SETTINGS_KEY) {
        return {
            ...formField,
            initialValue: formField.initialValue?.length ? formField.initialValue : [{}],
            renderField: () => (
                <AutoCreateTestRuns.TestRunsFilterSettings
                    rootFieldName={TEST_RUNS_FILTER_SETTINGS_KEY}
                    integrationType={context.regressionTestingType}
                />
            ),
        };
    }
    if (settingField.key === TEST_PLANS_FILTER_SETTINGS_KEY) {
        return {
            ...formField,
            initialValue: formField.initialValue?.length ? formField.initialValue : [{}],
            renderField: () => (
                <AutoCreateTestRuns.TestPlansFilterSettings
                    rootFieldName={TEST_PLANS_FILTER_SETTINGS_KEY}
                    integrationType={context.regressionTestingType}
                />
            ),
        };
    }
    if (settingField.key === BYPASS_PULL_REQUESTS_FIELD_KEY) {
        return buildBypassPullRequestsField(formField, context);
    }
    return undefined;
};

// Definitions are shared by every automation of a type, so each fills in its own saved value; dotted keys read nested values
const withAutomationCurrentValue = (settingField: SettingField, automation: Automation): SettingField => {
    const currentValue = get(automation.data, settingField.key);
    const isUnset =
        isNil(currentValue) ||
        ([SettingFieldType.Select, SettingFieldType.Radio].includes(settingField.type) && currentValue === '');
    return isUnset ? settingField : { ...settingField, currentValue };
};

// Labels come from the issue tracker on request, so they're suggested here rather than in the definition
const withIssueTrackingLabelOptions = (settingField: SettingField, labels: string[]): SettingField =>
    settingField.type === SettingFieldType.Tags && ISSUE_TRACKING_LABEL_KEYS.includes(settingField.key) ?
        { ...settingField, options: labels.map((label) => ({ value: label, label })) }
    :   settingField;

const ISSUE_TRACKING_LABEL_KEYS = ['fixLabels', 'approvedLabels', 'rejectedLabels'];

const automationUpdateRequestDataFromValues: (
    automation: AutomationTypesWithSettings,
    values: any,
    monitoringMetrics?: AppMonitoringHealthMetric[],
    previousData?: AutomationTypesWithSettings['data'],
) => typeof automation.data = (automation, values, monitoringMetrics, previousData) => {
    switch (automation.type) {
        case AutomationType.AutoBumpVersion: {
            return {
                strategy: values.strategy,
                shouldCommitAndPushDirectlyToTargetBranch: values.shouldCommitAndPushDirectlyToTargetBranch,
                skipInvalidFiles: values.skipInvalidFiles,
                assignPrTo: values.assignPrTo,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateRunwayReleases: {
            return {
                destinations: values.destinations,
                delayUntilBackmergeMerged: values.delayUntilBackmergeMerged ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateIncidents: {
            const previousData = (automation as AutomationCreateIncidents).data;
            const unhealthyTrigger: UnhealthyMetricsTriggerConfig = {
                ...(previousData?.unhealthyMetricsTrigger ?? { enabled: false }),
                enabled: values.shouldTriggerOnUnhealthyMetrics ?? false,
                monitoringConditions: [],
                adoptionThreshold: undefined,
                phasedReleaseDayThreshold: undefined,
                stagedRolloutPercentageThreshold: undefined,
            };
            if (values.shouldTriggerOnUnhealthyMetrics) {
                if (Array.isArray(values.monitoringConditions)) {
                    unhealthyTrigger.monitoringConditions = values.monitoringConditions
                        .map(({ id }) => id)
                        .filter((id): id is string => !!id);
                }
                if (Array.isArray(values.conditions)) {
                    for (const condition of values.conditions) {
                        if (!condition?.id || condition.threshold == null) {
                            continue;
                        }
                        switch (condition.id) {
                            case MonitoringAutomationConditionType.Adoption:
                                unhealthyTrigger.adoptionThreshold = condition.threshold;
                                break;
                            case MonitoringAutomationConditionType.PhasedReleaseDay:
                                unhealthyTrigger.phasedReleaseDayThreshold = condition.threshold;
                                break;
                            case MonitoringAutomationConditionType.StagedRolloutPercentage:
                                unhealthyTrigger.stagedRolloutPercentageThreshold = condition.threshold;
                                break;
                        }
                    }
                }
            }
            const finalValues: AutomationCreateIncidentsData = {
                rolloutHaltedTrigger: {
                    ...(previousData?.rolloutHaltedTrigger ?? { enabled: false }),
                    enabled: values.shouldTriggerOnRolloutHalted ?? false,
                },
                reviewRejectionTrigger: {
                    ...(previousData?.reviewRejectionTrigger ?? { enabled: false }),
                    enabled: values.shouldTriggerOnReviewRejection ?? false,
                },
                unhealthyMetricsTrigger: unhealthyTrigger,
            };
            if (values.incidentIoSeverityId != null) {
                finalValues.integrationSpecificSettings = {
                    severityId: values.incidentIoSeverityId,
                };
            }
            if (values.pagerDutyServiceId != null || values.pagerDutyFromEmail != null) {
                finalValues.integrationSpecificSettings = {
                    serviceId: values.pagerDutyServiceId ?? '',
                    fromEmail: values.pagerDutyFromEmail ?? '',
                };
            }
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.AutoPromoteStablePhasedReleases:
        case AutomationType.AutoHaltUnstablePhasedReleases: {
            const finalValues: AutomationHaltPromotePhasedReleaseData = {
                monitoringConditions: [],
                checklistItems: [],
            };

            if (values.conditionGroups) {
                finalValues.conditionGroups = haltConditionGroupsFormValueToConfig(
                    values.conditionGroups,
                    monitoringMetrics,
                );

                return finalValues satisfies typeof automation.data;
            }

            if (values.conditions) {
                const adoptionThresholds: Record<string, number> = {};
                let legacyAdoptionThreshold: number | undefined;
                for (const condition of values.conditions) {
                    switch (condition.id) {
                        case MonitoringAutomationConditionType.Adoption:
                            if (condition.installationId) {
                                adoptionThresholds[condition.installationId] = condition.threshold;
                            } else {
                                legacyAdoptionThreshold = condition.threshold;
                            }
                            break;
                        case MonitoringAutomationConditionType.PhasedReleaseDay:
                            finalValues.phasedReleaseDayThreshold = condition.threshold;
                            break;
                        case MonitoringAutomationConditionType.StagedRolloutPercentage:
                            finalValues.stagedRolloutPercentageThreshold = condition.threshold;
                            break;
                    }
                }
                if (Object.keys(adoptionThresholds).length > 0) {
                    finalValues.adoptionThresholds = adoptionThresholds;
                } else if (legacyAdoptionThreshold !== undefined) {
                    finalValues.adoptionThreshold = legacyAdoptionThreshold;
                }
            }

            if (values.monitoringConditions) {
                finalValues.monitoringConditions = values.monitoringConditions.map(({ id }) => id);
                finalValues.metricMaxDataAgeMinutes = metricMaxDataAgeMinutesFromFormValue(
                    values.monitoringConditions,
                    monitoringMetrics,
                );
            }

            if (values.monitoringChecklistItems) {
                finalValues.checklistItems = values.monitoringChecklistItems;
            }

            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.AutoKickoffRelease: {
            return {
                allowKickoffWhenPreviousNotComplete: values.allowKickoffWhenPreviousNotComplete,
                shouldCommitAndPushDirectlyToTargetBranch: values.shouldCommitAndPushDirectlyToTargetBranch,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoTriggerCIWorkflow: {
            const triggerCIResult: AutoTriggerCIWorkflowData = {
                skipIfBuildAlreadyExists: values.skipIfBuildAlreadyExists ?? false,
            };
            if (values.conditionGroups) {
                triggerCIResult.conditionGroups = values.conditionGroups.map(
                    (group: TriggerCIWorkflowConditionGroup) => ({
                        id: group.id,
                        type: group.type,
                        ...(group.runwayPRTypes && { runwayPRTypes: group.runwayPRTypes }),
                        ...(group.relativeTimeTrigger && {
                            relativeTimeTrigger: group.relativeTimeTrigger,
                        }),
                        ...(group.completedStepsTrigger && {
                            completedStepsTrigger: group.completedStepsTrigger,
                        }),
                    }),
                );
            }
            return triggerCIResult satisfies typeof automation.data;
        }
        case AutomationType.AutoBackmergeReleaseBranches: {
            return {
                strategy: values.strategy,
                availableStrategies: automation.data?.availableStrategies ?? [], // Just to satisfy the type checker, as this comes from BE
                runwayPRTypesToSkip: values.runwayPRTypesToSkip,
                shouldBackmergeOnlyMergeCommits: values.shouldBackmergeOnlyMergeCommits,
                onlyBackmergeRunwayPRs: values.onlyBackmergeRunwayPRs,
                assignPrTo: values.assignPrTo,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyBetaBuildNotes: {
            const isCIVariable = values.strategy === BuildNotesAutomationStrategy.CIBuildVariable;
            const supportsFallback =
                betaBuildNotesStrategyUsesCIMatchedBuild(values.strategy) ||
                isAIBetaBuildNotesStrategy(values.strategy);
            return {
                strategy: values.strategy,
                ...(isCIVariable && {
                    ciBuildVariableKey: values.ciBuildVariableKey,
                }),
                ...(supportsFallback && {
                    fallbackStrategy: values.fallbackStrategy,
                }),
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoGenerateCIBuildDiffSummary: {
            return {
                showSummaryOnCIStep: values.showSummaryOnCIStep ?? false,
                notificationIdsToInclude: values.notificationIdsToInclude ?? [],
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncAppStoreUsers: {
            const roleEntries = values.rolesMap as RoleEntry[];
            const rolesMap = {};
            roleEntries.forEach((entry) => {
                const roleSyncData: RoleSyncData = { syncEnabled: entry.syncEnabled, roles: entry.appStoreRoles };

                if (!rolesMap[entry.userGroup.id]) {
                    rolesMap[entry.userGroup.id] = {};
                }

                rolesMap[entry.userGroup.id][IntegrationCapability.AppStore] = roleSyncData;
            });

            return {
                allowDeleteUsers: values.allowDeleteUsers,
                rolesMap: rolesMap,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoTagReleases: {
            return {
                fallbackToHeadIfNeeded: values.fallbackToHeadIfNeeded,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyMetadata: {
            return {
                releaseNotesSource: values.releaseNotesSource,
                promoTextSource: values.promoTextSource,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoUploadBinaryArtifactToAppStore: {
            const workflowSettings =
                values.uploadWorkflowSettings?.map((setting) => {
                    const workflowSetting: AppStoreArtifactUploadWorkflowSettings = {
                        workflowType: setting.workflowType ? setting.workflowType : WorkflowType.Staging, // we always need a WorkflowType, so default to staging if blank (for CustomCI)
                        fileNames: setting.fileNames,
                        destinationInstallationId: setting.destinationInstallationId,
                        trackName: setting.trackName ? sanitizeTrackName(setting.trackName) : null,
                        createNewTrackReleaseWithPatternedName: setting.createNewTrackReleaseWithPatternedName,
                    };
                    return workflowSetting;
                }) ?? [];

            const finalValues = {
                uploadWorkflowSettings: workflowSettings,
                uploadRule: values.uploadRule,
            };
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.AutoUploadDsymsToStabilityMonitoring: {
            const workflowSettings = values.uploadWorkflowSettings.map((setting) => {
                const workflowSetting: DsymsUploadWorkflowSettings = {
                    workflowType: setting.workflowType,
                    fileNames: [setting.fileName.trim() ?? `{*}.dSYM.zip`],
                    stabilityMonitoringInstallationIds: setting.stabilityMonitoringInstallationIds ?? [],
                };
                return workflowSetting;
            });

            return {
                uploadWorkflowSettings: workflowSettings,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSelectLatestBuild: {
            const track = values.track ? sanitizeTrackName(values.track) : null;
            const strategy = values.strategy;
            const regressionStepsToConsider = values.regressionStepsToConsider;
            const updateTrackReleaseWithPatternedName = values.updateTrackReleaseWithPatternedName;
            return {
                track,
                strategy,
                regressionStepsToConsider,
                updateTrackReleaseWithPatternedName,
                shouldRequireBuildMatch: values.shouldRequireBuildMatch ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCherryPickFromWorkingBranch: {
            const previousCherryPickData =
                (previousData as AutomationCherryPickFromWorkingBranch['data'] | undefined) ?? automation.data;
            return {
                tokens: previousCherryPickData?.tokens,
                strategy: values.strategy,
                shouldNotifyPRAuthors: values.shouldNotifyPRAuthors,
                allowFixesWithToken: previousCherryPickData?.allowFixesWithToken ?? false,
                requiresFixApprovalToCherryPick: values.requiresFixApprovalToCherryPick,
                skipPostingPRCommentsOnCherryPickSuccess: values.skipPostingPRCommentsOnCherryPickSuccess,
                skipPostingPRCommentsOnCherryPickMergeConflicts: values.skipPostingPRCommentsOnCherryPickMergeConflicts,
                matchTokenOn: previousCherryPickData?.matchTokenOn,
                assignPrTo: values.assignPrTo,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoPullSubmissionFromReview: {
            return {
                pullOnReleaseSkipped: values.pullOnReleaseSkipped ?? false,
                pullOnFixOrFixRequestAccepted: values.pullOnFixOrFixRequestAccepted ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSubmitRelease: {
            return {
                submitStrategy: values.submitStrategy,
                shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission:
                    values.shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission,
                shouldReleasePreviousSubmissionToAllUsersFirst: values.shouldReleasePreviousSubmissionToAllUsersFirst,
                shouldWaitForPreviousReleaseToBeFullyRolledOut: values.shouldWaitForPreviousReleaseToBeFullyRolledOut,
                shouldUseCustomRequiredSteps: values.shouldUseCustomRequiredSteps,
                customRequiredSteps: values.customRequiredSteps,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoRelease: {
            return {
                strategy: values.strategy,
                shouldReleasePreviousSubmissionToAllUsersFirst: values.shouldReleasePreviousSubmissionToAllUsersFirst,
                shouldWaitForPreviousReleaseToBeFullyRolledOut: values.shouldWaitForPreviousReleaseToBeFullyRolledOut,
                shouldUseCustomRequiredSteps: values.shouldUseCustomRequiredSteps,
                customRequiredSteps: values.customRequiredSteps,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateReleaseChannels:
            return {
                teamId: values.teamId,
                channelLayoutType: values.channelLayoutType,
                channelMembershipType: values.channelMembershipType,
                archiveChannelsWhenReleaseCompleted: values.archiveChannelsWhenReleaseCompleted,
                inviteGroups: values.inviteGroups,
                inviteUsers: values.inviteUsers,
            } satisfies typeof automation.data;
        case AutomationType.AutoSyncSlackPilotUserGroup:
            return {
                userGroupHandle: values.userGroupHandle ?? '',
                shouldWaitUntilNextReleaseIsKickedOff: values.shouldWaitUntilNextReleaseIsKickedOff ?? false,
            } satisfies typeof automation.data;
        case AutomationType.AutoSyncTeamsPilotTag:
            return {
                tagName: values.tagName ?? '',
                shouldWaitUntilNextReleaseIsKickedOff: values.shouldWaitUntilNextReleaseIsKickedOff ?? false,
            } satisfies typeof automation.data;
        case AutomationType.AutoStagedRollout: {
            const parsedTime = dayjs(values.autoStagedRolloutCustomHour);
            const autoStagedRolloutCustomHour = parsedTime.isValid() ? parsedTime.hour() : undefined;
            const autoStagedRolloutStartStrategy =
                values.autoStagedRolloutStartStrategy ??
                (automation as AutomationAutoStagedRollout).data?.autoStagedRolloutStartStrategy ??
                AndroidAutoRolloutStartStrategy.Manual;
            return {
                daysToPercent: values.daysToPercent?.map((dayToPercent) => {
                    return Number(dayToPercent);
                }),
                autoStagedRolloutBlackoutSegmentsByDay: encodeAutoStagedRolloutBlackoutSegmentsByDay(
                    values.autoStagedRolloutBlackoutSegmentsByDay,
                    values.autoStagedRolloutBlackoutTimezone,
                ),
                autoStagedRolloutBlackoutTimezone: values.autoStagedRolloutBlackoutTimezone,
                autoStagedRolloutStartStrategy: autoStagedRolloutStartStrategy,
                autoStagedRolloutCustomHour: autoStagedRolloutCustomHour,
                shouldAccountBlackoutsForHoursSinceLastIncrement:
                    values.shouldAccountBlackoutsForHoursSinceLastIncrement ?? false,
                shouldAccountHaltedPeriodsForHoursSinceLastIncrement:
                    values.shouldAccountHaltedPeriodsForHoursSinceLastIncrement ?? true,
                shouldContinueIncrementingAfterManualUpdate: values.shouldContinueIncrementingAfterManualUpdate ?? true,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncAppleDevices: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncAppleProvisioningProfilesDevices: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoTransitionIssueTrackingTickets: {
            return {
                milestoneStatusOptions: values.milestoneStatusOptions ?? {},
                transitionNewTicketsAfterKickoff: values.transitionNewTicketsAfterKickoff ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoDistributeReleaseSummary:
            return {
                emailAddresses: values.emailAddresses,
            } satisfies typeof automation.data;
        case AutomationType.AutoCherryPickLocalizableStrings: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncTranslations: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncMetadataTranslations: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncMetadataFromVCS: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoPrepareRollbackRelease: {
            const finalValues: AutomationPrepareRollbackReleaseData = {
                abandonRollbackMonitoringConditions:
                    values.monitoringConditions ? values.monitoringConditions.map(({ id }) => id) : [],
                shouldAutoSubmit: values.shouldAutoSubmit,
                strategy: values.strategy,
            };
            if (values.conditions) {
                const abandonRollbackAdoptionThresholds: Record<string, number> = {};
                let legacyAbandonRollbackAdoptionThreshold: number | undefined;
                for (const condition of values.conditions) {
                    switch (condition.id) {
                        case MonitoringAutomationConditionType.Adoption:
                            if (condition.installationId) {
                                abandonRollbackAdoptionThresholds[condition.installationId] = condition.threshold;
                            } else {
                                legacyAbandonRollbackAdoptionThreshold = condition.threshold;
                            }
                            break;
                        case MonitoringAutomationConditionType.PhasedReleaseDay:
                            finalValues.abandonRollbackPhasedReleaseDayThreshold = condition.threshold;
                            break;
                        case MonitoringAutomationConditionType.StagedRolloutPercentage:
                            finalValues.abandonRollbackStagedRolloutPercentageThreshold = condition.threshold;
                            break;
                    }
                }
                if (Object.keys(abandonRollbackAdoptionThresholds).length > 0) {
                    finalValues.abandonRollbackAdoptionThresholds = abandonRollbackAdoptionThresholds;
                } else if (legacyAbandonRollbackAdoptionThreshold !== undefined) {
                    finalValues.abandonRollbackAdoptionThreshold = legacyAbandonRollbackAdoptionThreshold;
                }
            }
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.BAAutoUploadBinaryArtifactToAppStore: {
            const workflowSettings =
                values.uploadWorkflowSettings?.map((setting) => {
                    const workflowSetting: AppStoreArtifactUploadWorkflowSettings = {
                        workflowType: setting.workflowType,
                        fileNames: setting.fileNames,
                        destinationInstallationId: setting.destinationInstallationId,
                        trackName: setting.trackName ? sanitizeTrackName(setting.trackName) : null,
                        createNewTrackReleaseWithPatternedName: setting.createNewTrackReleaseWithPatternedName,
                    };
                    return workflowSetting;
                }) ?? [];

            const finalValues = {
                uploadWorkflowSettings: workflowSettings,
                uploadRule: values.uploadRule,
            };
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.BAAutoTriggerBuildSystemWorkflow: {
            return {
                timedTriggerEveryNHours: values.timedTriggerEveryNHours ?? null,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateTestRuns: {
            return {
                strategy: values.strategy,
                testPlansFilterSettings: values.testPlansFilterSettings,
                testRunsFilterSettings: values.testRunsFilterSettings,
                allowCreationWithoutPreviousMatch: values.allowCreationWithoutPreviousMatch ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoAssignBetaBuilds:
        case AutomationType.BAAutoAssignBetaBuilds: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyReviewAttachments: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoPromoteBuildsToTestTrack: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoAddMissingFAs: {
            return {
                safeMode: (automation as AutomationAutoAddMissingFAs).data?.safeMode ?? false,
                withComponents: (automation as AutomationAutoAddMissingFAs).data?.withComponents ?? false,
                useWorkspaceLabels: values.useWorkspaceLabels ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyLabelsToFixTickets: {
            return {
                fixLabels: values.fixLabels ?? [],
                applyApprovedLabels: values.applyApprovedLabels ?? false,
                approvedLabels: values.applyApprovedLabels ? (values.approvedLabels ?? []) : [],
                applyRejectedLabels: values.applyRejectedLabels ?? false,
                rejectedLabels: values.applyRejectedLabels ? (values.rejectedLabels ?? []) : [],
                useWorkspaceLabels: values.useWorkspaceLabels ?? false,
            } satisfies typeof automation.data;
        }
        default:
            return {
                ...values,
            };
    }
};

const requiredCapabilitiesComponent = (requiredArray: IntegrationCapability[]) => {
    return (
        <Space
            wrap
            split={
                <Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    {' '}
                    or{' '}
                </Text>
            }
        >
            {requiredArray.map((capability) => {
                return (
                    <div
                        style={{
                            borderColor: runwayColors.primary,
                            borderWidth: 1,
                            borderStyle: 'solid',
                            padding: `1px 8px 1px 8px`,
                            borderRadius: 2,
                            backgroundColor: colorWithAlpha(rwColors.primary, 0.08),
                        }}
                        key={`${requiredArray[0]}-div`}
                    >
                        <Space size={8} align="center" key={capability}>
                            <Icon
                                component={iconForCapability(capability)}
                                style={{
                                    fontSize: 12,
                                    color: runwayColors.primary,
                                }}
                            />
                            <Text
                                style={{
                                    color: runwayColors.primary,
                                    fontWeight: 400,
                                }}
                            >
                                {displayNameForCapability(capability)}
                            </Text>
                        </Space>
                    </div>
                );
            })}
        </Space>
    );
};

function generateDayRow(prefix: string, day: DayOfTheWeek) {
    const isBlackedOutKey: keyof AutoStagedRolloutBlackoutDay = 'isBlackedOut';
    return (
        <Form.Item shouldUpdate noStyle>
            {(form) => {
                const isBlackedOut = form.getFieldValue([prefix, day, isBlackedOutKey]);
                return (
                    <div
                        style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                        }}
                    >
                        <Space align="center" size={10}>
                            <Form.Item name={[prefix, day, 'isBlackedOut']} noStyle valuePropName="checked">
                                <Checkbox>
                                    <Text strong={isBlackedOut}>{displayTextForDayOfTheWeek(day)}</Text>
                                </Checkbox>
                            </Form.Item>
                        </Space>

                        <Form.List name={[prefix, day, 'segments']}>
                            {(fields, { add, remove }) => (
                                <div
                                    style={{
                                        display: isBlackedOut ? 'flex' : 'none',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 8,
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 8,
                                        }}
                                    >
                                        {fields.length === 0 && (
                                            <Text
                                                type="secondary"
                                                disabled={!isBlackedOut}
                                                style={{
                                                    width: 206,
                                                }}
                                            >
                                                All day
                                            </Text>
                                        )}
                                        {fields.map((fieldData, i) => {
                                            return (
                                                <div
                                                    key={fieldData.key}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                        gap: 8,
                                                    }}
                                                >
                                                    <Form.Item
                                                        name={[fieldData.name, 'blackoutSegment']}
                                                        style={{
                                                            marginBottom: 0,
                                                        }}
                                                        rules={[
                                                            {
                                                                validator: async (_, segment) => {
                                                                    if (!isBlackedOut) {
                                                                        return Promise.resolve();
                                                                    }

                                                                    if (!segment || !segment[0] || !segment[1]) {
                                                                        return Promise.reject('Invalid segment');
                                                                    }

                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <TimePicker.RangePicker
                                                            disabled={!isBlackedOut}
                                                            placeholder={['Start', 'End']}
                                                            minuteStep={10}
                                                            order={false}
                                                            format="h:mm a"
                                                            style={{
                                                                width: 206,
                                                            }}
                                                        />
                                                    </Form.Item>
                                                    <Button
                                                        icon={
                                                            <DeleteOutlined
                                                                color={runwayColors.statusRed}
                                                                disabled={!isBlackedOut}
                                                            />
                                                        }
                                                        disabled={!isBlackedOut}
                                                        size="small"
                                                        danger
                                                        type="link"
                                                        onClick={() => remove(i)}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <Button
                                        icon={
                                            <ClockCircleOutlined
                                                color={runwayColors.primary}
                                                disabled={!isBlackedOut}
                                            />
                                        }
                                        disabled={!isBlackedOut}
                                        type="link"
                                        size="small"
                                        onClick={() => add()}
                                    >
                                        Add times
                                    </Button>
                                </div>
                            )}
                        </Form.List>
                    </div>
                );
            }}
        </Form.Item>
    );
}

const UPLOAD_BINARY_AVAILABLE_TOKENS = [
    PatternToken.Version,
    PatternToken.VersionConcise,
    PatternToken.ReleaseName,
    PatternToken.BuildCI,
    PatternToken.ReleasePilot,
    PatternToken.ReleaseBranchName,
    PatternToken.WorkingBranchName,
    PatternToken.Wildcard,
];

function generateAutoUploadBinaryArtifactToAppStoreFields(
    baseField: FormFieldData,
    automation: Automation,
    platform: AppPlatform,
    appStoreType: AppStoreType,
    destinationOptions: AppStoreArtifactUploadDestinationTypeOption[],
    buildSystemData: BaseCIIntegrationData,
    isCustomCI: boolean,
) {
    const baseFieldWithConditionsValidation = {
        ...baseField,
        rules: [
            (form) => {
                return {
                    validator: (rule, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }

                        const uploadWorkflowSettings: AppStoreArtifactUploadWorkflowSettings[] =
                            form.getFieldValue('uploadWorkflowSettings') ?? [];
                        if (uploadWorkflowSettings.length === 0) {
                            const message = 'At least one rule is required to enable this automation';
                            globalMessage.error(message);
                            return Promise.reject(message);
                        } else {
                            const stagingWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Staging;
                            });
                            const prodWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Production;
                            });
                            if (stagingWorkflowSettings.length > 2 && prodWorkflowSettings.length > 1) {
                                const message =
                                    'A maximum of one release rule and two release candidate rules are allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (stagingWorkflowSettings.length > 2) {
                                const message = 'A maximum of two release candidate rules are allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (prodWorkflowSettings.length > 1) {
                                const message = 'A maximum of one release rule is allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else {
                                // Have the correct number of rules configured, checking for duplicates
                                // TODO:RUN-10317 duplicates checking..
                                if (stagingWorkflowSettings.length === 2) {
                                    if (
                                        stagingWorkflowSettings[0].destinationInstallationId ==
                                            stagingWorkflowSettings[1].destinationInstallationId &&
                                        stagingWorkflowSettings[0].workflowType ==
                                            stagingWorkflowSettings[1].workflowType &&
                                        stagingWorkflowSettings[0].fileNames.filter(
                                            (fileName) => stagingWorkflowSettings[1].fileNames.indexOf(fileName) < 0,
                                        ).length === 0
                                    ) {
                                        const message = 'Each rule must be unique';
                                        globalMessage.error(message);
                                        return Promise.reject(message);
                                    }
                                }
                                return Promise.resolve();
                            }
                        }
                    },
                };
            },
        ],
    };

    const appStoreUploadAutomation = automation as
        | AutomationAutoUploadBinaryArtifactToAppStore
        | BAAutomationAutoUploadBinaryArtifactToAppStore;

    const isBucketAutomation = automation.type === AutomationType.BAAutoUploadBinaryArtifactToAppStore;

    const savedSettings = appStoreUploadAutomation.data?.uploadWorkflowSettings;

    const uploadRulesOptions = AllAppStoreArtifactUploadRules.map((rule) => {
        const displayText = displayTextForAppStoreUploadRule(rule);

        return {
            value: rule,
            label: displayText,
        };
    });

    return [
        baseFieldWithConditionsValidation,
        {
            label: 'Upload behavior for multiple available builds',
            name: 'uploadRule',
            fieldType: FieldType.Custom,
            showDivider: true,
            initialValue: appStoreUploadAutomation.data?.uploadRule ?? AppStoreArtifactUploadRule.UploadNewestBuildOnly,
            data: uploadRulesOptions,
            rules: [{ required: true, message: 'Upload behavior is required' }],
            renderField: () => {
                return (
                    <Select
                        placeholder="Select an upload behavior"
                        style={{
                            width: '100%',
                        }}
                    >
                        {uploadRulesOptions.map((option) => {
                            return (
                                <Select.Option value={option.value} key={option.value}>
                                    {option.label}
                                </Select.Option>
                            );
                        })}
                    </Select>
                );
            },
        },
        {
            label: null,
            name: 'uploadWorkflowSettings',
            fieldType: FieldType.List,
            showDivider: true,
            initialValue: savedSettings,
            nestedListFields: [
                {
                    fieldType: FieldType.Custom,
                    style: { margin: 0 },
                    renderField: (data) => {
                        return renderUploadWorkflowSettingsField(
                            data,
                            platform,
                            appStoreType,
                            destinationOptions,
                            isBucketAutomation,
                            isCustomCI,
                            buildSystemData,
                        );
                    },
                },
            ],
            listChildrenWrapper: (children, { add }) => {
                const buttonText = (children as React.ReactNode[]).length === 0 ? 'Add rule' : 'Add another rule';
                return (
                    <Space
                        direction="vertical"
                        style={{
                            width: '100%',
                        }}
                        size={16}
                    >
                        {children}
                        <Form.Item shouldUpdate noStyle>
                            {() => {
                                return (
                                    <>
                                        <Button
                                            disabled={false}
                                            icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                            onClick={() => add()}
                                        >
                                            {buttonText}
                                        </Button>
                                    </>
                                );
                            }}
                        </Form.Item>
                    </Space>
                );
            },
        } as FormFieldData,
    ];
}

const renderUploadWorkflowSettingsField: (
    data: any,
    platform: AppPlatform,
    appStoreType: AppStoreType,
    destinationOptions: AppStoreArtifactUploadDestinationTypeOption[],
    isBucketAutomation,
    isCustomCI,
    buildSystemData?: BaseCIIntegrationData,
) => React.ReactNode = (
    { index, listOperations: { remove }, listFieldData },
    platform,
    appStoreType,
    destinationOptions,
    isBucketAutomation,
    isCustomCI,
    buildSystemData,
) => {
    const needsWorkflowInfo = buildSystemData && !isBucketAutomation && !isCustomCI;
    const workflowOptions: AppStoreArtifactUploadWorkflowOption[] = [];

    if (needsWorkflowInfo) {
        if (buildSystemData.workflowName) {
            const stagingWorkflow: AppStoreArtifactUploadWorkflowOption = {
                id: WorkflowType.Staging,
                workflowDescription: 'Release candidate workflow',
                workflowName: buildSystemData.workflowName,
            };
            workflowOptions.push(stagingWorkflow);
        }
        if (buildSystemData.prodWorkflowName) {
            const prodWorkflow: AppStoreArtifactUploadWorkflowOption = {
                id: WorkflowType.Production,
                workflowDescription: 'Release workflow',
                workflowName: buildSystemData.prodWorkflowName,
            };
            workflowOptions.push(prodWorkflow);
        }
    }

    const appStoreTypesSupportingMultiUploads = [AppStoreType.Google];
    const supportsMultiUploads = appStoreTypesSupportingMultiUploads.includes(appStoreType);

    const filePlaceholder = placeholderForFileTypePlatform(platform, appStoreType);

    return (
        <Form.Item
            shouldUpdate
            noStyle
            style={{
                width: '100%',
            }}
        >
            {(form) => {
                const selectedDestinationInstallationId =
                    form.getFieldValue('uploadWorkflowSettings')?.[index]?.destinationInstallationId ?? '';

                // Firebase App Distribution has no tracks, so its upload ignores both track fields.
                const isFirebaseDestination =
                    getIntegrationTypeForInstallationId(selectedDestinationInstallationId) ===
                    IntegrationType.FirebaseBeta;

                return (
                    <>
                        <Space
                            direction="vertical"
                            style={{
                                width: '100%',
                                backgroundColor: antGrey.grey2,
                                borderRadius: 8,
                                padding: '20px 30px',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: 16,
                                }}
                            >
                                <Text strong style={{ fontSize: 16 }}>
                                    Rule {index + 1}
                                </Text>
                                <Button
                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                    danger
                                    type="link"
                                    onClick={() => remove(index)}
                                />
                            </div>
                            {needsWorkflowInfo && (
                                <Form.Item
                                    label="Workflow"
                                    style={{
                                        width: '100%',
                                    }}
                                    {...listFieldData}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select a workflow',
                                            type: 'string',
                                        },
                                    ]}
                                    required
                                    name={[listFieldData.name, 'workflowType']}
                                >
                                    <Select
                                        placeholder="Select a workflow"
                                        style={{
                                            width: '100%',
                                        }}
                                    >
                                        {workflowOptions.map((option) => {
                                            return (
                                                <Select.Option value={option.id} key={option.id}>
                                                    {option.workflowDescription}{' '}
                                                    <Text style={{ color: antGrey.grey7 }}>
                                                        — {option.workflowName}
                                                    </Text>
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                            )}
                            {!isBucketAutomation && (
                                <Form.Item
                                    label="File name"
                                    {...listFieldData}
                                    extra={
                                        <Space>
                                            {' '}
                                            <Text style={{ color: antGrey.grey7 }}>
                                                {!supportsMultiUploads ?
                                                    'The file name of the artifact that will be uploaded to the target destination for this rule.'
                                                :   'The file name(s) of the artifact(s) that will be uploaded to the target destination for this rule.'
                                                }
                                                Tokenized patterns and wildcards are supported.
                                            </Text>{' '}
                                            <Popover
                                                content={
                                                    <PatternTokenHelperTextComponent
                                                        availableTokens={UPLOAD_BINARY_AVAILABLE_TOKENS}
                                                    />
                                                }
                                            >
                                                <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
                                            </Popover>
                                        </Space>
                                    }
                                    rules={
                                        !supportsMultiUploads ?
                                            [
                                                {
                                                    required: true,
                                                },
                                                {
                                                    required: true,
                                                    type: 'array',
                                                    validator: (_, fileNames) => {
                                                        if (!Array.isArray(fileNames)) {
                                                            return Promise.reject('Must provide one valid filename');
                                                        }
                                                        if (fileNames.length > 1) {
                                                            return Promise.reject('Only one filename allowed.');
                                                        }
                                                        for (const fileName of fileNames) {
                                                            const [isAcceptableFileName, msg] =
                                                                validateFileNameForAppStoreType(fileName, appStoreType);
                                                            if (isAcceptableFileName) {
                                                                return Promise.resolve();
                                                            } else {
                                                                return Promise.reject(msg);
                                                            }
                                                        }
                                                        return Promise.reject('Must provide one valid filename');
                                                    },
                                                },
                                            ]
                                        :   [
                                                {
                                                    required: true,
                                                },
                                                {
                                                    required: true,
                                                    validator: (_, fileNames) => {
                                                        for (const fileName of fileNames) {
                                                            const [isAcceptableFileName, msg] =
                                                                validateFileNameForAppStoreType(fileName, appStoreType);
                                                            if (isAcceptableFileName) {
                                                                return Promise.resolve();
                                                            } else {
                                                                return Promise.reject(msg);
                                                            }
                                                        }
                                                        return Promise.reject(
                                                            'Must provide at least one valid filename',
                                                        );
                                                    },
                                                },
                                            ]
                                    }
                                    name={[listFieldData.name, 'fileNames']}
                                >
                                    <Select
                                        mode="tags"
                                        allowClear
                                        tokenSeparators={[',', '\n']}
                                        dropdownStyle={{ display: 'none' }}
                                        style={{ width: '100%' }}
                                        placeholder={filePlaceholder}
                                    />
                                </Form.Item>
                            )}
                            <Form.Item
                                label="Destination"
                                required
                                shouldUpdate
                                {...listFieldData}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a destination',
                                        type: 'string',
                                    },
                                ]}
                                name={[listFieldData.name, 'destinationInstallationId']}
                                extra={`The target destination for the artifact defined by this rule. Destination options are determined by your app's app store and beta integrations.${
                                    appStoreType === AppStoreType.Amazon ?
                                        `Runway will replace the APK with the highest version code in the current
                                           edit in the Amazon Developer Portal with the defined artifact.`
                                    : appStoreType === AppStoreType.Huawei ?
                                        'Uploading a build will also select it for submission in Huawei AppGallery.'
                                    : appStoreType === AppStoreType.Samsung ?
                                        'Uploading a build will also select it for submission in the Samsung Galaxy Store.'
                                    :   ''
                                }`}
                            >
                                <Select
                                    placeholder="Select a destination"
                                    style={{
                                        flex: 1,
                                        width: '100%',
                                    }}
                                >
                                    {destinationOptions.map((option) => {
                                        let disabled = false;
                                        if (
                                            form.getFieldValue('uploadWorkflowSettings')?.[index]?.workflowType ==
                                                WorkflowType.Production &&
                                            option.type == AppStoreArtifactUploadDestinationType.DestinationBetaTesting
                                        ) {
                                            disabled = true;
                                        }
                                        const destinationAlias = option.alias?.trim();

                                        return (
                                            <Select.Option value={option.id} key={option.id} disabled={disabled}>
                                                {option.name}
                                                {destinationAlias && (
                                                    <Text style={{ color: antGrey.grey7 }}> {destinationAlias}</Text>
                                                )}
                                                <Text style={{ color: antGrey.grey7 }}> — </Text>
                                                {option.identifier}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                            {appStoreType === AppStoreType.Google && (
                                <Form.Item
                                    label="Track"
                                    shouldUpdate
                                    {...listFieldData}
                                    name={[listFieldData.name, 'trackName']}
                                    extra="Builds will be added to the track and released to all users immediately."
                                    rules={[
                                        (form) => {
                                            return {
                                                validator: (_, selectedTrack) => {
                                                    const selectedDestinationInstallId =
                                                        form.getFieldValue('uploadWorkflowSettings')?.[index]
                                                            ?.destinationInstallationId;
                                                    const selectedDestination = destinationOptions.find(
                                                        (option) =>
                                                            !!selectedDestinationInstallId &&
                                                            option.id === selectedDestinationInstallId,
                                                    );
                                                    if (
                                                        selectedDestination &&
                                                        selectedDestination.type ===
                                                            AppStoreArtifactUploadDestinationType.DestinationAppStore &&
                                                        selectedTrack === 'production'
                                                    ) {
                                                        return Promise.reject(
                                                            `The production track cannot be selected with the ${selectedDestination.name} destination.`,
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            };
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a track"
                                        style={{
                                            width: '100%',
                                        }}
                                        allowClear
                                        disabled={isFirebaseDestination}
                                    >
                                        {destinationOptions.map((option) => {
                                            if (
                                                form.getFieldValue('uploadWorkflowSettings')?.[index]
                                                    ?.destinationInstallationId === option.id
                                            ) {
                                                const trackNames = option.availableTracks;
                                                return (
                                                    trackNames &&
                                                    trackNames.map((track) => {
                                                        return (
                                                            <Select.Option value={track} key={track}>
                                                                {track}
                                                            </Select.Option>
                                                        );
                                                    })
                                                );
                                            }
                                            return null;
                                        })}
                                    </Select>
                                </Form.Item>
                            )}
                            {appStoreType === AppStoreType.Google && (
                                <Form.Item
                                    label="Create new track release with name"
                                    shouldUpdate
                                    {...listFieldData}
                                    name={[listFieldData.name, 'createNewTrackReleaseWithPatternedName']}
                                    extra="Optionally create a new track release per upload using the supplied naming pattern. If left blank, Runway will use an existing track release matching the version in question."
                                    rules={[
                                        {
                                            validator: (rule, value) => {
                                                if (!value) {
                                                    return Promise.resolve();
                                                }

                                                const pattern = value as string;

                                                return validatePattern(
                                                    pattern,
                                                    'Release name',
                                                    RequireAtLeastOneOfTokensForAndroidTrackReleaseName,
                                                    disallowedTokensForForAndroidTrackReleaseName(),
                                                );
                                            },
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="e.g. {version}.{appStoreBuildNumber}"
                                        autoComplete="off"
                                        allowClear
                                        disabled={isFirebaseDestination}
                                    />
                                </Form.Item>
                            )}
                        </Space>
                    </>
                );
            }}
        </Form.Item>
    );
};

function generateAutoUploadDsymsToStabilityMonitoringFields(
    baseField: FormFieldData,
    automation: Automation,
    buildSystemData: BaseCIIntegrationData,
    destinationOptions: DsymUploadDestinationOption[],
) {
    const baseFieldWithConditionsValidation = {
        ...baseField,
        rules: [
            (form) => {
                return {
                    validator: (rule, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }

                        const uploadWorkflowSettings: DsymsUploadWorkflowSettings[] =
                            form.getFieldValue('uploadWorkflowSettings') ?? [];
                        if (uploadWorkflowSettings.length === 0) {
                            const message = 'At least one setting is required to enable this automation';
                            globalMessage.error(message);
                            return Promise.reject(message);
                        } else {
                            const stagingWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Staging;
                            });
                            const prodWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Production;
                            });
                            if (stagingWorkflowSettings.length > 1 && prodWorkflowSettings.length > 1) {
                                const message =
                                    'A maximum of one release and one release candidate settings are allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (stagingWorkflowSettings.length > 1) {
                                const message = 'A maximum of one release candidate setting is allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (prodWorkflowSettings.length > 1) {
                                const message = 'A maximum of one release setting is allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else {
                                return Promise.resolve();
                            }
                        }
                    },
                };
            },
        ],
    };

    const workflowOptions: DsymsUploadWorkflowOption[] = [];
    if (buildSystemData) {
        if (buildSystemData.workflowName) {
            const stagingWorkflow: DsymsUploadWorkflowOption = {
                id: WorkflowType.Staging,
                workflowDescription: 'Release candidate workflow',
                workflowName: buildSystemData.workflowName,
            };
            workflowOptions.push(stagingWorkflow);
        }
        if (buildSystemData.prodWorkflowName) {
            const prodWorkflow: DsymsUploadWorkflowOption = {
                id: WorkflowType.Production,
                workflowDescription: 'Release workflow',
                workflowName: buildSystemData.prodWorkflowName,
            };
            workflowOptions.push(prodWorkflow);
        }
    }

    const dsymsUploadAutomation = automation as AutomationAutoUploadDsymsToStabilityMonitoring;
    const savedSettings = dsymsUploadAutomation.data?.uploadWorkflowSettings;
    const defaultStabilityMonitoringInstallationIds = destinationOptions.map((option) => option.installationId);
    const uploadSettingsFields = [];
    if (savedSettings) {
        savedSettings.forEach((setting) => {
            uploadSettingsFields.push({
                workflowType: setting.workflowType,
                fileName: setting.fileNames?.[0] ?? `{*}.dSYM.zip`,
                stabilityMonitoringInstallationIds:
                    setting.stabilityMonitoringInstallationIds ?? defaultStabilityMonitoringInstallationIds,
            });
        });
    } else {
        uploadSettingsFields.push({
            workflowType: null,
            fileName: `{*}.dSYM.zip`,
            stabilityMonitoringInstallationIds: defaultStabilityMonitoringInstallationIds,
        });
    }

    const availableTokens: PatternToken[] = [
        PatternToken.Version,
        PatternToken.VersionConcise,
        PatternToken.ReleaseName,
        PatternToken.BuildCI,
        PatternToken.ReleasePilot,
        PatternToken.ReleaseBranchName,
        PatternToken.WorkingBranchName,
        PatternToken.Wildcard,
    ];

    return [
        baseFieldWithConditionsValidation,
        {
            label: null,
            name: 'uploadWorkflowSettings',
            fieldType: FieldType.List,
            showDivider: true,
            initialValue: uploadSettingsFields,
            nestedListFields: [
                {
                    fieldType: FieldType.Custom,
                    style: { margin: 0 },
                    renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                        return (
                            <Form.Item
                                shouldUpdate
                                noStyle
                                style={{
                                    width: '100%',
                                }}
                            >
                                {() => {
                                    return (
                                        <>
                                            <Space
                                                direction="vertical"
                                                size={14}
                                                style={{
                                                    width: '100%',
                                                    backgroundColor: antGrey.grey2,
                                                    borderRadius: 8,
                                                    padding: '20px 30px',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Text>Rule {index + 1}</Text>
                                                    <Button
                                                        icon={
                                                            <DeleteOutlined style={{ color: runwayColors.statusRed }} />
                                                        }
                                                        danger
                                                        type="link"
                                                        onClick={() => remove(index)}
                                                    />
                                                </div>
                                                <Space
                                                    direction="vertical"
                                                    size={20}
                                                    style={{
                                                        width: '100%',
                                                        paddingTop: 8,
                                                    }}
                                                >
                                                    <Space align="center">
                                                        <Text
                                                            style={{
                                                                fontWeight: 600,
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            Workflow
                                                        </Text>
                                                        <Tooltip title="The type of CI/CD workflow whose dSYM file the setting will apply to">
                                                            <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                                                        </Tooltip>
                                                    </Space>
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            gap: 8,
                                                            alignItems: 'center',
                                                            marginTop: -4,
                                                        }}
                                                    >
                                                        <Form.Item
                                                            noStyle
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            {...listFieldData}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please select a workflow',
                                                                    type: 'string',
                                                                },
                                                            ]}
                                                            name={[listFieldData.name, 'workflowType']}
                                                        >
                                                            <Select
                                                                placeholder="Select a workflow"
                                                                style={{
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                {workflowOptions.map((option) => {
                                                                    return (
                                                                        <Select.Option
                                                                            value={option.id}
                                                                            key={option.id}
                                                                        >
                                                                            {option.workflowDescription}{' '}
                                                                            <Text style={{ color: antGrey.grey7 }}>
                                                                                — {option.workflowName}
                                                                            </Text>
                                                                        </Select.Option>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </Space>

                                                <Space
                                                    direction="vertical"
                                                    size={14}
                                                    style={{
                                                        width: '100%',
                                                        paddingTop: 8,
                                                    }}
                                                >
                                                    <Space align="center">
                                                        <Text
                                                            style={{
                                                                fontWeight: 600,
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            File name
                                                        </Text>
                                                        <Tooltip
                                                            title={
                                                                'The name of the dSYM zip file that will be uploaded to the target destination for this setting. The default value of {*}.dSYM.zip will be used if no file name is specified.'
                                                            }
                                                        >
                                                            <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                                                        </Tooltip>
                                                    </Space>
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            gap: 8,
                                                            alignItems: 'center',
                                                            marginTop: -4,
                                                        }}
                                                    >
                                                        <Form.Item
                                                            noStyle
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            {...listFieldData}
                                                            rules={[
                                                                {
                                                                    type: 'string',
                                                                    validator: (_, fileName) => {
                                                                        if (
                                                                            !fileName ||
                                                                            (fileName.length > 4 &&
                                                                                fileName.endsWith('.zip')) ||
                                                                            (fileName.length > 5 &&
                                                                                (fileName.endsWith('.dsym') ||
                                                                                    fileName.endsWith('.dSYM')))
                                                                        ) {
                                                                            return Promise.resolve();
                                                                        } else {
                                                                            return Promise.reject(
                                                                                'dSYM filename must be of type .zip, .dsym, or .dSYM.',
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            ]}
                                                            name={[listFieldData.name, 'fileName']}
                                                        >
                                                            <Input allowClear style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </div>
                                                    <div style={{ marginTop: -10 }}>
                                                        <Text style={{ color: antGrey.grey7 }}>
                                                            Tokenized patterns and wildcards are supported.
                                                        </Text>{' '}
                                                        <Popover
                                                            content={
                                                                <PatternTokenHelperTextComponent
                                                                    availableTokens={availableTokens}
                                                                />
                                                            }
                                                        >
                                                            <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
                                                        </Popover>
                                                    </div>
                                                </Space>

                                                <Space
                                                    direction="vertical"
                                                    size={14}
                                                    style={{
                                                        width: '100%',
                                                        paddingTop: 8,
                                                    }}
                                                >
                                                    <Space align="center">
                                                        <Text
                                                            style={{
                                                                fontWeight: 600,
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            Upload to
                                                        </Text>
                                                        <Tooltip title="Which stability monitoring integrations should receive dSYMs matching this rule. Options come from the stability monitoring integrations connected to this step's downstream rollout step(s).">
                                                            <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                                                        </Tooltip>
                                                    </Space>
                                                    <Form.Item
                                                        noStyle
                                                        {...listFieldData}
                                                        name={[
                                                            listFieldData.name,
                                                            'stabilityMonitoringInstallationIds',
                                                        ]}
                                                        rules={[
                                                            {
                                                                validator: (_, value) => {
                                                                    if (
                                                                        destinationOptions.length > 0 &&
                                                                        (!value || value.length === 0)
                                                                    ) {
                                                                        return Promise.reject(
                                                                            'Select at least one stability monitoring integration to upload to.',
                                                                        );
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            mode="multiple"
                                                            placeholder={
                                                                destinationOptions.length === 0 ?
                                                                    'No stability monitoring integrations connected to downstream rollout steps'
                                                                :   'Select stability monitoring integrations'
                                                            }
                                                            disabled={destinationOptions.length === 0}
                                                            style={{ width: '100%' }}
                                                        >
                                                            {destinationOptions.map((option) => {
                                                                const provenance =
                                                                    option.rolloutStepNames.length > 0 ?
                                                                        ` (used by ${option.rolloutStepNames.join(', ')})`
                                                                    :   '';
                                                                return (
                                                                    <Select.Option
                                                                        value={option.installationId}
                                                                        key={option.installationId}
                                                                    >
                                                                        {option.integrationName}
                                                                        <Text style={{ color: antGrey.grey7 }}>
                                                                            {provenance}
                                                                        </Text>
                                                                    </Select.Option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                </Space>
                                            </Space>
                                        </>
                                    );
                                }}
                            </Form.Item>
                        );
                    },
                },
            ],
            listChildrenWrapper: (children, { add }) => {
                const buttonText = (children as React.ReactNode[]).length === 0 ? 'Add rule' : 'Add another rule';
                return (
                    <Space
                        direction="vertical"
                        style={{
                            width: '100%',
                        }}
                        size={16}
                    >
                        {children}
                        <Form.Item shouldUpdate noStyle>
                            {(form) => {
                                const currentUploadSettings = form.getFieldValue('uploadWorkflowSettings');
                                const disableButton = currentUploadSettings?.length > 1;
                                return (
                                    <>
                                        <Button
                                            disabled={disableButton}
                                            icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                            onClick={() =>
                                                add({
                                                    workflowType: null,
                                                    fileName: `{*}.dSYM.zip`,
                                                    stabilityMonitoringInstallationIds:
                                                        defaultStabilityMonitoringInstallationIds,
                                                })
                                            }
                                        >
                                            {buttonText}
                                        </Button>
                                    </>
                                );
                            }}
                        </Form.Item>
                    </Space>
                );
            },
        } as FormFieldData,
    ];
}

function generateAutoHaltOrPromoteFields(
    baseField: FormFieldData,
    automation: Automation,
    appStoreType: AppStoreType,
    connectedCapabilities: IntegrationCapability[],
    stabilityIntegrations: Integration[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
    healthMetricsLink?: string,
    monitoringChecklistItemTemplates?: ChecklistItemTemplate[],
    isWorkflowsRolloutStepEnabled?: boolean,
) {
    const autoPromoteOrAutoHaltAutomation = automation as
        | AutomationPromoteStablePhasedRelease
        | AutomationHaltUnstableRelease;
    const isAutoPromote = automation.type === AutomationType.AutoPromoteStablePhasedReleases;

    const monitoringConditionOptions: MonitoringConditionOption[] = automationConditionsForAutomationType(
        automation.type,
        appStoreType,
    ).map((type) => {
        return {
            id: type,
            title: displayTextForAutomationConditionType(type),
        };
    });

    const conditionFields = [];
    const perIntegrationAdoptionThresholds = autoPromoteOrAutoHaltAutomation.data?.adoptionThresholds;
    if (perIntegrationAdoptionThresholds && Object.keys(perIntegrationAdoptionThresholds).length > 0) {
        for (const [installationId, threshold] of Object.entries(perIntegrationAdoptionThresholds)) {
            if (!threshold) continue;
            conditionFields.push({
                id: MonitoringAutomationConditionType.Adoption,
                threshold,
                installationId,
            });
        }
    } else if (autoPromoteOrAutoHaltAutomation.data?.adoptionThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.Adoption,
            threshold: autoPromoteOrAutoHaltAutomation.data?.adoptionThreshold,
        });
    }

    if (autoPromoteOrAutoHaltAutomation.data?.phasedReleaseDayThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.PhasedReleaseDay,
            threshold: autoPromoteOrAutoHaltAutomation.data?.phasedReleaseDayThreshold,
        });
    }

    if (autoPromoteOrAutoHaltAutomation.data?.stagedRolloutPercentageThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.StagedRolloutPercentage,
            threshold: autoPromoteOrAutoHaltAutomation.data?.stagedRolloutPercentageThreshold,
        });
    }

    const baseFieldWithConditionsValidation = {
        ...baseField,
        rules: [
            (form) => {
                return {
                    validator: (_, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }

                        const conditions: unknown[] = form.getFieldValue('conditions') ?? [];
                        const monitoringConditions: unknown[] = form.getFieldValue('monitoringConditions') ?? [];
                        if (conditions.length === 0 || monitoringConditions.length === 0) {
                            return Promise.reject(
                                'At least one condition and one associated health metric are required to enable this automation.',
                            );
                        } else {
                            return Promise.resolve();
                        }
                    },
                };
            },
        ],
    };

    if (!isAutoPromote && isWorkflowsRolloutStepEnabled) {
        const baseFieldWithConditionGroupsValidation = {
            ...baseField,
            rules: [
                (form) => {
                    return {
                        validator: (_, value) => {
                            if (!value) {
                                return Promise.resolve();
                            }

                            const conditionGroups: HaltPhasedRolloutConditionGroupFormValue[] =
                                form.getFieldValue('conditionGroups') ?? [];
                            if (conditionGroups.length === 0) {
                                return Promise.reject(
                                    'At least one condition group is required to enable this automation.',
                                );
                            }

                            const hasInvalidGroup = conditionGroups.some(
                                (group) =>
                                    (group.conditions ?? []).length === 0 ||
                                    (group.monitoringConditions ?? []).length === 0,
                            );
                            if (hasInvalidGroup) {
                                return Promise.reject(
                                    'Each condition group requires at least one condition and one associated health metric.',
                                );
                            }

                            return Promise.resolve();
                        },
                    };
                },
            ],
        };

        return [
            baseFieldWithConditionGroupsValidation,
            generateHaltPhasedRolloutConditionGroupsField(
                autoPromoteOrAutoHaltAutomation.data?.conditionGroups ?? [],
                connectedCapabilities,
                monitoringConditionOptions,
                monitoringMetrics,
                healthMetricsLink,
                stabilityIntegrations,
            ),
        ];
    }

    return [
        baseFieldWithConditionsValidation,
        generateThresholdConditionsField(
            'conditions',
            'Apply this automation under the following conditions:',
            conditionFields,
            connectedCapabilities,
            monitoringConditionOptions,
            { stabilityIntegrations },
        ),
        ...(monitoringMetrics && monitoringMetrics.length > 0 ?
            [
                generateMonitoringConditionsField(
                    isAutoPromote ?
                        'Release to 100% of users if...'
                    :   'Halt rollout if any of these health metric conditions are not met:',
                    autoPromoteOrAutoHaltAutomation.data?.monitoringConditions ?? [],
                    isAutoPromote,
                    isAutoPromote ? 'AND' : 'OR',
                    monitoringMetrics,
                    {
                        isAutoPromote,
                        minutesByMetricId: autoPromoteOrAutoHaltAutomation.data?.metricMaxDataAgeMinutes,
                    },
                ),
                generateLinkToHealthMetricsField(
                    'Constraints for health metrics can be managed from',
                    healthMetricsLink,
                ),
            ]
        :   [
                generateLinkToHealthMetricsField(
                    'To add health metric conditions, you first need to add health metric constraints in',
                    healthMetricsLink,
                ),
            ]),
        // Auto-halt automation shouldn't depend on checklist items because it doesn't make sense to wait for approval to halt a bad rollout
        ...(isAutoPromote ?
            [
                generateMonitoringChecklistItemsField(
                    'Require checklist item completion for...',
                    monitoringChecklistItemTemplates,
                    autoPromoteOrAutoHaltAutomation.data?.checklistItems ?? [],
                ),
            ]
        :   []),
    ];
}

export type HaltPhasedRolloutConditionGroupFormValue = {
    id: string;
    name: string;
    conditions?: { id: MonitoringAutomationConditionType; threshold?: number; installationId?: string }[];
    monitoringConditions?: { id: string; maxDataAgeMinutes?: number; threshold?: number }[];
};

export type NotificationTriggerOption = {
    id: NotificationTriggerConditionType;
    title: string;
    input?: { min: number; max: number; precision: number; addonAfter?: string; descriptionText: string };
};

export type ConditionGroupsVariant = 'automation' | 'notification';

const conditionGroupBorderColor = (variant: ConditionGroupsVariant) =>
    variant === 'notification' ? antGrey.grey5 : antGrey.grey4;

const conditionRowBorderRadius = (variant: ConditionGroupsVariant) => (variant === 'notification' ? 20 : 8);

export const haltConditionGroupHasSelectedCondition = (group: HaltPhasedRolloutConditionGroupFormValue): boolean => {
    return (
        (group.conditions ?? []).some((condition) => !!condition?.id) ||
        (group.monitoringConditions ?? []).some((condition) => !!condition?.id)
    );
};

export const defaultHaltConditionGroupName = (index: number) => `Group ${index + 1}`;

const HALT_METRICS_SECTION_TITLE = 'halt if these health metric conditions are not met:';

export const haltConditionGroupsFormValueToConfig = (
    groups: HaltPhasedRolloutConditionGroupFormValue[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
): AutomationHaltPromotePhasedReleaseConditionGroup[] =>
    groups.map((group, index) => {
        const conditionGroup: AutomationHaltPromotePhasedReleaseConditionGroup = {
            id: group.id,
            name: group.name?.trim() || defaultHaltConditionGroupName(index),
            monitoringConditions: [],
            metricMaxDataAgeMinutes: metricMaxDataAgeMinutesFromFormValue(
                group.monitoringConditions,
                monitoringMetrics,
            ),
        };

        for (const condition of group.conditions ?? []) {
            switch (condition.id) {
                case MonitoringAutomationConditionType.Adoption:
                    if (condition.installationId && condition.threshold != null) {
                        conditionGroup.adoptionThresholds = {
                            ...(conditionGroup.adoptionThresholds ?? {}),
                            [condition.installationId]: condition.threshold,
                        };
                    }
                    break;
                case MonitoringAutomationConditionType.PhasedReleaseDay:
                    conditionGroup.phasedReleaseDayThreshold = condition.threshold;
                    break;
                case MonitoringAutomationConditionType.StagedRolloutPercentage:
                    conditionGroup.stagedRolloutPercentageThreshold = condition.threshold;
                    break;
            }
        }

        for (const item of group.monitoringConditions ?? []) {
            switch (item.id) {
                case NotificationTriggerConditionType.RolloutDay:
                    conditionGroup.triggerRolloutDayThreshold = item.threshold;
                    break;
                case NotificationTriggerConditionType.RolloutPercentage:
                    conditionGroup.triggerRolloutPercentageThreshold = item.threshold;
                    break;
                case NotificationTriggerConditionType.PreviousReleaseFullyRolledOut:
                    conditionGroup.triggerOnPreviousReleaseFullyRolledOut = true;
                    break;
                default:
                    conditionGroup.monitoringConditions.push(item.id);
            }
        }

        return conditionGroup;
    });

const conditionFieldsFromHaltConditionGroup = (
    group: AutomationHaltPromotePhasedReleaseConditionGroup,
): HaltPhasedRolloutConditionGroupFormValue['conditions'] => {
    const conditionFields = [];
    if (group.adoptionThresholds && Object.keys(group.adoptionThresholds).length > 0) {
        for (const [installationId, threshold] of Object.entries(group.adoptionThresholds)) {
            // Zero is a real threshold, so only a missing one is skipped
            if (threshold == null) continue;
            conditionFields.push({
                id: MonitoringAutomationConditionType.Adoption,
                threshold,
                installationId,
            });
        }
    }
    if (group.phasedReleaseDayThreshold != null) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.PhasedReleaseDay,
            threshold: group.phasedReleaseDayThreshold,
        });
    }
    if (group.stagedRolloutPercentageThreshold != null) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.StagedRolloutPercentage,
            threshold: group.stagedRolloutPercentageThreshold,
        });
    }
    return conditionFields;
};

const triggerItemsFromHaltConditionGroup = (
    group: AutomationHaltPromotePhasedReleaseConditionGroup,
): HaltPhasedRolloutConditionGroupFormValue['monitoringConditions'] => {
    const items = [];
    if (group.triggerRolloutDayThreshold != null) {
        items.push({ id: NotificationTriggerConditionType.RolloutDay, threshold: group.triggerRolloutDayThreshold });
    }
    if (group.triggerRolloutPercentageThreshold != null) {
        items.push({
            id: NotificationTriggerConditionType.RolloutPercentage,
            threshold: group.triggerRolloutPercentageThreshold,
        });
    }
    if (group.triggerOnPreviousReleaseFullyRolledOut) {
        items.push({ id: NotificationTriggerConditionType.PreviousReleaseFullyRolledOut });
    }
    return items;
};

export const haltConditionGroupsToFormValue = (
    groups: AutomationHaltPromotePhasedReleaseConditionGroup[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
): HaltPhasedRolloutConditionGroupFormValue[] => {
    return groups.map((group, index) => ({
        id: group.id,
        name: group.name || defaultHaltConditionGroupName(index),
        conditions: conditionFieldsFromHaltConditionGroup(group),
        monitoringConditions: [
            ...triggerItemsFromHaltConditionGroup(group),
            ...(group.monitoringConditions
                ?.filter((id) => !monitoringMetrics || monitoringMetrics.some((metric) => metric.id === id))
                .map((id) => ({
                    id,
                    maxDataAgeMinutes: group.metricMaxDataAgeMinutes?.[id],
                })) ?? []),
        ],
    }));
};

export const generateHaltPhasedRolloutConditionGroupsField = (
    conditionGroups: AutomationHaltPromotePhasedReleaseConditionGroup[],
    connectedCapabilities: IntegrationCapability[],
    monitoringConditionOptions: MonitoringConditionOption[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
    healthMetricsLink?: string,
    stabilityIntegrations?: Integration[],
    metricsSectionTitle: string = HALT_METRICS_SECTION_TITLE,
    extraTriggerOptions?: NotificationTriggerOption[],
    variant: ConditionGroupsVariant = 'automation',
): FormFieldData => {
    return {
        name: 'conditionGroupsField',
        fieldType: FieldType.Custom,
        skipFormItemWrapper: true,
        data: {
            formListName: 'conditionGroups',
            initialValue: haltConditionGroupsToFormValue(conditionGroups, monitoringMetrics),
        },
        renderField: ({ formListName, initialValue }) => (
            <HaltPhasedRolloutConditionGroupsField
                formListName={formListName}
                initialValue={initialValue}
                connectedCapabilities={connectedCapabilities}
                monitoringConditionOptions={monitoringConditionOptions}
                monitoringMetrics={monitoringMetrics}
                healthMetricsLink={healthMetricsLink}
                stabilityIntegrations={stabilityIntegrations}
                metricsSectionTitle={metricsSectionTitle}
                extraTriggerOptions={extraTriggerOptions}
                variant={variant}
            />
        ),
    };
};

const HaltPhasedRolloutConditionGroupsField: React.FC<{
    formListName: any;
    initialValue: HaltPhasedRolloutConditionGroupFormValue[];
    connectedCapabilities: IntegrationCapability[];
    monitoringConditionOptions: MonitoringConditionOption[];
    monitoringMetrics?: AppMonitoringHealthMetric[];
    healthMetricsLink?: string;
    stabilityIntegrations?: Integration[];
    metricsSectionTitle: string;
    extraTriggerOptions?: NotificationTriggerOption[];
    variant: ConditionGroupsVariant;
}> = ({
    formListName,
    initialValue,
    connectedCapabilities,
    monitoringConditionOptions,
    monitoringMetrics,
    healthMetricsLink,
    stabilityIntegrations,
    metricsSectionTitle,
    extraTriggerOptions,
    variant,
}) => {
    const isNotificationVariant = variant === 'notification';
    const buildNewGroup = (index: number): HaltPhasedRolloutConditionGroupFormValue => ({
        id: `condition-group-${Date.now()}-${index}`,
        name: defaultHaltConditionGroupName(index),
        conditions: [],
        monitoringConditions: [],
    });

    return (
        <Form.List
            name={formListName}
            initialValue={initialValue}
            rules={[
                {
                    validator: (_, groups: HaltPhasedRolloutConditionGroupFormValue[] | undefined) =>
                        (groups ?? []).every(haltConditionGroupHasSelectedCondition) ?
                            Promise.resolve()
                        :   Promise.reject(new Error('Each group needs at least one condition')),
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => {
                const groups = fields.map((field, index) => ({ field, index }));
                return (
                    <Space direction="vertical" style={{ width: '100%' }} size={16}>
                        {groups.length === 0 && (
                            <Button
                                block={isNotificationVariant}
                                icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                onClick={() => add(buildNewGroup(0))}
                            >
                                {extraTriggerOptions ? 'Add trigger logic group' : 'Add group'}
                            </Button>
                        )}
                        {groups.map(({ field, index }) => (
                            <React.Fragment key={field.key}>
                                <HaltPhasedRolloutConditionGroupCard
                                    groupField={field}
                                    groupIndex={index}
                                    formListName={formListName}
                                    metricsSectionTitle={metricsSectionTitle}
                                    extraTriggerOptions={extraTriggerOptions}
                                    variant={variant}
                                    onDuplicate={(group) =>
                                        add(
                                            {
                                                ...group,
                                                id: `condition-group-${Date.now()}`,
                                                name: `${group.name} copy`,
                                            },
                                            index + 1,
                                        )
                                    }
                                    onDelete={() => remove(index)}
                                    connectedCapabilities={connectedCapabilities}
                                    monitoringConditionOptions={monitoringConditionOptions}
                                    monitoringMetrics={monitoringMetrics}
                                    stabilityIntegrations={stabilityIntegrations}
                                />
                                {index < groups.length - 1 && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 12,
                                            color: antGrey.grey6,
                                            width: '100%',
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                height: 1,
                                                backgroundImage: `repeating-linear-gradient(to right, ${antGrey.grey5} 0 2px, transparent 2px 4px)`,
                                            }}
                                        />
                                        <Text
                                            style={{
                                                color: antGrey.grey8,
                                                fontSize: 14,
                                                letterSpacing: '0.1em',
                                                textTransform: 'uppercase',
                                            }}
                                        >
                                            or
                                        </Text>
                                        <div
                                            style={{
                                                flex: 1,
                                                height: 1,
                                                backgroundImage: `repeating-linear-gradient(to right, ${antGrey.grey5} 0 2px, transparent 2px 4px)`,
                                            }}
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                        {groups.length > 0 && (
                            <Button
                                block={isNotificationVariant}
                                icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                onClick={() => add(buildNewGroup(groups.length))}
                            >
                                {extraTriggerOptions ? 'Add trigger logic group' : 'Add group'}
                            </Button>
                        )}
                        <Form.ErrorList errors={errors} />
                        <div style={{ textAlign: isNotificationVariant ? 'center' : undefined }}>
                            {monitoringMetrics && monitoringMetrics.length > 0 ?
                                generateLinkToHealthMetricsField(
                                    'Constraints for health metrics can be managed from',
                                    healthMetricsLink,
                                ).renderField(null)
                            :   generateLinkToHealthMetricsField(
                                    'To add health metric conditions, you first need to add health metric constraints in',
                                    healthMetricsLink,
                                ).renderField(null)
                            }
                        </div>
                    </Space>
                );
            }}
        </Form.List>
    );
};

const HaltPhasedRolloutConditionGroupCard: React.FC<{
    groupField: any;
    groupIndex: number;
    formListName: any;
    metricsSectionTitle: string;
    extraTriggerOptions?: NotificationTriggerOption[];
    variant: ConditionGroupsVariant;
    onDuplicate: (group: HaltPhasedRolloutConditionGroupFormValue) => void;
    onDelete: () => void;
    connectedCapabilities: IntegrationCapability[];
    monitoringConditionOptions: MonitoringConditionOption[];
    monitoringMetrics?: AppMonitoringHealthMetric[];
    stabilityIntegrations?: Integration[];
}> = ({
    groupField,
    groupIndex,
    formListName,
    metricsSectionTitle,
    extraTriggerOptions,
    variant,
    onDuplicate,
    onDelete,
    connectedCapabilities,
    monitoringConditionOptions,
    monitoringMetrics,
    stabilityIntegrations,
}) => {
    return (
        <Form.Item shouldUpdate noStyle>
            {(form) => {
                const groupPath = [...(Array.isArray(formListName) ? formListName : [formListName]), groupField.name];
                const group = form.getFieldValue(groupPath) as HaltPhasedRolloutConditionGroupFormValue;
                const name = group?.name || defaultHaltConditionGroupName(groupIndex);

                return (
                    <div
                        style={{
                            border: `1px solid ${conditionGroupBorderColor(variant)}`,
                            borderRadius: 4,
                            background: runwayColors.white,
                        }}
                    >
                        <Form.Item hidden name={[groupField.name, 'id']} initialValue={group?.id}>
                            <Input />
                        </Form.Item>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 12px',
                                borderBottom: `1px solid ${conditionGroupBorderColor(variant)}`,
                                backgroundColor: variant === 'notification' ? antGrey.grey2 : undefined,
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <NumericBadge value={groupIndex + 1} size={16} filled />
                                <Form.Item
                                    name={[groupField.name, 'name']}
                                    initialValue={name}
                                    rules={[{ required: true, message: 'Group name is required' }]}
                                    style={{ margin: 0, marginLeft: 6 }}
                                >
                                    <Input
                                        placeholder={defaultHaltConditionGroupName(groupIndex)}
                                        style={{ width: 180 }}
                                    />
                                </Form.Item>
                            </div>
                            <Space size={4}>
                                <Button type="link" icon={<CopyOutlined />} onClick={() => onDuplicate(group)} />
                                <Button type="link" danger icon={<DeleteOutlined />} onClick={onDelete} />
                            </Space>
                        </div>
                        <div style={{ padding: 16 }}>
                            <Text
                                style={{
                                    ...titleStyle,
                                    fontSize: 14,
                                    fontWeight: 400,
                                    color: antGrey.grey8,
                                }}
                            >
                                under the conditions:
                            </Text>
                            <NestedHaltThresholdConditions
                                groupField={groupField}
                                groupPath={groupPath}
                                variant={variant}
                                connectedCapabilities={connectedCapabilities}
                                monitoringConditionOptions={monitoringConditionOptions}
                                stabilityIntegrations={stabilityIntegrations}
                            />
                            <Divider dashed style={{ margin: '16px 0', borderColor: antGrey.grey5 }} />
                            <Text
                                style={{
                                    ...titleStyle,
                                    fontSize: 14,
                                    fontWeight: 400,
                                    color: antGrey.grey8,
                                }}
                            >
                                {metricsSectionTitle}
                            </Text>
                            <NestedHaltMonitoringConditions
                                groupField={groupField}
                                groupPath={groupPath}
                                monitoringMetrics={monitoringMetrics}
                                extraTriggerOptions={extraTriggerOptions}
                                variant={variant}
                            />
                        </div>
                    </div>
                );
            }}
        </Form.Item>
    );
};

const NestedHaltThresholdConditions: React.FC<{
    groupField: any;
    groupPath: any[];
    connectedCapabilities: IntegrationCapability[];
    monitoringConditionOptions: MonitoringConditionOption[];
    stabilityIntegrations?: Integration[];
    variant: ConditionGroupsVariant;
}> = ({ groupField, groupPath, connectedCapabilities, monitoringConditionOptions, stabilityIntegrations, variant }) => (
    <Form.List name={[groupField.name, 'conditions']}>
        {(fields, { add, remove }) => (
            <Space direction="vertical" style={{ width: '100%', marginTop: 10 }} size={12}>
                {fields.map((field, index) => (
                    <Form.Item shouldUpdate noStyle key={field.key}>
                        {(form) => {
                            const conditions = form.getFieldValue([...groupPath, 'conditions']) ?? [];
                            const usedConditionsMap =
                                conditions.reduce(
                                    (acc, condition) => {
                                        if (
                                            condition?.id &&
                                            condition.id !== MonitoringAutomationConditionType.Adoption
                                        ) {
                                            acc[condition.id] = true;
                                        }
                                        return acc;
                                    },
                                    {} as Record<string, boolean>,
                                ) ?? {};
                            const selectedInstallationId: string | undefined = form.getFieldValue([
                                ...groupPath,
                                'conditions',
                                field.name,
                                'installationId',
                            ]);
                            const usedAdoptionInstallations = new Set<string>(
                                (conditions ?? [])
                                    .filter(
                                        (condition, conditionIndex) =>
                                            conditionIndex !== field.name &&
                                            condition?.id === MonitoringAutomationConditionType.Adoption &&
                                            !!condition?.installationId,
                                    )
                                    .map((condition) => condition.installationId as string),
                            );
                            const selectedConditionId = form.getFieldValue([
                                ...groupPath,
                                'conditions',
                                field.name,
                                'id',
                            ]);
                            const selectedConditionThreshold = form.getFieldValue([
                                ...groupPath,
                                'conditions',
                                field.name,
                                'threshold',
                            ]);
                            const conditionInputData =
                                selectedConditionId ?
                                    inputFieldDataForMonitoringConditionType(selectedConditionId, false)
                                :   null;
                            const showStabilityIntegrationSelect =
                                selectedConditionId === MonitoringAutomationConditionType.Adoption &&
                                (stabilityIntegrations?.length ?? 0) > 0;
                            const hasRequiredCapability =
                                selectedConditionId ?
                                    hasRequiredCapabilityForConditionType(selectedConditionId, connectedCapabilities)
                                :   false;

                            return (
                                <>
                                    <Space
                                        direction="vertical"
                                        size={10}
                                        style={{
                                            width: '100%',
                                            backgroundColor: antGrey.grey3,
                                            borderRadius: conditionRowBorderRadius(variant),
                                            padding: '12px 16px',
                                        }}
                                    >
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <NumericBadge value={index + 1} />
                                            <Form.Item
                                                noStyle
                                                name={[field.name, 'id']}
                                                rules={[{ required: true, message: 'Please select a condition' }]}
                                            >
                                                <Select
                                                    placeholder="Select a condition"
                                                    style={{ width: '100%', minWidth: 0 }}
                                                >
                                                    {monitoringConditionOptions.map((option) => (
                                                        <Select.Option
                                                            value={option.id}
                                                            key={option.id}
                                                            disabled={usedConditionsMap[option.id]}
                                                        >
                                                            {option.title}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                            <Button
                                                type="link"
                                                danger
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(index)}
                                            />
                                        </div>
                                        {conditionInputData &&
                                            (showStabilityIntegrationSelect ?
                                                <div
                                                    style={{
                                                        marginLeft: 44,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        gap: 24,
                                                        alignItems: 'flex-start',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 4,
                                                            width: 170,
                                                        }}
                                                    >
                                                        <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                            {conditionInputData.descriptionText}
                                                        </Typography.Text>
                                                        <Form.Item
                                                            noStyle
                                                            name={[field.name, 'threshold']}
                                                            rules={conditionInputData.validationRules}
                                                        >
                                                            <InputNumber
                                                                placeholder="Threshold"
                                                                precision={conditionInputData.precision}
                                                                addonAfter={conditionInputData.addonAfter}
                                                                type="number"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 4,
                                                            width: 220,
                                                        }}
                                                    >
                                                        <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                            reported by
                                                        </Typography.Text>
                                                        <Form.Item
                                                            noStyle
                                                            name={[field.name, 'installationId']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        'Please select a stability monitoring integration',
                                                                    type: 'string',
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                placeholder="Select integration"
                                                                style={{ width: '100%' }}
                                                            >
                                                                {(stabilityIntegrations ?? []).map((integration) => (
                                                                    <Select.Option
                                                                        key={integration.installationId}
                                                                        value={integration.installationId}
                                                                        disabled={
                                                                            usedAdoptionInstallations.has(
                                                                                integration.installationId,
                                                                            ) &&
                                                                            integration.installationId !==
                                                                                selectedInstallationId
                                                                        }
                                                                    >
                                                                        {integration.name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            :   <Space style={{ marginLeft: 44 }}>
                                                    <Form.Item
                                                        noStyle
                                                        name={[field.name, 'threshold']}
                                                        rules={conditionInputData.validationRules}
                                                    >
                                                        <InputNumber
                                                            placeholder="Threshold"
                                                            precision={conditionInputData.precision}
                                                            addonAfter={conditionInputData.addonAfter}
                                                            type="number"
                                                            style={{ width: 170 }}
                                                        />
                                                    </Form.Item>
                                                    <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                        {conditionInputData.descriptionText}
                                                    </Typography.Text>
                                                </Space>)}
                                        {!isNil(selectedConditionThreshold) &&
                                            selectedConditionId &&
                                            thresholdInformationForConditionType(
                                                selectedConditionThreshold,
                                                selectedConditionId,
                                                false,
                                            )}
                                        {selectedConditionId && !hasRequiredCapability && (
                                            <Alert
                                                className="setup-success-banner"
                                                style={{ marginTop: 8 }}
                                                message={
                                                    <Text>
                                                        This rule will not apply until you have the required integration
                                                        capability connected:{' '}
                                                        {displayTextForCapability(
                                                            requiredCapabilityForConditionType(selectedConditionId),
                                                        )}
                                                    </Text>
                                                }
                                                type="warning"
                                                showIcon
                                            />
                                        )}
                                    </Space>
                                    {index < fields.length - 1 && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
                                            <Typography.Text
                                                style={{ color: antGrey.grey8, fontSize: 14, letterSpacing: '0.1em' }}
                                            >
                                                AND
                                            </Typography.Text>
                                            <div
                                                style={{
                                                    flex: 1,
                                                    height: 1,
                                                    backgroundImage: `repeating-linear-gradient(to right, ${antGrey.grey5} 0 2px, transparent 2px 4px)`,
                                                }}
                                            />
                                        </div>
                                    )}
                                </>
                            );
                        }}
                    </Form.Item>
                ))}
                <Button icon={<PlusOutlined style={{ color: runwayColors.primary }} />} onClick={() => add()}>
                    Add condition
                </Button>
            </Space>
        )}
    </Form.List>
);

const displayTextForMonitoringMetricOption = (metric: AppMonitoringHealthMetric): string =>
    fullDisplayTextForMonitoringMetric(metric) ?? displayTextForMonitoringMetric(metric, true);

const sortedMonitoringMetricsWithThresholds = (
    monitoringMetrics?: AppMonitoringHealthMetric[],
): AppMonitoringHealthMetric[] =>
    sortBy(monitoringMetrics?.filter((metric) => metric.thresholds.length > 0) ?? [], (metric) =>
        displayTextForMonitoringMetricOption(metric).toLocaleLowerCase(),
    );

const MonitoringMetricOptionContent: React.FC<{
    metric: AppMonitoringHealthMetric;
    title: string;
    showDescription?: boolean;
    showGeneratedNameTooltip?: boolean;
}> = ({ metric, title, showDescription, showGeneratedNameTooltip }) => {
    const [icon, iconAlt] = iconAndAltForIntegrationType(metric.integrationId);
    const generatedName = displayTextForMonitoringMetric({ ...metric, customDisplayName: undefined }, true);

    return (
        <Space align="center">
            {icon && <img src={icon} alt={iconAlt} width={20} height={20} />}
            {showGeneratedNameTooltip ?
                <Tooltip title={renamedMetricTooltip(metric.customDisplayName, generatedName)}>{title}</Tooltip>
            :   title}
            {showDescription && metric.description && <DescriptionPopoverIcon description={metric.description} />}
        </Space>
    );
};

type MaxDataAgeFieldConfig = {
    isAutoPromote: boolean;
    minutesByMetricId?: Record<string, number>;
};

const MaxDataAgeMinutesField: React.FC<{
    name: (string | number)[];
    path: (string | number)[];
    isAutoPromote: boolean;
    form: FormInstance;
}> = ({ name, path, isAutoPromote, form }) => {
    const isEnabled = form.getFieldValue(path) != null;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                flexWrap: 'wrap',
                marginLeft: NUMERIC_BADGE_INDENT,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Checkbox
                    checked={isEnabled}
                    onChange={(e) =>
                        form.setFieldValue(path, e.target.checked ? DEFAULT_MAX_DATA_AGE_MINUTES : undefined)
                    }
                >
                    <Typography.Text style={{ color: isEnabled ? antGrey.grey9 : antGrey.grey7, fontSize: 12 }}>
                        {isAutoPromote ?
                            "Hold entire trigger unless this metric's data is newer than"
                        :   'Ignore this metric if its data is older than'}
                    </Typography.Text>
                </Checkbox>
                <ConfigProvider theme={{ components: { InputNumber: { fontSize: 12 } } }}>
                    <Form.Item noStyle name={name} rules={[{ validator: validatePositiveMaxDataAgeMinutes }]}>
                        <InputNumber
                            size="small"
                            disabled={!isEnabled}
                            min={1}
                            max={MAX_DATA_AGE_MINUTES_LIMIT}
                            precision={0}
                            type="number"
                            addonAfter="min"
                            placeholder={String(DEFAULT_MAX_DATA_AGE_MINUTES)}
                            style={{ width: 90 }}
                        />
                    </Form.Item>
                </ConfigProvider>
            </div>
            <TooltipInfoIcon
                tooltipContent={
                    <>
                        Set a value between 1 and {MAX_DATA_AGE_MINUTES_LIMIT} minutes to only consider this health
                        metric if the data received is newer than this. If the data is older, Runway will notify you and{' '}
                        {isAutoPromote ?
                            'wait until fresh data arrives to calculate whether to trigger the automation.'
                        :   'count this metric as met.'}
                    </>
                }
            />
        </div>
    );
};

const NestedHaltMonitoringConditions: React.FC<{
    groupField: any;
    groupPath: any[];
    monitoringMetrics?: AppMonitoringHealthMetric[];
    extraTriggerOptions?: NotificationTriggerOption[];
    variant: ConditionGroupsVariant;
}> = ({ groupField, groupPath, monitoringMetrics, extraTriggerOptions, variant }) => (
    <Form.List name={[groupField.name, 'monitoringConditions']}>
        {(fields, { add, remove }) => (
            <Space direction="vertical" style={{ width: '100%', marginTop: 10 }} size={12}>
                {fields.map((field, index) => (
                    <Form.Item shouldUpdate noStyle key={field.key}>
                        {(form) => {
                            const conditions = form.getFieldValue([...groupPath, 'conditions']) ?? [];
                            const currentMonitoringConditions =
                                form.getFieldValue([...groupPath, 'monitoringConditions']) ?? [];
                            const usedMonitoringConditionsMap =
                                currentMonitoringConditions.reduce(
                                    (acc, condition) => {
                                        if (condition?.id) acc[condition.id] = true;
                                        return acc;
                                    },
                                    {} as Record<string, boolean>,
                                ) ?? {};
                            const selectedMetricConditionId = form.getFieldValue([
                                ...groupPath,
                                'monitoringConditions',
                                field.name,
                                'id',
                            ]);
                            const selectedMetric = monitoringMetrics?.find((m) => m.id === selectedMetricConditionId);
                            const selectedTrigger = extraTriggerOptions?.find(
                                (option) => option.id === selectedMetricConditionId,
                            );

                            return (
                                <>
                                    <Space
                                        direction="vertical"
                                        size={10}
                                        style={{
                                            width: '100%',
                                            backgroundColor: antGrey.grey3,
                                            borderRadius: conditionRowBorderRadius(variant),
                                            padding: '12px 16px',
                                        }}
                                    >
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <NumericBadge value={conditions.length + index + 1} />
                                            <Form.Item
                                                noStyle
                                                name={[field.name, 'id']}
                                                rules={[
                                                    { required: true, message: 'Please select a monitoring condition' },
                                                ]}
                                            >
                                                <Select
                                                    placeholder={
                                                        extraTriggerOptions ? 'Select a condition' : (
                                                            'Select a monitoring condition'
                                                        )
                                                    }
                                                    style={{ width: '100%', minWidth: 0 }}
                                                    optionLabelProp="label"
                                                >
                                                    {(extraTriggerOptions ?? []).map((option) => (
                                                        <Select.Option
                                                            value={option.id}
                                                            key={option.id}
                                                            disabled={usedMonitoringConditionsMap[option.id]}
                                                            label={option.title}
                                                        >
                                                            {option.title}
                                                        </Select.Option>
                                                    ))}
                                                    {sortedMonitoringMetricsWithThresholds(monitoringMetrics).map(
                                                        (metric) => {
                                                            const title = displayTextForMonitoringMetricOption(metric);
                                                            return (
                                                                <Select.Option
                                                                    value={metric.id}
                                                                    key={metric.id}
                                                                    disabled={usedMonitoringConditionsMap[metric.id]}
                                                                    label={
                                                                        <MonitoringMetricOptionContent
                                                                            metric={metric}
                                                                            title={title}
                                                                            showGeneratedNameTooltip
                                                                        />
                                                                    }
                                                                >
                                                                    <MonitoringMetricOptionContent
                                                                        metric={metric}
                                                                        title={title}
                                                                        showDescription
                                                                    />
                                                                </Select.Option>
                                                            );
                                                        },
                                                    )}
                                                </Select>
                                            </Form.Item>
                                            <Button
                                                type="link"
                                                danger
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(index)}
                                            />
                                        </div>
                                        {selectedTrigger?.input && (
                                            <Space style={{ marginLeft: NUMERIC_BADGE_INDENT }}>
                                                <Form.Item
                                                    noStyle
                                                    name={[field.name, 'threshold']}
                                                    rules={[
                                                        { required: true, message: 'Please enter a threshold' },
                                                        {
                                                            type: 'number',
                                                            min: selectedTrigger.input.min,
                                                            message: `Threshold must be at least ${selectedTrigger.input.min}`,
                                                        },
                                                        {
                                                            type: 'number',
                                                            max: selectedTrigger.input.max,
                                                            message: `Threshold must be at most ${selectedTrigger.input.max}`,
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber
                                                        placeholder="Threshold"
                                                        precision={selectedTrigger.input.precision}
                                                        addonAfter={selectedTrigger.input.addonAfter}
                                                        type="number"
                                                        style={{ width: 170 }}
                                                    />
                                                </Form.Item>
                                                <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                    {selectedTrigger.input.descriptionText}
                                                </Typography.Text>
                                            </Space>
                                        )}
                                        {selectedMetric && selectedMetric.thresholds.length > 1 && (
                                            <Space direction="vertical" style={{ marginTop: 8 }}>
                                                {selectedMetric.thresholds.map((threshold, i) => (
                                                    <ExtendedThresholdDescription
                                                        key={threshold.value + threshold.condition + i}
                                                        threshold={mapThresholdToFormValue(threshold)}
                                                        metricType={selectedMetric.type}
                                                        metricCategory={selectedMetric.category}
                                                        selectedEventId={selectedMetric.eventName}
                                                        unit={unitForMonitoringMetric(selectedMetric)}
                                                        shouldIndent
                                                    />
                                                ))}
                                            </Space>
                                        )}
                                        {isCustomObaaMetric(selectedMetric) && (
                                            <MaxDataAgeMinutesField
                                                name={[field.name, 'maxDataAgeMinutes']}
                                                path={[
                                                    ...groupPath,
                                                    'monitoringConditions',
                                                    field.name,
                                                    'maxDataAgeMinutes',
                                                ]}
                                                isAutoPromote={false}
                                                form={form}
                                            />
                                        )}
                                    </Space>
                                    {index < fields.length - 1 && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
                                            <Typography.Text
                                                style={{ color: antGrey.grey8, fontSize: 14, letterSpacing: '0.1em' }}
                                            >
                                                OR
                                            </Typography.Text>
                                            <div
                                                style={{
                                                    flex: 1,
                                                    height: 1,
                                                    backgroundImage: `repeating-linear-gradient(to right, ${antGrey.grey5} 0 2px, transparent 2px 4px)`,
                                                }}
                                            />
                                        </div>
                                    )}
                                </>
                            );
                        }}
                    </Form.Item>
                ))}
                <Button icon={<PlusOutlined style={{ color: runwayColors.primary }} />} onClick={() => add()}>
                    {extraTriggerOptions ? 'Add condition' : 'Add health metric condition'}
                </Button>
            </Space>
        )}
    </Form.List>
);

export const NumericBadge: React.FC<{ value: number; size?: number; filled?: boolean }> = ({
    value,
    size = 24,
    filled = false,
}) => {
    return (
        <div
            style={{
                width: size,
                height: size,
                flexShrink: 0,
                borderRadius: size / 2,
                backgroundColor: filled ? runwayColors.primary : runwayColors.white,
                color: filled ? runwayColors.white : runwayColors.primary,
                border: filled ? undefined : `1px solid ${runwayColors.primary}`,
                fontSize: size <= 16 ? 10 : undefined,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 6px',
            }}
        >
            {value}
        </div>
    );
};

function generatePrepareRollbackFields(
    baseField: FormFieldData,
    automation: Automation,
    appStoreType: AppStoreType,
    connectedCapabilities: IntegrationCapability[],
    stabilityIntegrations: Integration[],
    platform: AppPlatform,
    monitoringMetrics?: AppMonitoringHealthMetric[],
    healthMetricsLink?: string,
    resigningStrategy?: RollbackResigningStrategy,
    onSelectResigningStrategy?: (value: RollbackResigningStrategy) => void,
    rebuildByCIUnavailableReason?: string | null,
) {
    const isApplePlatform = getIsApplePlatform(platform);
    const autoPrepareRollbackAutomation = automation as AutomationPrepareRollbackRelease;

    const monitoringConditionOptions: MonitoringConditionOption[] = automationConditionsForAutomationType(
        automation.type,
        appStoreType,
    ).map((type) => {
        return {
            id: type,
            title: displayTextForAutomationConditionType(type),
        };
    });

    const thresholdFields = [];
    const perIntegrationAbandonAdoptionThresholds =
        autoPrepareRollbackAutomation.data?.abandonRollbackAdoptionThresholds;
    if (perIntegrationAbandonAdoptionThresholds && Object.keys(perIntegrationAbandonAdoptionThresholds).length > 0) {
        for (const [installationId, threshold] of Object.entries(perIntegrationAbandonAdoptionThresholds)) {
            if (!threshold) continue;
            thresholdFields.push({
                id: MonitoringAutomationConditionType.Adoption,
                threshold,
                installationId,
            });
        }
    } else if (autoPrepareRollbackAutomation.data?.abandonRollbackAdoptionThreshold) {
        thresholdFields.push({
            id: MonitoringAutomationConditionType.Adoption,
            threshold: autoPrepareRollbackAutomation.data?.abandonRollbackAdoptionThreshold,
        });
    }

    if (autoPrepareRollbackAutomation.data?.abandonRollbackPhasedReleaseDayThreshold) {
        thresholdFields.push({
            id: MonitoringAutomationConditionType.PhasedReleaseDay,
            threshold: autoPrepareRollbackAutomation.data?.abandonRollbackPhasedReleaseDayThreshold,
        });
    }

    if (autoPrepareRollbackAutomation.data?.abandonRollbackStagedRolloutPercentageThreshold) {
        thresholdFields.push({
            id: MonitoringAutomationConditionType.StagedRolloutPercentage,
            threshold: autoPrepareRollbackAutomation.data?.abandonRollbackStagedRolloutPercentageThreshold,
        });
    }

    const baseFields = [
        baseField,
        {
            label: 'Re-signing strategy',
            fieldType: FieldType.Custom,
            name: 'strategy',
            initialValue: resigningStrategy,
            renderField: (data) => {
                return (
                    <Select style={{ width: '100%' }} onChange={(value) => onSelectResigningStrategy(value)}>
                        {data.map((option) => {
                            return (
                                <Select.Option
                                    value={option.value}
                                    key={option.value}
                                    disabled={option.disabled}
                                    title={option.disabledReason}
                                >
                                    {option.displayValue}
                                    {option.disabledReason && (
                                        <Text style={{ color: antGrey.grey7 }}> — {option.disabledReason}</Text>
                                    )}
                                </Select.Option>
                            );
                        })}
                    </Select>
                );
            },
            data: AllRollbackResigningStrategies.map((strategy) => {
                return {
                    value: strategy,
                    displayValue: displayTextForResigningStrategy(strategy),
                    disabled: strategy === RollbackResigningStrategy.CIResign && !!rebuildByCIUnavailableReason,
                    disabledReason:
                        strategy === RollbackResigningStrategy.CIResign ? rebuildByCIUnavailableReason : null,
                };
            }),
            rules: [
                {
                    validator: (_, value) => {
                        if (value === RollbackResigningStrategy.CIResign && rebuildByCIUnavailableReason) {
                            return Promise.reject(new Error(rebuildByCIUnavailableReason));
                        }

                        return Promise.resolve();
                    },
                },
            ],
        },
    ];

    if (isApplePlatform) {
        baseFields.push({
            label: '',
            data: 'Submit automatically when all rollback release steps are ready (green)',
            name: 'shouldAutoSubmit',
            fieldType: FieldType.Checkbox,
            initialValue: autoPrepareRollbackAutomation.data?.shouldAutoSubmit ?? false,
            rules: [],
        });
    }

    return [
        ...baseFields,
        generateThresholdConditionsField(
            'conditions',
            'Automatically discard rollback if the target version meets the following rollout conditions:',
            thresholdFields,
            connectedCapabilities,
            monitoringConditionOptions,
            { allow100PercentRolloutPercentage: true, stabilityIntegrations },
        ),
        ...(monitoringMetrics && monitoringMetrics.length > 0 ?
            [
                generateMonitoringConditionsField(
                    'Automatically discard rollback if the target version meets the following stability conditions:',
                    autoPrepareRollbackAutomation.data?.abandonRollbackMonitoringConditions ?? [],
                    true,
                    'AND',
                    monitoringMetrics,
                ),
                generateLinkToHealthMetricsField(
                    'Constraints for health metrics can be managed from',
                    healthMetricsLink,
                ),
            ]
        :   [
                generateLinkToHealthMetricsField(
                    'To add health metric conditions, you first need to add health metric constraints in',
                    healthMetricsLink,
                ),
            ]),
    ];
}

const generateLinkToHealthMetricsField: (title: string, link?: string) => FormFieldData = (title, link) => {
    return {
        fieldType: FieldType.Custom,
        renderField: () => {
            return (
                <Typography.Text
                    style={{
                        color: antGrey.grey8,
                        fontSize: 12,
                    }}
                >
                    {title} <Link to={link}>App Settings {'>'} Health metrics</Link>
                </Typography.Text>
            );
        },
    };
};

// TODO: Move this logic to a separate file to be properly shared with other components
export const generateThresholdConditionsField: (
    fieldName: string,
    title: string,
    conditionFields: any[],
    connectedCapabilities: IntegrationCapability[],
    monitoringConditionOptions: MonitoringConditionOption[],
    settings?: {
        allow100PercentRolloutPercentage?: boolean;
        ignoreThresholdIfPhasedReleaseIsMissing?: boolean;
        marginBottom?: number;
        stabilityIntegrations?: Integration[];
    },
) => FormFieldData = (
    fieldName,
    title,
    conditionFields,
    connectedCapabilities,
    monitoringConditionOptions,
    settings = {},
) => {
    const {
        allow100PercentRolloutPercentage,
        ignoreThresholdIfPhasedReleaseIsMissing,
        marginBottom,
        stabilityIntegrations,
    } = settings;
    const stabilityIntegrationOptions = stabilityIntegrations ?? [];
    return {
        label: title,
        name: fieldName,
        fieldType: FieldType.List,
        initialValue: conditionFields,
        nestedListFields: [
            {
                fieldType: FieldType.Custom,
                style: { margin: 0 },
                renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                    return (
                        <Form.Item shouldUpdate noStyle style={{ width: '100%' }}>
                            {(form) => {
                                const currentConditions = form.getFieldValue(fieldName);
                                const usedConditionsMap =
                                    currentConditions?.reduce(
                                        (acc, condition) => {
                                            if (
                                                condition?.id &&
                                                condition.id !== MonitoringAutomationConditionType.Adoption
                                            ) {
                                                acc[condition.id] = true;
                                            }
                                            return acc;
                                        },
                                        {} as Record<string, boolean>,
                                    ) ?? {};

                                const selectedConditionId = form.getFieldValue([fieldName, listFieldData.name, 'id']);
                                const selectedInstallationId: string | undefined = form.getFieldValue([
                                    fieldName,
                                    listFieldData.name,
                                    'installationId',
                                ]);

                                const usedAdoptionInstallations = new Set<string>(
                                    (currentConditions ?? [])
                                        .filter(
                                            (c, i) =>
                                                i !== listFieldData.name &&
                                                c?.id === MonitoringAutomationConditionType.Adoption &&
                                                !!c?.installationId,
                                        )
                                        .map((c) => c.installationId as string),
                                );

                                const isAdoptionRow =
                                    selectedConditionId === MonitoringAutomationConditionType.Adoption;
                                const showStabilityIntegrationSelect =
                                    isAdoptionRow && stabilityIntegrationOptions.length > 0;

                                const selectedConditionThreshold = form.getFieldValue([
                                    fieldName,
                                    listFieldData.name,
                                    'threshold',
                                ]);

                                const conditionInputData =
                                    selectedConditionId ?
                                        inputFieldDataForMonitoringConditionType(
                                            selectedConditionId,
                                            allow100PercentRolloutPercentage,
                                        )
                                    :   null;
                                const hasRequiredCapability =
                                    selectedConditionId ?
                                        hasRequiredCapabilityForConditionType(
                                            selectedConditionId,
                                            connectedCapabilities,
                                        )
                                    :   false;

                                return (
                                    <>
                                        <Space
                                            direction="vertical"
                                            size={14}
                                            style={{
                                                width: '100%',
                                                backgroundColor: antGrey.grey2,
                                                borderRadius: 8,
                                                padding: '20px 30px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    gap: 8,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <NumericBadge value={index + 1} />
                                                <Form.Item
                                                    noStyle
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    {...listFieldData}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please select a condition',
                                                            type: 'string',
                                                        },
                                                    ]}
                                                    name={[listFieldData.name, 'id']}
                                                >
                                                    <Select
                                                        placeholder="Select a condition"
                                                        style={{
                                                            width: '100%',
                                                            minWidth: 0,
                                                        }}
                                                    >
                                                        {monitoringConditionOptions.map((option) => {
                                                            return (
                                                                <Select.Option
                                                                    value={option.id}
                                                                    key={option.id}
                                                                    disabled={usedConditionsMap[option.id]}
                                                                >
                                                                    {option.title}
                                                                </Select.Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </Form.Item>

                                                <Button
                                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                                    danger
                                                    type="link"
                                                    onClick={() => remove(index)}
                                                />
                                            </div>
                                            {conditionInputData && (
                                                <>
                                                    {showStabilityIntegrationSelect ?
                                                        // Stack label-above-input when the integration select is also
                                                        // rendered — otherwise the three inline texts get squeezed and
                                                        // wrap vertically next to the inputs.
                                                        <div
                                                            style={{
                                                                marginLeft: 44,
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                gap: 24,
                                                                alignItems: 'flex-start',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: 4,
                                                                    width: 170,
                                                                }}
                                                            >
                                                                <Typography.Text
                                                                    style={{
                                                                        color: antGrey.grey7,
                                                                        fontSize: 12,
                                                                        lineHeight: '20px',
                                                                        marginBottom: 0,
                                                                    }}
                                                                >
                                                                    {conditionInputData.descriptionText}
                                                                </Typography.Text>
                                                                <Form.Item
                                                                    noStyle
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    {...listFieldData}
                                                                    name={[listFieldData.name, 'threshold']}
                                                                    rules={conditionInputData.validationRules}
                                                                >
                                                                    <InputNumber
                                                                        placeholder="Threshold"
                                                                        precision={conditionInputData.precision}
                                                                        addonAfter={conditionInputData.addonAfter}
                                                                        type="number"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: 4,
                                                                    width: 220,
                                                                }}
                                                            >
                                                                <Typography.Text
                                                                    style={{
                                                                        color: antGrey.grey7,
                                                                        fontSize: 12,
                                                                        lineHeight: '20px',
                                                                        marginBottom: 0,
                                                                    }}
                                                                >
                                                                    reported by
                                                                </Typography.Text>
                                                                <Form.Item
                                                                    noStyle
                                                                    {...listFieldData}
                                                                    name={[listFieldData.name, 'installationId']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                'Please select a stability monitoring integration',
                                                                            type: 'string',
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        placeholder="Select integration"
                                                                        style={{ width: '100%' }}
                                                                    >
                                                                        {stabilityIntegrationOptions.map(
                                                                            (integration) => (
                                                                                <Select.Option
                                                                                    key={integration.installationId}
                                                                                    value={integration.installationId}
                                                                                    disabled={
                                                                                        usedAdoptionInstallations.has(
                                                                                            integration.installationId,
                                                                                        ) &&
                                                                                        integration.installationId !==
                                                                                            selectedInstallationId
                                                                                    }
                                                                                >
                                                                                    {integration.name}
                                                                                </Select.Option>
                                                                            ),
                                                                        )}
                                                                    </Select>
                                                                </Form.Item>
                                                            </div>
                                                        </div>
                                                    :   <Space
                                                            style={{
                                                                marginLeft: 44,
                                                            }}
                                                        >
                                                            <Form.Item
                                                                noStyle
                                                                style={{
                                                                    width: '100%',
                                                                }}
                                                                {...listFieldData}
                                                                name={[listFieldData.name, 'threshold']}
                                                                rules={conditionInputData.validationRules}
                                                            >
                                                                <InputNumber
                                                                    placeholder="Threshold"
                                                                    precision={conditionInputData.precision}
                                                                    addonAfter={conditionInputData.addonAfter}
                                                                    type="number"
                                                                    style={{
                                                                        width: 170,
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                            <Typography.Text
                                                                style={{
                                                                    color: antGrey.grey7,
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                {conditionInputData.descriptionText}
                                                            </Typography.Text>
                                                        </Space>
                                                    }
                                                    {!isNil(selectedConditionThreshold) &&
                                                        selectedConditionId &&
                                                        thresholdInformationForConditionType(
                                                            selectedConditionThreshold,
                                                            selectedConditionId,
                                                            ignoreThresholdIfPhasedReleaseIsMissing,
                                                        )}
                                                    {selectedConditionId && !hasRequiredCapability && (
                                                        <Alert
                                                            className="setup-success-banner"
                                                            style={{ margin: 8 }}
                                                            message={
                                                                <Text>
                                                                    This rule will not apply until you have the required
                                                                    integration capability connected:{' '}
                                                                    {displayTextForCapability(
                                                                        requiredCapabilityForConditionType(
                                                                            selectedConditionId,
                                                                        ),
                                                                    )}
                                                                </Text>
                                                            }
                                                            type="warning"
                                                            showIcon
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </Space>
                                        {!(index === currentConditions?.length - 1) && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    paddingTop: 16,
                                                }}
                                            >
                                                <Typography.Text
                                                    style={{
                                                        color: antGrey.grey6,
                                                    }}
                                                >
                                                    <strong>AND</strong>
                                                </Typography.Text>
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    );
                },
            },
        ],
        listChildrenWrapper: (children, { add }) => {
            return (
                <Space direction="vertical" style={{ width: '100%', marginBottom }} size={16}>
                    {children}
                    <Form.Item shouldUpdate noStyle>
                        {() => {
                            return (
                                <>
                                    <Button
                                        icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                        onClick={() => add()}
                                    >
                                        Add condition
                                    </Button>
                                </>
                            );
                        }}
                    </Form.Item>
                </Space>
            );
        },
    } as FormFieldData;
};

const generateMonitoringConditionsField: (
    title: string,
    monitoringConditions: string[],
    isPositive: boolean,
    booleanOp: 'AND' | 'OR',
    monitoringMetrics?: AppMonitoringHealthMetric[],
    maxDataAge?: MaxDataAgeFieldConfig,
) => FormFieldData = (title, monitoringConditions, isPositive, booleanOp, monitoringMetrics, maxDataAge) => {
    return {
        label: title,
        name: 'monitoringConditions',
        fieldType: FieldType.List,
        showDivider: true,
        initialValue:
            monitoringConditions
                ?.filter((id) => monitoringMetrics?.find((metric) => metric.id === id)?.thresholds?.length > 0)
                .map((id) => ({ id, maxDataAgeMinutes: maxDataAge?.minutesByMetricId?.[id] })) ?? [],
        rules: [],
        nestedListFields: [
            {
                fieldType: FieldType.Custom,
                style: { margin: 0 },
                renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                    return (
                        <Form.Item
                            shouldUpdate
                            noStyle
                            style={{
                                width: '100%',
                            }}
                        >
                            {(form) => {
                                const currentConditionsLength = form.getFieldValue('conditions')?.length ?? 0;

                                const currentMonitoringConditions = form.getFieldValue(['monitoringConditions']);
                                const usedMonitoringConditionsMap =
                                    currentMonitoringConditions?.reduce(
                                        (acc, condition) => {
                                            if (condition?.id) {
                                                acc[condition.id] = true;
                                            }
                                            return acc;
                                        },
                                        {} as Record<string, boolean>,
                                    ) ?? {};
                                const selectedMetricConditionId = form.getFieldValue([
                                    'monitoringConditions',
                                    listFieldData.name,
                                    'id',
                                ]);

                                const selectedMetric = monitoringMetrics?.find(
                                    (m) => m.id === selectedMetricConditionId,
                                );

                                return (
                                    <>
                                        <Space
                                            direction="vertical"
                                            size={14}
                                            style={{
                                                width: '100%',
                                                backgroundColor: antGrey.grey2,
                                                borderRadius: 8,
                                                padding: '20px 30px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    gap: 8,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <NumericBadge value={currentConditionsLength + index + 1} />
                                                <Form.Item
                                                    noStyle
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    {...listFieldData}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please select a monitoring condition',
                                                            type: 'string',
                                                        },
                                                    ]}
                                                    name={[listFieldData.name, 'id']}
                                                >
                                                    <Select
                                                        placeholder="Select a monitoring condition"
                                                        style={{
                                                            width: '100%',
                                                            minWidth: 0,
                                                        }}
                                                        optionLabelProp="label"
                                                    >
                                                        {sortedMonitoringMetricsWithThresholds(monitoringMetrics).map(
                                                            (metric) => {
                                                                const title =
                                                                    displayTextForMonitoringMetricOption(metric);

                                                                return (
                                                                    <Select.Option
                                                                        value={metric.id}
                                                                        key={metric.id}
                                                                        disabled={
                                                                            usedMonitoringConditionsMap[metric.id]
                                                                        }
                                                                        label={
                                                                            <MonitoringMetricOptionContent
                                                                                metric={metric}
                                                                                title={title}
                                                                                showGeneratedNameTooltip
                                                                            />
                                                                        }
                                                                    >
                                                                        <MonitoringMetricOptionContent
                                                                            metric={metric}
                                                                            title={title}
                                                                            showDescription
                                                                        />
                                                                    </Select.Option>
                                                                );
                                                            },
                                                        )}
                                                    </Select>
                                                </Form.Item>

                                                <Button
                                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                                    danger
                                                    type="link"
                                                    onClick={() => remove(index)}
                                                />
                                            </div>
                                            {selectedMetric && selectedMetric.thresholds.length > 1 && (
                                                <Space
                                                    direction="vertical"
                                                    style={{
                                                        marginTop: 12,
                                                    }}
                                                >
                                                    {selectedMetric.thresholds.map((threshold, i) => {
                                                        return (
                                                            <ExtendedThresholdDescription
                                                                key={threshold.value + threshold.condition + i}
                                                                threshold={mapThresholdToFormValue(threshold)}
                                                                metricType={selectedMetric.type}
                                                                metricCategory={selectedMetric.category}
                                                                selectedEventId={selectedMetric.eventName}
                                                                unit={unitForMonitoringMetric(selectedMetric)}
                                                                shouldIndent
                                                            />
                                                        );
                                                    })}
                                                </Space>
                                            )}
                                            {maxDataAge && isCustomObaaMetric(selectedMetric) && (
                                                <MaxDataAgeMinutesField
                                                    name={[listFieldData.name, 'maxDataAgeMinutes']}
                                                    path={[
                                                        'monitoringConditions',
                                                        listFieldData.name,
                                                        'maxDataAgeMinutes',
                                                    ]}
                                                    isAutoPromote={maxDataAge.isAutoPromote}
                                                    form={form}
                                                />
                                            )}
                                        </Space>
                                        {!(index === currentMonitoringConditions?.length - 1) && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    paddingTop: 16,
                                                }}
                                            >
                                                <Typography.Text
                                                    style={{
                                                        color: antGrey.grey6,
                                                    }}
                                                >
                                                    <strong>{booleanOp}</strong>
                                                </Typography.Text>
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    );
                },
            },
        ],
        listChildrenWrapper: (children, { add }) => {
            return (
                <Space
                    direction="vertical"
                    style={{
                        width: '100%',
                    }}
                    size={16}
                >
                    {children}
                    <Button icon={<PlusOutlined style={{ color: runwayColors.primary }} />} onClick={() => add()}>
                        Add health metric condition
                    </Button>
                </Space>
            );
        },
    } as FormFieldData;
};

const generateMonitoringChecklistItemsField: (
    title: string,
    monitoringChecklistItemTemplates: ChecklistItemTemplate[],
    selectedChecklistItemsIds: string[],
) => FormFieldData = (title, monitoringChecklistItemTemplates, selectedChecklistItemsIds) => {
    return {
        label: title,
        name: 'monitoringChecklistItems',
        fieldType: FieldType.List,
        initialValue: selectedChecklistItemsIds,
        showDivider: true,
        nestedListFields: [
            {
                fieldType: FieldType.Custom,
                style: { margin: 0 },
                renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                    return (
                        <Form.Item
                            shouldUpdate
                            noStyle
                            style={{
                                width: '100%',
                            }}
                        >
                            {(form) => {
                                const currentConditions = form.getFieldValue('monitoringChecklistItems');
                                const usedConditionsMap =
                                    currentConditions?.reduce(
                                        (acc, condition) => {
                                            if (condition) {
                                                acc[condition] = true;
                                            }
                                            return acc;
                                        },
                                        {} as Record<string, boolean>,
                                    ) ?? {};

                                const selectedConditionId = form.getFieldValue([
                                    'monitoringChecklistItems',
                                    listFieldData.name,
                                ]);
                                const selectedCondition = monitoringChecklistItemTemplates.find(
                                    (cliCondition) => cliCondition.id === selectedConditionId,
                                );

                                const selectedConditionTitle = selectedCondition?.title;
                                return (
                                    <>
                                        <Space
                                            direction="vertical"
                                            size={14}
                                            style={{
                                                width: '100%',
                                                backgroundColor: antGrey.grey2,
                                                borderRadius: 8,
                                                padding: '20px 30px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    gap: 8,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <NumericBadge value={index + 1} />
                                                <Form.Item
                                                    {...listFieldData}
                                                    noStyle
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please select a checklist item',
                                                            type: 'string',
                                                        },
                                                    ]}
                                                    name={listFieldData.name}
                                                    style={{ width: '100%' }}
                                                >
                                                    <Select
                                                        placeholder="Select a checklist item"
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    >
                                                        {monitoringChecklistItemTemplates.map((option) => {
                                                            return (
                                                                <Select.Option
                                                                    value={option.id}
                                                                    key={option.id}
                                                                    disabled={usedConditionsMap[option.id]}
                                                                >
                                                                    {option.title}
                                                                </Select.Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </Form.Item>
                                                <Button
                                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                                    danger
                                                    type="link"
                                                    onClick={() => remove(index)}
                                                />
                                            </div>
                                            <Space
                                                style={{
                                                    marginLeft: 44,
                                                }}
                                            >
                                                {selectedCondition && (
                                                    <Typography.Text
                                                        style={{
                                                            color: antGrey.grey7,
                                                        }}
                                                    >
                                                        <strong
                                                            style={{
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            Checklist item &quot;{selectedConditionTitle}&quot;
                                                        </strong>{' '}
                                                        is{' '}
                                                        <strong
                                                            style={{
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            completed
                                                        </strong>
                                                    </Typography.Text>
                                                )}
                                            </Space>
                                        </Space>
                                        {!(index === currentConditions?.length - 1) && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    paddingTop: 16,
                                                }}
                                            >
                                                <Typography.Text
                                                    style={{
                                                        color: antGrey.grey6,
                                                    }}
                                                >
                                                    <strong>AND</strong>
                                                </Typography.Text>
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    );
                },
            },
        ],
        listChildrenWrapper: (children, { add }) => {
            return (
                <Space
                    direction="vertical"
                    style={{
                        width: '100%',
                    }}
                    size={16}
                >
                    {children}
                    <Form.Item shouldUpdate noStyle>
                        {() => {
                            return (
                                <>
                                    <Button
                                        icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                        onClick={() => add()}
                                    >
                                        Add checklist item condition
                                    </Button>
                                </>
                            );
                        }}
                    </Form.Item>
                </Space>
            );
        },
    } as FormFieldData;
};

const hasRequiredCapabilityForConditionType: (
    type: MonitoringAutomationConditionType,
    connectedCapabilities: IntegrationCapability[],
) => boolean = (type, capabilities) => {
    const requiredCapability = requiredCapabilityForConditionType(type);

    return capabilities.includes(requiredCapability);
};

const requiredCapabilityForConditionType: (type: MonitoringAutomationConditionType) => IntegrationCapability = (
    type,
) => {
    switch (type) {
        case MonitoringAutomationConditionType.Adoption:
            return IntegrationCapability.StabilityMonitoring;
        case MonitoringAutomationConditionType.PhasedReleaseDay:
        case MonitoringAutomationConditionType.StagedRolloutPercentage:
            return IntegrationCapability.AppStore;
    }
};

const thresholdInformationForConditionType: (
    threshold: number,
    type: MonitoringAutomationConditionType,
    ignoreThresholdIfPhasedReleaseIsMissing: boolean,
) => React.ReactNode = (threshold, type, ignoreThresholdIfPhasedReleaseIsMissing) => {
    let text = null;
    switch (type) {
        case MonitoringAutomationConditionType.Adoption:
            text = (
                <Typography.Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Release adoption
                    </strong>{' '}
                    is {'>= '}
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        {threshold}%
                    </strong>
                </Typography.Text>
            );
            break;
        case MonitoringAutomationConditionType.PhasedReleaseDay:
            text = (
                <Typography.Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Phased release
                    </strong>{' '}
                    must reach{' '}
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Day {threshold}
                    </strong>
                    {ignoreThresholdIfPhasedReleaseIsMissing && (
                        <span style={{ marginLeft: 4 }}>
                            <TooltipInfoIcon tooltipContent="If there is no phased release / staged rollout enabled, this requirement will be ignored." />
                        </span>
                    )}
                </Typography.Text>
            );
            break;
        case MonitoringAutomationConditionType.StagedRolloutPercentage:
            text = (
                <Typography.Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Staged rollout percentage
                    </strong>{' '}
                    is {'>= '}
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        {threshold}%
                    </strong>
                </Typography.Text>
            );
    }

    return (
        <Space
            style={{
                marginLeft: 44,
            }}
        >
            {text}
        </Space>
    );
};

const inputFieldDataForMonitoringConditionType: (
    conditionType: MonitoringAutomationConditionType,
    allow100PercentRollout: boolean,
) => InputFieldDataWithValidation = (conditionType, allow100PercentRollout) => {
    let data: InputFieldDataWithValidation = {};

    switch (conditionType) {
        case MonitoringAutomationConditionType.Adoption:
            data = {
                max: 99.9999,
                min: 0,
                addonAfter: '%',
                descriptionText: 'session adoption',
            };
            break;
        case MonitoringAutomationConditionType.PhasedReleaseDay:
            data = {
                precision: 0,
                max: 7,
                min: 0,
                step: 1,
                descriptionText: 'phased release day',
            };
            break;
        case MonitoringAutomationConditionType.StagedRolloutPercentage:
            data = {
                max: allow100PercentRollout ? 100 : 99,
                min: 0,
                addonAfter: '%',
                descriptionText: 'staged rollout percentage',
            };
            break;
    }

    return {
        ...data,
        validationRules: [
            {
                min: data.min as number,
                message: `Threshold must be greater than ${data.min}`,
                type: 'number',
            },
            {
                max: data.max as number,
                message: `Threshold must be less than ${data.max}`,
                type: 'number',
            },
            { required: true, message: 'Please enter a threshold' },
        ],
    };
};

function checkboxLabelWithTooltip(label: string, tooltip: React.ReactNode): React.ReactNode {
    return (
        <div>
            {label}
            <Tooltip title={tooltip}>
                <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
            </Tooltip>
        </div>
    );
}

const BYPASS_PULL_REQUESTS_FIELD_KEY = 'shouldCommitAndPushDirectlyToTargetBranch';

interface DirectPushCheck {
    createsMergeCommit: boolean;
    canWaitForRequiredStatusChecks: boolean;
    branchTargetForValues: (values: Record<string, unknown>) => VCSDirectPushBranchTarget | null;
    disabledReasonForValues?: (values: Record<string, unknown>) => string | undefined;
}

// Which branch the bypass check tests for each automation that can bypass pull requests, and what its push needs
const DIRECT_PUSH_CHECKS: Partial<Record<AutomationType, DirectPushCheck>> = {
    [AutomationType.AutoBumpVersion]: {
        createsMergeCommit: false,
        canWaitForRequiredStatusChecks: true,
        branchTargetForValues: (values) => {
            const strategy = values.strategy as BumpVersionAutomationStrategy | null;
            if (!strategy) {
                return null;
            }
            return strategy === BumpVersionAutomationStrategy.PostKickoffToCurrentVersionOnReleaseBranch ?
                    'releaseBranch'
                :   'workingBranch';
        },
        disabledReasonForValues: (values) =>
            values.strategy ? undefined : (
                'Choose a bump version strategy first, so Runway knows which branch to check.'
            ),
    },
    [AutomationType.AutoKickoffRelease]: {
        createsMergeCommit: true,
        canWaitForRequiredStatusChecks: false,
        branchTargetForValues: () => 'releaseBranch',
    },
    [AutomationType.AutoCherryPickLocalizableStrings]: {
        createsMergeCommit: false,
        canWaitForRequiredStatusChecks: true,
        branchTargetForValues: () => 'releaseBranch',
    },
};

// The switch's tooltip links to the docs, and a check under it tests the branch protection, which the shared renderer can't do
function buildBypassPullRequestsField(formField: FormFieldData, context: AutomationFormFieldContext): FormFieldData {
    const bypassField: FormFieldData = {
        ...formField,
        renderField: () => (
            <Checkbox>
                {checkboxLabelWithTooltip(
                    'Bypass pull requests',
                    bypassPullRequestsTooltip(context.vcsSupportsDirectPushCheck),
                )}
            </Checkbox>
        ),
    };
    const check = DIRECT_PUSH_CHECKS[context.automationType];
    if (!context.vcsSupportsDirectPushCheck || !check) {
        return bypassField;
    }
    return {
        fieldType: FieldType.WrappedGroup,
        groupedFields: [bypassField, buildVCSDirectPushCheckField(context, check)],
    };
}

function buildVCSDirectPushCheckField(context: AutomationFormFieldContext, check: DirectPushCheck): FormFieldData {
    return {
        name: 'vcsDirectPushCheck',
        fieldType: FieldType.Custom,
        initialValue: null,
        rules: [],
        skipFormItemWrapper: true,
        renderField: (_data: unknown, namespace?: string) => {
            return (
                <Form.Item shouldUpdate noStyle>
                    {({ getFieldsValue }) => {
                        const allValues = getFieldsValue();
                        const values = namespace ? (allValues[namespace] ?? {}) : allValues;
                        const branchTarget = check.branchTargetForValues(values);
                        const disabledReason =
                            !values.shouldCommitAndPushDirectlyToTargetBranch ?
                                'Enable Bypass pull requests first.'
                            :   check.disabledReasonForValues?.(values);

                        return (
                            <div style={{ marginBottom: 12 }}>
                                <VCSDirectPushCheck
                                    orgId={context.orgId}
                                    appId={context.appId}
                                    branchTarget={branchTarget}
                                    disabledReason={disabledReason}
                                    createsMergeCommit={check.createsMergeCommit}
                                    canWaitForRequiredStatusChecks={check.canWaitForRequiredStatusChecks}
                                />
                            </div>
                        );
                    }}
                </Form.Item>
            );
        },
    };
}

function bypassPullRequestsTooltip(vcsSupportsDirectPushCheck: boolean): React.ReactNode {
    const docsLink = (
        <Typography.Link
            href={`https://docs.runway.team/integrations/version-control/github#ensure-runway-can-run-status-checks-if-needed`}
            target="_blank"
            rel="noreferrer"
        >
            here
        </Typography.Link>
    );

    // A VCS Runway can test gets the shorter copy, because the prerequisites test does the explaining.
    // The rest still need the full description, since there is nothing to click.
    if (vcsSupportsDirectPushCheck) {
        return (
            <>
                {`Information on how to set this up for each type of VCS integration is available `}
                {docsLink}
                {'. Use the action below to test your existing setup.'}
            </>
        );
    }

    return (
        <>
            {`If your repository has branch protection enabled for the target branch AND those branch protections include requiring pull requests to merge or restricting push access to your target branch, you'll need to update your branch protection rules to allow Runway to bypass requirements. Detailed instructions on how to set this up for each type of VCS integration are available `}
            {docsLink}
            {'.'}
        </>
    );
}

function defaultHelpMessage(automationType: AutomationType): string {
    if (isAppLevelAutomationConfig(automationType)) {
        return 'This setting will apply to all releases for this app.';
    }

    switch (automationType) {
        case AutomationType.AutoResignRollbackBuild:
            return 'This automation applies to rollback releases only.';
        default:
            // All other autos have the ability to select which release types to apply the automation to
            return '';
    }
}

type RoleEntry = {
    userGroup: UserGroup;
    appStoreRoles: GooglePlayConsolePermission[] | ASCRole[];
    syncEnabled: boolean;
};

function generateAutoSyncAppStoreUsersFields(
    baseField: FormFieldData,
    automation: AutomationSyncAppStoreUsers,
    appStoreName: string,
    appStoreType: AppStoreType,
    userGroups: UserGroup[],
) {
    const rolesEntries: RoleEntry[] = Object.entries(automation.data?.rolesMap ?? {}).map(([groupId, appStoreData]) => {
        return {
            userGroup: userGroups.find((group) => group.id === groupId),
            appStoreRoles: appStoreData.appStore.roles,
            syncEnabled: appStoreData.appStore.syncEnabled,
        };
    });

    let selectOptions: string[];
    switch (appStoreType) {
        case AppStoreType.Apple:
            selectOptions = Object.values(ASCRole);
            break;
        case AppStoreType.Google:
            selectOptions = Object.values(GooglePlayConsolePermission);
            break;
        default:
            selectOptions = [];
    }

    return [
        {
            ...baseField,
            helpMessage: null,
        },
        {
            label: '',
            fieldType: FieldType.List,
            name: 'rolesMap',
            initialValue: rolesEntries,
            nestedListFields: [
                {
                    fieldType: FieldType.Custom,
                    extraFormItemProps: {
                        noStyle: true,
                    },
                    renderField: ({ index, listFieldData }) => {
                        return (
                            <Form.Item shouldUpdate noStyle>
                                {() => {
                                    const entry = rolesEntries[index];

                                    return (
                                        <>
                                            <Divider style={{ margin: '12px 0' }} />
                                            <Row gutter={[8, 8]} justify={'space-around'} align={'middle'}>
                                                <Col span={6}>
                                                    <Text>{displayTextForUserGroup(entry.userGroup)}</Text>
                                                </Col>
                                                <Col span={14}>
                                                    <Form.Item
                                                        style={
                                                            {
                                                                width: '80%',
                                                                height: 'min-content',
                                                                margin: '0 0',
                                                            } as React.CSSProperties
                                                        }
                                                        name={[listFieldData.name, 'appStoreRoles']}
                                                    >
                                                        <Select mode="multiple" placeholder="Select user groups">
                                                            {selectOptions.map((group) => (
                                                                <Select.Option key={group} value={group}>
                                                                    {
                                                                        (getIsAppleAppStore(appStoreType) ?
                                                                            ROLE_TITLE_BY_ASCROLE
                                                                        :   ROLE_TITLE_BY_GPLAY_PERMISSION)[group]
                                                                    }
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4} flex={'row'} style={{ justifyContent: 'center' }}>
                                                    <Form.Item
                                                        style={
                                                            {
                                                                width: 'min-content',
                                                                height: 'min-content',
                                                                margin: '0 auto 0 0',
                                                            } as React.CSSProperties
                                                        }
                                                        name={[listFieldData.name, 'syncEnabled']}
                                                    >
                                                        <Switch
                                                            defaultChecked={entry.syncEnabled}
                                                            style={{ margin: 'auto auto' }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </>
                                    );
                                }}
                            </Form.Item>
                        );
                    },
                },
            ],
            listChildrenWrapper: (children) => {
                return (
                    <div style={{ marginBottom: '30px' }}>
                        <Row gutter={[8, 8]} justify="space-around" align="middle">
                            <Col span={6} style={{ padding: '0' }}>
                                <Text strong>Runway user group</Text>
                            </Col>
                            <Col span={14}>
                                <Text strong>User group in {displayConsoleNameForAppStoreType(appStoreType)}</Text>
                            </Col>
                            <Col span={4}>
                                <Text strong>Sync enabled</Text>
                            </Col>
                        </Row>
                        {children}
                    </div>
                );
            },
        },
        {
            label: `Allow Runway to remove users from your app in ${appStoreName} when they are removed from your app in Runway`,
            name: 'allowDeleteUsers',
            fieldType: FieldType.Checkbox,
            initialValue: automation.data?.allowDeleteUsers ?? false,
            rules: [],
            data: 'Yes, allow',
        },
    ];
}

function buildDisabledBetaGroupField() {
    return {
        label: 'Default beta groups',
        name: 'selectedBetaGroupIds',
        fieldType: FieldType.Custom,
        initialValue: [],
        renderField: () => {
            return (
                <Select mode="multiple" placeholder="Select" disabled>
                    <Select.Option value="disabled" key="disabled" disabled>
                        Beta groups are disabled
                    </Select.Option>
                </Select>
            );
        },
        rules: [],
    };
}

function buildTestFlightBetaGroupField(
    betaTesting: IntegrationTestFlight,
    betaTestingProvider: IntegrationProviderApple,
    initialGroupIds: string[],
) {
    const appleProvider = betaTestingProvider as IntegrationProviderApple;
    const bundleId = betaTesting.data?.bundleId;
    const testFlightBetaGroups =
        bundleId ?
            appleProvider.data.availableApps.find((availableApp) => availableApp.bundleId === bundleId)?.betaGroups
        :   [];

    return {
        label: 'Default beta testing groups',
        name: 'selectedBetaGroupIds',
        fieldType: FieldType.Custom,
        initialValue: initialGroupIds,
        data: testFlightBetaGroups ?? [],
        renderField: (data: BetaGroup[]) => {
            return (
                <Select mode="multiple" placeholder="Select" filterOption={filterOptionLabel}>
                    {data.map((group) => {
                        return (
                            <Select.Option
                                value={group.id}
                                key={group.id}
                                label={group.name}
                                disabled={!group.isEligibleAsDefaultBetaGroup}
                            >
                                {group.name}
                                {group.isExternal && <Text type="secondary">(external)</Text>}
                            </Select.Option>
                        );
                    })}
                </Select>
            );
        },
        rules: [{ required: true, message: 'Beta groups selection required' }],
    };
}

function buildFirebaseBetaGroupField(
    betaTesting: IntegrationFirebaseBeta,
    betaTestingProvider: IntegrationProviderGoogle,
    initialGroupIds: string[],
) {
    const firebaseProvider = betaTestingProvider as IntegrationProviderGoogle;
    const projectId = betaTesting.data?.projectId;
    const resourcesForProject =
        projectId ?
            firebaseProvider.data?.projectsResources?.find((info) => info.project.projectId === projectId)
        :   null;
    const availableBetaGroups = resourcesForProject?.availableBetaGroups ?? [];

    return {
        label: 'Default beta groups',
        name: 'selectedBetaGroupIds',
        fieldType: FieldType.Custom,
        initialValue: initialGroupIds,
        data: availableBetaGroups,
        renderField: (availableBetaGroups: FirebaseBetaGroup[]) => {
            return (
                <Select
                    allowClear
                    mode="multiple"
                    placeholder="Select default beta groups"
                    filterOption={filterOptionLabel}
                >
                    {availableBetaGroups?.map((group) => (
                        <Select.Option key={group.id} value={group.id} label={group.name}>
                            {group.name}
                        </Select.Option>
                    ))}
                </Select>
            );
        },
        rules: [{ required: true, message: 'Beta groups selection required' }],
    };
}

function generateAutoApplyReviewAttachmentsFields(
    baseField: FormFieldData,
    appId: string,
    orgId: string,
    currentlyUploadedReviewAttachment: FileStats,
    stepConfigId?: string,
) {
    const baseFieldWithFileIsUploadedValidation = {
        ...baseField,
        rules: [
            () => {
                return {
                    validator: (_, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }
                        if (currentlyUploadedReviewAttachment) {
                            return Promise.resolve();
                        }
                        return Promise.reject('Review attachment is required');
                    },
                };
            },
        ],
    };

    return [
        baseFieldWithFileIsUploadedValidation,
        {
            label: 'Review attachment',
            name: 'reviewAttachment',
            fieldType: FieldType.Custom,
            initialValue: null,
            rules: [],
            renderField: () => {
                return (
                    <DefaultReviewAttachmentUpload
                        appId={appId}
                        orgId={orgId}
                        stepConfigId={stepConfigId}
                        currentlyUploadedReviewAttachment={currentlyUploadedReviewAttachment}
                    />
                );
            },
        },
    ];
}

// The steps each release type waits for, for the release types the automation runs on, or all of them
const RequiredStepsInput: React.FC<{
    appId: string;
    platform: AppPlatform;
    appStoreType: AppStoreType;
    value?: Partial<Record<ReleaseTypesForNonBlockingSteps, string[]>>;
    onChange?: (value: Partial<Record<ReleaseTypesForNonBlockingSteps, string[]>>) => void;
}> = ({ appId, platform, appStoreType, value, onChange }) => {
    const selectedReleaseTypes: ReleaseTypesForNonBlockingSteps[] | undefined = Form.useWatch('primaryReleaseTypes');
    const releaseTypes =
        selectedReleaseTypes?.length ? selectedReleaseTypes : (
            [ReleaseTypesForNonBlockingSteps.Standard, ReleaseTypesForNonBlockingSteps.Hotfix]
        );

    return (
        <Flex vertical gap={16}>
            {releaseTypes.map((releaseType) => (
                <Flex key={releaseType} vertical gap={6}>
                    <Text>{`${capitalizeFirstLetter(releaseType)} releases`}</Text>
                    <BlockingStepsSelector
                        appId={appId}
                        platform={platform}
                        appStoreType={appStoreType}
                        releaseType={releaseType}
                        value={value?.[releaseType]}
                        onChange={(steps) => onChange?.({ ...value, [releaseType]: steps })}
                    />
                </Flex>
            ))}
        </Flex>
    );
};

const TRANSITION_MILESTONE_SELECT_WIDTH = 240;

interface MilestoneStatusesRow {
    milestone?: ReleaseMilestone;
    statuses?: string[];
}

// Rows are kept locally, since one without a milestone yet has no key in the saved map
const MilestoneStatusesInput: React.FC<{
    statusOptions: SettingOption[];
    value?: Partial<Record<ReleaseMilestone, string[]>>;
    onChange?: (value: Partial<Record<ReleaseMilestone, string[]>>) => void;
}> = ({ statusOptions, value, onChange }) => {
    const [rows, setRows] = React.useState<MilestoneStatusesRow[]>(() => {
        const savedRows = allReleaseMilestones
            .filter((milestone) => value?.[milestone])
            .map((milestone) => ({ milestone, statuses: value?.[milestone] }));
        return savedRows.length ? savedRows : [{ milestone: ReleaseMilestone.ReleaseCompleted }];
    });

    // A milestone without statuses is still sent, so the backend asks for them instead of silently dropping it
    const updateRows = (updatedRows: MilestoneStatusesRow[]) => {
        setRows(updatedRows);
        const statusesByMilestone: Partial<Record<ReleaseMilestone, string[]>> = {};
        for (const row of updatedRows) {
            if (row.milestone) {
                statusesByMilestone[row.milestone] = row.statuses ?? [];
            }
        }
        onChange?.(statusesByMilestone);
    };

    return (
        <Space direction="vertical" style={{ width: '100%' }} size={16}>
            {rows.map((row, index) => (
                <Space key={index} direction="vertical" size={8} style={{ width: '100%' }}>
                    <Row gutter={8} align="top" wrap={false} style={{ width: '100%' }}>
                        <Col flex="none">
                            <div style={{ lineHeight: '32px', color: runwayColors.darkTextGrey }}>On</div>
                        </Col>
                        <Col flex={`0 0 ${TRANSITION_MILESTONE_SELECT_WIDTH}px`}>
                            <Select
                                placeholder="Select milestone"
                                popupMatchSelectWidth={false}
                                style={{ width: '100%' }}
                                value={row.milestone}
                                onChange={(milestone: ReleaseMilestone) =>
                                    updateRows(
                                        rows.map((otherRow, otherIndex) =>
                                            otherIndex === index ? { ...otherRow, milestone } : otherRow,
                                        ),
                                    )
                                }
                            >
                                {allReleaseMilestones.map((milestone) => (
                                    <Select.Option
                                        value={milestone}
                                        key={milestone}
                                        disabled={rows.some(
                                            (otherRow, otherIndex) =>
                                                otherIndex !== index && otherRow.milestone === milestone,
                                        )}
                                    >
                                        {releaseMilestoneLabels[milestone]}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col flex="none">
                            <div style={{ lineHeight: '32px', color: runwayColors.darkTextGrey, whiteSpace: 'nowrap' }}>
                                update to
                            </div>
                        </Col>
                        <Col flex="auto" style={{ minWidth: 0 }}>
                            <Select
                                mode="multiple"
                                placeholder="Select statuses"
                                filterOption={filterOptionLabel}
                                style={{ width: '100%' }}
                                showSearch
                                value={row.statuses}
                                onChange={(statuses: string[]) =>
                                    updateRows(
                                        rows.map((otherRow, otherIndex) =>
                                            otherIndex === index ? { ...otherRow, statuses } : otherRow,
                                        ),
                                    )
                                }
                                options={statusOptions.map((option) => ({
                                    value: option.value,
                                    label: option.label,
                                }))}
                            />
                        </Col>
                        <Col flex="none">
                            <Button
                                icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                danger
                                type="link"
                                onClick={() => updateRows(rows.filter((_, otherIndex) => otherIndex !== index))}
                            />
                        </Col>
                    </Row>
                    {row.milestone === ReleaseMilestone.Kickoff && (
                        <Form.Item
                            name={TRANSITION_NEW_TICKETS_AFTER_KICKOFF_KEY}
                            valuePropName="checked"
                            style={{ marginBottom: 0 }}
                        >
                            <Checkbox>Also update status of new tickets added to the release after kickoff</Checkbox>
                        </Form.Item>
                    )}
                </Space>
            ))}
            {rows.length < allReleaseMilestones.length && (
                <Button
                    icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                    onClick={() => setRows([...rows, {}])}
                >
                    Add another status update
                </Button>
            )}
        </Space>
    );
};

function buildAutoReleaseAndAutoSubmitRequiredStepsFields(
    automation: AutomationAutoSubmitRelease | AutomationAutoRelease,
    appId: string,
    platform: AppPlatform,
    appStoreType: AppStoreType,
    config: {
        fieldKeyPrefix: string;
        submitStrategyFieldName: string | string[];
        shouldUseCustomRequiredStepsFieldName: string | string[];
        customRequiredStepsFieldNamePrefix: string[];
        releaseTypesFieldName: string | string[];
        shouldUseCustomRequiredStepsInitialValue?: boolean;
        customRequiredStepsInitialValue?: Record<ReleaseTypesForNonBlockingSteps, ReleaseStepType[]>;
    },
) {
    const hasSupportForRollbacks = automation.type === AutomationType.AutoSubmitRelease;
    const isStepConfigAutomation = !!automation.stepConfigId;
    if (!isStepConfigAutomation) {
        return [];
    }

    return [
        {
            name: `${config.fieldKeyPrefix}ToggleField`,
            fieldType: FieldType.Custom,
            skipFormItemWrapper: true,
            renderField: () => (
                <FormItem noStyle dependencies={[config.submitStrategyFieldName]}>
                    {(form) => {
                        const submitStrategy = form.getFieldValue(config.submitStrategyFieldName) as
                            | AutoSubmitStrategy
                            | undefined;
                        if (submitStrategy === AutoSubmitStrategy.AfterTargetDateEvenIfNotReady) {
                            return null;
                        }
                        return (
                            <FormItem
                                name={config.shouldUseCustomRequiredStepsFieldName}
                                valuePropName="checked"
                                initialValue={config.shouldUseCustomRequiredStepsInitialValue}
                                style={{ marginBottom: 10 }}
                            >
                                <Checkbox>Override default required steps</Checkbox>
                            </FormItem>
                        );
                    }}
                </FormItem>
            ),
        },
        {
            name: `${config.fieldKeyPrefix}ConfigField`,
            fieldType: FieldType.Custom,
            skipFormItemWrapper: true,
            renderField: () => (
                <FormItem
                    noStyle
                    dependencies={[
                        config.submitStrategyFieldName,
                        config.releaseTypesFieldName,
                        config.shouldUseCustomRequiredStepsFieldName,
                    ]}
                >
                    {(form) => {
                        const submitStrategy = form.getFieldValue(config.submitStrategyFieldName) as
                            | AutoSubmitStrategy
                            | undefined;
                        const shouldUseCustomRequiredSteps = form.getFieldValue(
                            config.shouldUseCustomRequiredStepsFieldName,
                        );

                        const releaseTypesForNonBlockingSteps = form.getFieldValue(
                            config.releaseTypesFieldName,
                        ) as ReleaseTypesForNonBlockingSteps[];

                        if (
                            !shouldUseCustomRequiredSteps ||
                            submitStrategy === AutoSubmitStrategy.AfterTargetDateEvenIfNotReady
                        ) {
                            return null;
                        }

                        const selectedReleaseTypes =
                            releaseTypesForNonBlockingSteps?.length ?
                                releaseTypesForNonBlockingSteps
                            :   [
                                    ReleaseTypesForNonBlockingSteps.Standard,
                                    ReleaseTypesForNonBlockingSteps.Hotfix,
                                    ...(hasSupportForRollbacks ? [ReleaseTypesForNonBlockingSteps.Rollback] : []),
                                ];

                        return selectedReleaseTypes.map((releaseType: ReleaseTypesForNonBlockingSteps) => (
                            <Flex vertical gap={6} style={{ marginBottom: 16 }}>
                                <FormItem
                                    key={releaseType}
                                    initialValue={config.customRequiredStepsInitialValue?.[releaseType] ?? []}
                                    label={`${capitalizeFirstLetter(releaseType)} releases`}
                                    name={[...config.customRequiredStepsFieldNamePrefix, releaseType]}
                                    style={{ marginBottom: 0 }}
                                    rules={[
                                        {
                                            validator: (_, value: ReleaseStepType[] | undefined) =>
                                                value && value.length > 0 ?
                                                    Promise.resolve()
                                                :   Promise.reject(new Error('Select at least one step')),
                                        },
                                    ]}
                                >
                                    <BlockingStepsSelector
                                        appId={appId}
                                        platform={platform}
                                        appStoreType={appStoreType}
                                        releaseType={releaseType}
                                    />
                                </FormItem>
                            </Flex>
                        ));
                    }}
                </FormItem>
            ),
        },
    ];
}
